const airports= [
{ code: "WKK", name: "Aleknagik - Aleknagik / New Airport" },
{ code: "HIR", name: "Honiara - Honiara International Airport" },
{ code: "MUA", name: "Munda - Munda Airport" },
{ code: "INU", name: "Yaren District - Nauru International Airport" },
{ code: "AXF", name: "Bayanhot - Alxa Left Banner Bayanhot Airport" },
{ code: "VMU", name: "Baimuru - Baimuru Airport" },
{ code: "BUA", name: "Buka Island - Buka Airport" },
{ code: "OPU", name: "Balimo - Balimo Airport" },
{ code: "CMU", name: "Kundiawa - Chimbu Airport" },
{ code: "DAU", name: "Daru - Daru Airport" },
{ code: "GKA", name: "Goronka - Goroka Airport" },
{ code: "GUR", name: "Gurney - Gurney Airport" },
{ code: "PNP", name: "Popondetta - Girua Airport" },
{ code: "HKN", name: "Kimbe - Hoskins Airport" },
{ code: "KMA", name: "Kerema - Kerema Airport" },
{ code: "KVG", name: "Kavieng - Kavieng Airport" },
{ code: "MAG", name: "Madang - Madang Airport" },
{ code: "HGU", name: "Mount Hagen - Mount Hagen Kagamuga Airport" },
{ code: "MDU", name: "Mendi - Mendi Airport" },
{ code: "MAS", name: "Manus Island - Momote Airport" },
{ code: "LAE", name: "Lae - Nadzab Airport" },
{ code: "POM", name: "Port Moresby - Port Moresby Jacksons International Airport" },
{ code: "RAB", name: "Kokopo - Tokua Airport" },
{ code: "VAI", name: "Vanimo - Vanimo Airport" },
{ code: "WBM", name: "Wapenamanda - Wapenamanda Airport" },
{ code: "WWK", name: "Wewak - Wewak International Airport" },
{ code: "ZXT", name: "Zabrat - Zabrat Airport" },
{ code: "BCW", name: "Benguera Island - Benguera Island Airport" },
{ code: "JAM", name: "Bezmer - Bezmer Air Base" },
{ code: "JEG", name: "Aasiaat - Aasiaat Airport" },
{ code: "UAK", name: "Narsarsuaq - Narsarsuaq Airport" },
{ code: "GOH", name: "Nuuk - Nuuk Airport" },
{ code: "JAV", name: "Ilulissat - Ilulissat Airport" },
{ code: "KUS", name: "Kulusuk - Kulusuk Airport" },
{ code: "SFJ", name: "Kangerlussuaq - Kangerlussuaq Airport" },
{ code: "JHS", name: "Sisimiut - Sisimiut Airport" },
{ code: "THU", name: "Pituffik - Pituffik Space Base" },
{ code: "AEY", name: "Akureyri - Akureyri Airport" },
{ code: "EGS", name: "EgilsstaÃ°ir - EgilsstaÃ°ir Airport" },
{ code: "HFN", name: "HÃ¶fn - HornafjÃ¶rÃ°ur Airport" },
{ code: "HZK", name: "HÃºsavÃ­k - HÃºsavÃ­k Airport" },
{ code: "IFJ", name: "ÃsafjÃ¶rÃ°ur - ÃsafjÃ¶rÃ°ur Airport" },
{ code: "KEF", name: "ReykjavÃ­k - Keflavik International Airport" },
{ code: "RKV", name: "ReykjavÃ­k - ReykjavÃ­k Domestic Airport" },
{ code: "SIJ", name: "SiglufjÃ¶rÃ°ur - SiglufjÃ¶rÃ°ur Airport" },
{ code: "VEY", name: "Vestmannaeyjar - Vestmannaeyjar Airport" },
{ code: "PRN", name: "Prishtina - PriÅ¡tina Adem Jashari International Airport" },
{ code: "VDC", name: "VitÃ³ria da Conquista - Glauber de Andrade Rocha Airport" },
{ code: "BTZ", name: "Betong - Betong International Airport" },
{ code: "TXC", name: "Orsha - Orsha Airport - Balbasovo Air Base" },
{ code: "CUK", name: "Caye Caulker - Caye Caulker Airport" },
{ code: "CYC", name: "Caye Chapel - Caye Chapel Airport" },
{ code: "CZH", name: "Corozal - Corozal Airport" },
{ code: "DGA", name: "Dangriga - Dangriga Airport" },
{ code: "PND", name: "Punta Gorda - Punta Gorda Airport" },
{ code: "SJX", name: "Sartaneja - Sartaneja Airport" },
{ code: "SPR", name: "San Pedro - John Greif II Airport" },
{ code: "TZA", name: "Belize City - Sir Barry Bowen Municipal Airport" },
{ code: "BZB", name: "Bazaruto Island - Bazaruto Island Airport" },
{ code: "YAA", name: "Anahim Lake - Anahim Lake Airport" },
{ code: "XQU", name: "Qualicum Beach - Qualicum Beach Airport" },
{ code: "YZA", name: "Cache Creek - Cache Creek-Ashcroft Regional Airport" },
{ code: "ZEL", name: "Bella Bella - Bella Bella (Campbell Island) Airport" },
{ code: "HSC", name: "Shaoguan - Shaoguan Danxia Airport" },
{ code: "JGS", name: "Ji'an - Jinggangshan Airport" },
{ code: "WHN", name: "Wuhan (Hannan) - Wuhan Hannan Municipal Airport" },
{ code: "NAY", name: "Beijing - Beijing Nanjiao Airport" },
{ code: "DDR", name: "XigazÃª (Dingri) - Rikaze Dingri Airport" },
{ code: "HQL", name: "Tashikuergan - Tashikuergan Hongqilafu Airport" },
{ code: "APJ", name: "Burang Town - Ali Pulan Airport" },
{ code: "BFY", name: "Bengbu - Bengbu Tenghu Airport (U.C.)" },
{ code: "YAG", name: "Fort Frances - Fort Frances Municipal Airport" },
{ code: "YAH", name: "La Grande-4 - La Grande-4 Airport" },
{ code: "YAM", name: "Sault Ste Marie - Sault Ste Marie Airport" },
{ code: "XKS", name: "Kasabonika - Kasabonika Airport" },
{ code: "YAY", name: "St. Anthony - St. Anthony Airport" },
{ code: "YAZ", name: "Tofino - Tofino / Long Beach Airport" },
{ code: "YBC", name: "Baie-Comeau - Baie-Comeau Airport" },
{ code: "QBC", name: "Bella Coola - Bella Coola Airport" },
{ code: "YBY", name: "Bonnyville - Bonnyville Airport" },
{ code: "YBG", name: "La Baie - CFB Bagotville / Saguenay-Bagotville Airport" },
{ code: "YBK", name: "Baker Lake - Baker Lake Airport" },
{ code: "YBL", name: "Campbell River - Campbell River Airport" },
{ code: "YBR", name: "Brandon - Brandon Municipal Airport" },
{ code: "YBX", name: "Blanc-Sablon - Lourdes-de-Blanc-Sablon Airport" },
{ code: "YCB", name: "Cambridge Bay - Cambridge Bay Airport" },
{ code: "YCC", name: "Cornwall - Cornwall Regional Airport" },
{ code: "YCD", name: "Nanaimo - Nanaimo Airport" },
{ code: "YCE", name: "Huron Park - Centralia / James T. Field Memorial Aerodrome" },
{ code: "YCG", name: "Castlegar - Castlegar/West Kootenay Regional Airport" },
{ code: "YCH", name: "Miramichi - Miramichi Airport" },
{ code: "YCL", name: "Charlo - Charlo Airport" },
{ code: "YCN", name: "Cochrane - Cochrane Airport" },
{ code: "YCQ", name: "Chetwynd - Chetwynd Airport" },
{ code: "YDA", name: "Dawson City - Dawson City Airport" },
{ code: "YDB", name: "Burwash Landing - Burwash Airport" },
{ code: "YDF", name: "Deer Lake - Deer Lake Airport" },
{ code: "XRR", name: "Ross River - Ross River Airport" },
{ code: "YDN", name: "Dauphin - Dauphin Barker Airport" },
{ code: "YDO", name: "Dolbeau-Saint-Felicien - Dolbeau-Saint-Felicien Airport" },
{ code: "YDQ", name: "Dawson Creek - Dawson Creek Airport" },
{ code: "YEG", name: "Edmonton - Edmonton International Airport" },
{ code: "YEL", name: "Elliot Lake - Elliot Lake Municipal Airport" },
{ code: "YEM", name: "Sheguiandah - Manitoulin East Municipal Airport" },
{ code: "YEN", name: "Estevan - Estevan Airport" },
{ code: "YET", name: "Edson - Edson Airport" },
{ code: "YEV", name: "Inuvik - Inuvik Mike Zubko Airport" },
{ code: "YEY", name: "Amos - Amos/Magny Airport" },
{ code: "YFB", name: "Iqaluit - Iqaluit Airport" },
{ code: "YFC", name: "Fredericton - Fredericton Airport" },
{ code: "YFE", name: "Forestville - Forestville Airport" },
{ code: "YTM", name: "La Macaza - Mont-Tremblant International Airport" },
{ code: "YFR", name: "Fort Resolution - Fort Resolution Airport" },
{ code: "YFS", name: "Fort Simpson - Fort Simpson Airport" },
{ code: "YGK", name: "Kingston - Kingston Norman Rogers Airport" },
{ code: "YGL", name: "La Grande RiviÃ¨re - La Grande RiviÃ¨re Airport" },
{ code: "YGM", name: "Gimli - Gimli Industrial Park Airport" },
{ code: "YGP", name: "GaspÃ© - Michel-Pouliot GaspÃ© Airport" },
{ code: "YGQ", name: "Geraldton - Geraldton Greenstone Regional Airport" },
{ code: "YGR", name: "Les ÃŽles-de-la-Madeleine - ÃŽles-de-la-Madeleine Airport" },
{ code: "YGV", name: "Havre-Saint-Pierre - Havre-Saint-Pierre Airport" },
{ code: "YGW", name: "Kuujjuarapik - Kuujjuarapik Airport" },
{ code: "YHD", name: "Dryden - Dryden Regional Airport" },
{ code: "YHF", name: "Hearst - Hearst RenÃ© Fontaine Municipal Airport" },
{ code: "YHM", name: "Hamilton - John C. Munro Hamilton International Airport" },
{ code: "YHN", name: "Hornepayne - Hornepayne Municipal Airport" },
{ code: "YHT", name: "Haines Junction - Haines Junction Airport" },
{ code: "YHU", name: "MontrÃ©al - MontrÃ©al / Saint-Hubert Metropolitan Airport" },
{ code: "YHY", name: "Hay River - Hay River / Merlyn Carter Airport" },
{ code: "YHZ", name: "Halifax - Halifax / Stanfield International Airport" },
{ code: "YIB", name: "Atikokan - Atikokan Municipal Airport" },
{ code: "YDG", name: "Digby - Digby / Annapolis Regional Airport" },
{ code: "YIF", name: "St-Augustin - St Augustin Airport" },
{ code: "YIV", name: "Island Lake - Island Lake Airport" },
{ code: "YJF", name: "Fort Liard - Fort Liard Airport" },
{ code: "YJN", name: "St Jean - St Jean Airport" },
{ code: "YJT", name: "Stephenville - Dymond Airport" },
{ code: "YKA", name: "Kamloops - Kamloops John Moose Fulton Field Regional Airport" },
{ code: "YKF", name: "Breslau - Region of Waterloo International Airport" },
{ code: "YKJ", name: "Key Lake - Key Lake Airport" },
{ code: "YKL", name: "Schefferville - Schefferville Airport" },
{ code: "YKD", name: "Kincardine - Kincardine Municipal Airport" },
{ code: "YKX", name: "Kirkland Lake - Kirkland Lake Airport" },
{ code: "YKY", name: "Kindersley - Kindersley Airport" },
{ code: "YLD", name: "Chapleau - Chapleau Airport" },
{ code: "YLJ", name: "Meadow Lake - Meadow Lake Airport" },
{ code: "YLL", name: "Lloydminster - Lloydminster Airport" },
{ code: "YLR", name: "Leaf Rapids - Leaf Rapids Airport" },
{ code: "YLK", name: "Barrie - Barrie-Lake Simcoe Regional Airport" },
{ code: "YLT", name: "Alert - Alert Airport" },
{ code: "YLW", name: "Kelowna - Kelowna International Airport" },
{ code: "YMA", name: "Mayo - Mayo Airport" },
{ code: "YME", name: "Matane - Matane Airport" },
{ code: "YMG", name: "Manitouwadge - Manitouwadge Airport" },
{ code: "YMJ", name: "Moose Jaw - Moose Jaw Air Vice Marshal C. M. McEwen Airport" },
{ code: "YML", name: "Charlevoix - Charlevoix Airport" },
{ code: "YMM", name: "Fort McMurray - Fort McMurray Airport" },
{ code: "YMO", name: "Moosonee - Moosonee Airport" },
{ code: "YMT", name: "Chibougamau - Chapais Airport" },
{ code: "YMX", name: "MontrÃ©al - Montreal International (Mirabel) Airport" },
{ code: "YNA", name: "Natashquan - Natashquan Airport" },
{ code: "YND", name: "Gatineau - Ottawa / Gatineau Airport" },
{ code: "YLY", name: "Langley - Langley Airport" },
{ code: "YNL", name: "Points North Landing - Points North Landing Airport" },
{ code: "YNM", name: "Matagami - Matagami Airport" },
{ code: "YOA", name: "Ekati - Ekati Airport" },
{ code: "YOD", name: "Cold Lake - CFB Cold Lake" },
{ code: "YOJ", name: "High Level - High Level Airport" },
{ code: "YOO", name: "Oshawa - Oshawa Executive Airport" },
{ code: "YOP", name: "Rainbow Lake - Rainbow Lake Airport" },
{ code: "YOS", name: "Owen Sound - Owen Sound / Billy Bishop Regional Airport" },
{ code: "YOW", name: "Ottawa - Ottawa Macdonald-Cartier International Airport" },
{ code: "YPA", name: "Prince Albert - Prince Albert Glass Field" },
{ code: "YPS", name: "Port Hawkesbury - Port Hawkesbury Airport" },
{ code: "YPE", name: "Peace River - Peace River Airport" },
{ code: "YPG", name: "Portage la Prairie - Portage-la-Prairie / Southport Airport" },
{ code: "YPL", name: "Pickle Lake - Pickle Lake Airport" },
{ code: "YPN", name: "Port-Menier - Port-Menier Airport" },
{ code: "YPQ", name: "Peterborough - Peterborough Municipal Airport" },
{ code: "YPR", name: "Prince Rupert - Prince Rupert Airport" },
{ code: "YPW", name: "Powell River - Powell River Airport" },
{ code: "YPX", name: "Puvirnituq - Puvirnituq Airport" },
{ code: "YPY", name: "Fort Chipewyan - Fort Chipewyan Airport" },
{ code: "YPZ", name: "Burns Lake - Burns Lake Airport" },
{ code: "YQA", name: "Gravenhurst - Muskoka Airport" },
{ code: "YQB", name: "Quebec - Quebec Jean Lesage International Airport" },
{ code: "YQD", name: "The Pas - The Pas Airport" },
{ code: "YQF", name: "Springbrook - Red Deer Regional Airport" },
{ code: "YQG", name: "Windsor - Windsor Airport" },
{ code: "YQH", name: "Watson Lake - Watson Lake Airport" },
{ code: "YQI", name: "Yarmouth - Yarmouth Airport" },
{ code: "YQK", name: "Kenora - Kenora Airport" },
{ code: "YQL", name: "Lethbridge - Lethbridge County Airport" },
{ code: "YQM", name: "Moncton - Greater Moncton RomÃ©o LeBlanc International Airport" },
{ code: "YQN", name: "Nakina - Nakina Airport" },
{ code: "YQQ", name: "Comox - Comox Valley Airport / CFB Comox" },
{ code: "YQR", name: "Regina - Regina International Airport" },
{ code: "YQS", name: "St Thomas - St Thomas Municipal Airport" },
{ code: "YQT", name: "Thunder Bay - Thunder Bay Airport" },
{ code: "YQU", name: "Grande Prairie - Grande Prairie Airport" },
{ code: "YQV", name: "Yorkton - Yorkton Municipal Airport" },
{ code: "YQW", name: "North Battleford - North Battleford Airport" },
{ code: "YQX", name: "Gander - Gander International Airport / CFB Gander" },
{ code: "YQY", name: "Sydney - Sydney / J.A. Douglas McCurdy Airport" },
{ code: "YQZ", name: "Quesnel - Quesnel Airport" },
{ code: "YRB", name: "Resolute Bay - Resolute Bay Airport" },
{ code: "YRI", name: "RiviÃ¨re-du-Loup - RiviÃ¨re-du-Loup Airport" },
{ code: "YRJ", name: "Roberval - Roberval Airport" },
{ code: "YRL", name: "Red Lake - Red Lake Airport" },
{ code: "YRO", name: "Ottawa - Ottawa / Rockcliffe Airport" },
{ code: "YRQ", name: "Trois-RiviÃ¨res - Trois-RiviÃ¨res Airport" },
{ code: "YRT", name: "Rankin Inlet - Rankin Inlet Airport" },
{ code: "YRV", name: "Revelstoke - Revelstoke Airport" },
{ code: "YSB", name: "Sudbury - Sudbury Airport" },
{ code: "YSC", name: "Sherbrooke - Sherbrooke Airport" },
{ code: "YSF", name: "Stony Rapids - Stony Rapids Airport" },
{ code: "YSH", name: "Smiths Falls - Smiths Falls-Montague (Russ Beach) Airport" },
{ code: "YSJ", name: "Saint John - Saint John Airport" },
{ code: "YSL", name: "Saint-LÃ©onard - Saint-LÃ©onard Airport" },
{ code: "YSM", name: "Fort Smith - Fort Smith Airport" },
{ code: "YCM", name: "Niagara-on-the-Lake - Niagara District Airport" },
{ code: "YSP", name: "Marathon - Marathon Airport" },
{ code: "YSU", name: "Slemon Park - Summerside Airport" },
{ code: "YTA", name: "Pembroke - Pembroke Airport" },
{ code: "YTF", name: "Alma - Alma Airport" },
{ code: "YTH", name: "Thompson - Thompson Airport" },
{ code: "YTR", name: "Trenton - CFB Trenton" },
{ code: "YTS", name: "Timmins - Timmins/Victor M. Power" },
{ code: "YTZ", name: "Toronto - Billy Bishop Toronto City Centre Airport" },
{ code: "YUL", name: "MontrÃ©al - Montreal / Pierre Elliott Trudeau International Airport" },
{ code: "YUX", name: "Sanirajak - Hall Beach Airport" },
{ code: "YUY", name: "Rouyn-Noranda - Rouyn Noranda Airport" },
{ code: "YVB", name: "Bonaventure - Bonaventure Airport" },
{ code: "YVC", name: "La Ronge - La Ronge Airport" },
{ code: "YVE", name: "Vernon - Vernon Regional Airport" },
{ code: "YVO", name: "Val-d'Or - Val-d'Or Airport" },
{ code: "YVP", name: "Kuujjuaq - Kuujjuaq Airport" },
{ code: "YVQ", name: "Norman Wells - Norman Wells Airport" },
{ code: "YVR", name: "Vancouver - Vancouver International Airport" },
{ code: "YVV", name: "Wiarton - Wiarton Airport" },
{ code: "YWG", name: "Winnipeg - Winnipeg / James Armstrong Richardson International Airport" },
{ code: "YWK", name: "Wabush - Wabush Airport" },
{ code: "YWL", name: "Williams Lake - Williams Lake Airport" },
{ code: "YWY", name: "Wrigley - Wrigley Airport" },
{ code: "YXC", name: "Cranbrook - Cranbrook/Canadian Rockies International Airport" },
{ code: "YXE", name: "Saskatoon - Saskatoon John G. Diefenbaker International Airport" },
{ code: "YXH", name: "Medicine Hat - Medicine Hat Regional Airport" },
{ code: "YXJ", name: "Fort Saint John - Fort St John / North Peace Regional Airport" },
{ code: "YXK", name: "Rimouski - Rimouski Airport" },
{ code: "YXL", name: "Sioux Lookout - Sioux Lookout Airport" },
{ code: "YXQ", name: "Beaver Creek - Beaver Creek Airport" },
{ code: "YXR", name: "Earlton - Earlton (Timiskaming Regional) Airport" },
{ code: "YXS", name: "Prince George - Prince George Airport" },
{ code: "YXT", name: "Terrace - Northwest Regional Airport Terrace-Kitimat" },
{ code: "YXU", name: "London - London Airport" },
{ code: "YXX", name: "Abbotsford - Abbotsford International Airport" },
{ code: "YXY", name: "Whitehorse - Whitehorse / Erik Nielsen International Airport" },
{ code: "YXZ", name: "Wawa - Wawa Airport" },
{ code: "YYB", name: "North Bay - North Bay Jack Garland Airport" },
{ code: "YYC", name: "Calgary - Calgary International Airport" },
{ code: "YYD", name: "Smithers - Smithers Airport" },
{ code: "YYE", name: "Fort Nelson - Fort Nelson Airport" },
{ code: "YYF", name: "Penticton - Penticton Airport" },
{ code: "YYG", name: "Charlottetown - Charlottetown Airport" },
{ code: "YYJ", name: "Victoria - Victoria International Airport" },
{ code: "YYL", name: "Lynn Lake - Lynn Lake Airport" },
{ code: "YYN", name: "Swift Current - Swift Current Airport" },
{ code: "YYQ", name: "Churchill - Churchill Airport" },
{ code: "YYR", name: "Goose Bay - Goose Bay Airport" },
{ code: "YYT", name: "St. John's - St. John's International Airport" },
{ code: "YYU", name: "Kapuskasing - Kapuskasing Airport" },
{ code: "YYW", name: "Armstrong - Armstrong Airport" },
{ code: "YYY", name: "Mont-Joli - Mont Joli Airport" },
{ code: "YYZ", name: "Toronto - Toronto Lester B. Pearson International Airport" },
{ code: "YZE", name: "Gore Bay - Gore Bay Manitoulin Airport" },
{ code: "YZF", name: "Yellowknife - Yellowknife International Airport" },
{ code: "YZH", name: "Slave Lake - Slave Lake Airport" },
{ code: "YZP", name: "Sandspit - Sandspit Airport" },
{ code: "YZR", name: "Sarnia - Chris Hadfield Airport" },
{ code: "YZS", name: "Coral Harbour - Coral Harbour Airport" },
{ code: "YZT", name: "Port Hardy - Port Hardy Airport" },
{ code: "YZU", name: "Whitecourt - Whitecourt Airport" },
{ code: "YZV", name: "Sept-ÃŽles - Sept-ÃŽles Airport" },
{ code: "YZW", name: "Teslin - Teslin Airport" },
{ code: "YZX", name: "Greenwood - CFB Greenwood" },
{ code: "YSN", name: "Salmon Arm - Shuswap Regional Airport" },
{ code: "YDT", name: "Delta - Boundary Bay Airport" },
{ code: "ZBF", name: "South Tetagouche - Bathurst Airport" },
{ code: "ZBM", name: "Bromont - Bromont (Roland DÃ©sourdy) Airport" },
{ code: "KES", name: "Kelsey - Kelsey Airport" },
{ code: "ZFA", name: "Faro - Faro Airport" },
{ code: "ZGF", name: "Grand Forks - Grand Forks Airport" },
{ code: "ZJG", name: "Jenpeg - Jenpeg Airport" },
{ code: "ZJN", name: "Swan River - Swan River Airport" },
{ code: "YTD", name: "Thicket Portage - Thicket Portage Airport" },
{ code: "PIW", name: "Pikwitonei - Pikwitonei Airport" },
{ code: "ZMT", name: "Masset - Masset Airport" },
{ code: "WPC", name: "Pincher Creek - Pincher Creek Airport" },
{ code: "ZSJ", name: "Sandy Lake - Sandy Lake Airport" },
{ code: "ZST", name: "Stewart - Stewart Airport" },
{ code: "ZUC", name: "Ignace - Ignace Municipal Airport" },
{ code: "BUJ", name: "Ouled Sidi Brahim - Bou Saada Airport" },
{ code: "BJA", name: "BÃ©jaÃ¯a - Soummamâ€“Abane Ramdane Airport" },
{ code: "ALG", name: "Algiers - Houari Boumediene Airport" },
{ code: "DJG", name: "Djanet - Djanet Inedbirene Airport" },
{ code: "VVZ", name: "Illizi - Illizi Takhamalt Airport" },
{ code: "QSF", name: "SÃ©tif - Ain Arnat Airport" },
{ code: "TMR", name: "Tamanrasset - Aguenar â€“ Hadj Bey Akhamok Airport" },
{ code: "GJL", name: "Tahir - Jijel Ferhat Abbas Airport" },
{ code: "MZW", name: "Mecheria - Mecheria Airport" },
{ code: "AAE", name: "Annaba - Annaba Rabah Bitat Airport" },
{ code: "CZL", name: "Constantine - Mohamed Boudiaf International Airport" },
{ code: "TEE", name: "TÃ©bessi - Cheikh Larbi TÃ©bessi Airport" },
{ code: "BLJ", name: "Batna - Batna Mostefa Ben Boulaid Airport" },
{ code: "HRM", name: "Hassi R'Mel - Hassi R'Mel Airport" },
{ code: "TID", name: "Tiaret - Abdelhafid Boussouf Bou Chekif Airport" },
{ code: "TIN", name: "Tindouf - Tindouf Airport" },
{ code: "CFK", name: "Chlef - Chlef Aboubakr Belkaid International Airport" },
{ code: "TAF", name: "Tafraoui - Oran Tafraoui Airport" },
{ code: "TLM", name: "Zenata - Zenata â€“ Messali El Hadj Airport" },
{ code: "ORN", name: "Es-SÃ©nia - Oran Es-SÃ©nia (Ahmed Ben Bella) International Airport" },
{ code: "CBH", name: "BÃ©char - BÃ©char Boudghene Ben Ali Lotfi Airport" },
{ code: "MUW", name: "Ghriss - Ghriss Airport" },
{ code: "AZR", name: "Adrar - Touat Cheikh Sidi Mohamed Belkebir Airport" },
{ code: "BSK", name: "Biskra - Biskra - Mohamed Khider Airport" },
{ code: "ELG", name: "El Menia - El Golea Airport" },
{ code: "GHA", name: "El Atteuf - NoumÃ©rat - Moufdi Zakaria Airport" },
{ code: "HME", name: "Hassi Messaoud - Hassi Messaoud-Oued Irara Krim Belkacem Airport" },
{ code: "INZ", name: "In Salah - In Salah Airport" },
{ code: "TGR", name: "Touggourt - Touggourt Sidi Madhi Airport" },
{ code: "LOO", name: "Laghouat - Laghouat - Molay Ahmed Medeghri Airport" },
{ code: "ELU", name: "Guemar - Guemar Airport - Ù…Ø·Ø§Ø± Ù‚Ù…Ø§Ø± Ø¨Ø§Ù„ÙˆØ§Ø¯ÙŠ" },
{ code: "TMX", name: "Timimoun - Timimoun Airport" },
{ code: "OGX", name: "Ouargla - Ain Beida Airport" },
{ code: "IAM", name: "In AmÃ©nas - Zarzaitine - In AmÃ©nas Airport" },
{ code: "COO", name: "Cotonou - Cadjehoun Airport" },
{ code: "OUA", name: "Ouagadougou - Ouagadougou Airport" },
{ code: "BOY", name: "Bobo Dioulasso - Bobo Dioulasso Airport" },
{ code: "ACC", name: "Accra - Kotoka International Airport" },
{ code: "TML", name: "Tamale - Tamale Airport" },
{ code: "KMS", name: "Kumasi - Kumasi Airport" },
{ code: "NYI", name: "Sunyani - Sunyani Airport" },
{ code: "TKD", name: "Sekondi-Takoradi - Takoradi Airport" },
{ code: "ABJ", name: "Abidjan - FÃ©lix-HouphouÃ«t-Boigny International Airport" },
{ code: "BYK", name: "BouakÃ© - BouakÃ© Airport" },
{ code: "DJO", name: " - Daloa Airport" },
{ code: "HGO", name: "Korhogo - Korhogo Airport" },
{ code: "MJC", name: " - Man Airport" },
{ code: "SPY", name: " - San Pedro Airport" },
{ code: "ASK", name: "Yamoussoukro - Yamoussoukro Airport" },
{ code: "ABV", name: "Abuja - Nnamdi Azikiwe International Airport" },
{ code: "QUO", name: "Uyo - Akwa Ibom International Airport" },
{ code: "AKR", name: "Akure - Akure Airport" },
{ code: "ABB", name: "Asaba - Asaba International Airport" },
{ code: "BCU", name: "Bauchi - Sir Abubakar Tafawa Balewa International Airport" },
{ code: "BNI", name: "Benin - Benin Airport" },
{ code: "CBQ", name: "Calabar - Margaret Ekpo International Airport" },
{ code: "ENU", name: "Enegu - Akanu Ibiam International Airport" },
{ code: "GMO", name: "Gombe - Gombe Lawanti International Airport" },
{ code: "IBA", name: "Ibadan - Ibadan Airport" },
{ code: "ILR", name: "Ilorin - Ilorin International Airport" },
{ code: "QOW", name: "Owerri - Sam Mbakwe International Airport" },
{ code: "JOS", name: "Jos - Yakubu Gowon Airport" },
{ code: "KAD", name: "Kaduna - Kaduna Airport" },
{ code: "KAN", name: "Kano - Mallam Aminu International Airport" },
{ code: "MIU", name: "Maiduguri - Maiduguri International Airport" },
{ code: "MDI", name: "Makurdi - Makurdi Airport" },
{ code: "LOS", name: "Lagos - Murtala Muhammed International Airport" },
{ code: "MXJ", name: "Minna - Minna Airport" },
{ code: "PHC", name: "Port Harcourt - Port Harcourt International Airport" },
{ code: "SKO", name: "Sokoto - Sadiq Abubakar III International Airport" },
{ code: "QRW", name: "Okpe - Warri Airport" },
{ code: "YOL", name: "Yola - Yola Airport" },
{ code: "ZAR", name: "Zaria - Zaria Airport" },
{ code: "MFQ", name: "Maradi - Maradi Airport" },
{ code: "NIM", name: "Niamey - Diori Hamani International Airport" },
{ code: "THZ", name: "Tahoua - Tahoua Airport" },
{ code: "AJY", name: "Agadez - Mano Dayak International Airport" },
{ code: "ZND", name: "Zinder - Zinder Airport" },
{ code: "TBJ", name: "Tabarka - Tabarka-AÃ¯n Draham International Airport" },
{ code: "MIR", name: "Monastir - Monastir Habib Bourguiba International Airport" },
{ code: "NBE", name: "Enfidha - Enfidha - Hammamet International Airport" },
{ code: "TUN", name: "Tunis - Tunis Carthage International Airport" },
{ code: "GAF", name: "Gafsa - Gafsa Ksar International Airport" },
{ code: "GAE", name: "GabÃ¨s - GabÃ¨s Matmata International Airport" },
{ code: "DJE", name: "Mellita - Djerba Zarzis International Airport" },
{ code: "EBM", name: "El Borma - El Borma Airport" },
{ code: "SFA", name: "Sfax - Sfax Thyna International Airport" },
{ code: "TOE", name: "Tozeur - Tozeur Nefta International Airport" },
{ code: "LRL", name: "Niamtougou - Niamtougou International Airport" },
{ code: "LFW", name: "LomÃ© - LomÃ©â€“Tokoin International Airport" },
{ code: "ANR", name: "Antwerp - Antwerp International Airport (Deurne)" },
{ code: "BRU", name: "Zaventem - Brussels Airport" },
{ code: "CRL", name: "Charleroi - Brussels South Charleroi Airport" },
{ code: "KJK", name: "Wevelgem - Flanders International Airport Kortrijk-Wevelgem" },
{ code: "LGG", name: "GrÃ¢ce-Hollogne - LiÃ¨ge Airport" },
{ code: "OST", name: "Oostende - Oostende-Brugge International Airport" },
{ code: "AOC", name: "Nobitz - Leipzigâ€“Altenburg Airport" },
{ code: "HDF", name: "Zirchow - Heringsdorf Airport" },
{ code: "FNB", name: "Trollenhagen - Neubrandenburg Trollenhagen Airport" },
{ code: "BER", name: "Berlin - Berlin Brandenburg Airport" },
{ code: "DRS", name: "Dresden - Dresden Airport" },
{ code: "ERF", name: "Erfurt - Erfurt-Weimar Airport" },
{ code: "FRA", name: "Frankfurt am Main - Frankfurt Airport" },
{ code: "FMO", name: "Greven - MÃ¼nster OsnabrÃ¼ck Airport" },
{ code: "HAM", name: "Hamburg - Hamburg Helmut Schmidt Airport" },
{ code: "CGN", name: "KÃ¶ln (Cologne) - Cologne Bonn Airport" },
{ code: "DUS", name: "DÃ¼sseldorf - DÃ¼sseldorf Airport" },
{ code: "MUC", name: "Munich - Munich Airport" },
{ code: "NUE", name: "Nuremberg - Nuremberg Airport" },
{ code: "LEJ", name: "Schkeuditz - Leipzig/Halle Airport" },
{ code: "SCN", name: "SaarbrÃ¼cken - SaarbrÃ¼cken Airport" },
{ code: "STR", name: "Stuttgart - Stuttgart Airport" },
{ code: "HAJ", name: "Hannover - Hannover Airport" },
{ code: "BRE", name: "Bremen - Bremen Airport" },
{ code: "HHN", name: "Frankfurt am Main (Lautzenhausen) - Frankfurt-Hahn Airport" },
{ code: "MHG", name: "Mannheim - Mannheim-City Airport" },
{ code: "EIB", name: "HÃ¶rselberg-Hainich - Eisenach-Kindel Airport" },
{ code: "SGE", name: "Burbach - Siegerland Airport" },
{ code: "XFW", name: "Hamburg - Hamburg-Finkenwerder Airport" },
{ code: "KEL", name: "Kiel - Kiel-Holtenau Airport" },
{ code: "LBC", name: "LÃ¼beck - LÃ¼beck Blankensee Airport" },
{ code: "FMM", name: "Memmingen - Memmingen Allgau Airport" },
{ code: "MGL", name: "MÃ¶nchengladbach - MÃ¶nchengladbach Airport" },
{ code: "PAD", name: "BÃ¼ren - Paderborn Lippstadt Airport" },
{ code: "NRN", name: "Weeze - Weeze Airport" },
{ code: "DTM", name: "Dortmund - Dortmund Airport" },
{ code: "AGB", name: "Augsburg - Augsburg Airport" },
{ code: "OBF", name: "WeÃŸling - Oberpfaffenhofen Airport" },
{ code: "FDH", name: "Friedrichshafen - Friedrichshafen Airport" },
{ code: "BYU", name: "Bindlach - Bayreuth Airport" },
{ code: "HOQ", name: "Hof - Hof-Plauen Airport" },
{ code: "FKB", name: "RheinmÃ¼nster - Karlsruhe Baden-Baden Airport" },
{ code: "LHA", name: "Lahr/Schwarzwald - Lahr Airport" },
{ code: "BWE", name: "Braunschweig - Braunschweig-Wolfsburg Airport" },
{ code: "KSF", name: "Calden - Kassel Airport" },
{ code: "GWT", name: "Sylt - Westerland Sylt Airport" },
{ code: "KDL", name: "KÃ¤rdla - KÃ¤rdla Airport" },
{ code: "URE", name: "Kuressaare - Kuressaare Airport" },
{ code: "EPU", name: "PÃ¤rnu - PÃ¤rnu Airport" },
{ code: "EES", name: "Berenice Troglodytica - Berenice International Airport / Banas Cape Air Base" },
{ code: "TLL", name: "Tallinn - Lennart Meri Tallinn Airport" },
{ code: "TAY", name: "Reola - Tartu Airport" },
{ code: "ENF", name: "Enontekio - Enontekio Airport" },
{ code: "KEV", name: "JÃ¤msÃ¤ - Halli Airport" },
{ code: "HEL", name: "Helsinki (Vantaa) - Helsinki Vantaa Airport" },
{ code: "KTQ", name: "Kitee - Kitee Airport" },
{ code: "IVL", name: "Ivalo - Ivalo Airport" },
{ code: "JOE", name: "Joensuu - Joensuu Airport" },
{ code: "JYV", name: "JyvÃ¤skylÃ¤n Maalaiskunta - JyvÃ¤skylÃ¤ Airport" },
{ code: "KAU", name: "Kauhava - Kauhava Airfield" },
{ code: "KEM", name: "Kemi / Tornio - Kemi-Tornio Airport" },
{ code: "KAJ", name: "Kajaani - Kajaani Airport" },
{ code: "KHJ", name: "Kauhajoki - Kauhajoki Airfield" },
{ code: "KOK", name: "Kokkola / Kruunupyy - Kokkola-Pietarsaari Airport" },
{ code: "KAO", name: "Kuusamo - Kuusamo Airport" },
{ code: "KTT", name: "KittilÃ¤ - KittilÃ¤ Airport" },
{ code: "KUO", name: "Kuopio / SiilinjÃ¤rvi - Kuopio Airport" },
{ code: "LPP", name: "Lappeenranta - Lappeenranta Airport" },
{ code: "MHQ", name: "Mariehamn - Mariehamn Airport" },
{ code: "MIK", name: "Mikkeli - Mikkeli Airport" },
{ code: "OUL", name: "Oulu / Oulunsalo - Oulu Airport" },
{ code: "POR", name: "Pori - Pori Airport" },
{ code: "RVN", name: "Rovaniemi - Rovaniemi Airport" },
{ code: "SVL", name: "Savonlinna - Savonlinna Airport" },
{ code: "SJY", name: "SeinÃ¤joki / Ilmajoki - SeinÃ¤joki Airport" },
{ code: "SOT", name: "Sodankyla - Sodankyla Airport" },
{ code: "TMP", name: "Tampere / Pirkkala - Tampere-Pirkkala Airport" },
{ code: "TKU", name: "Turku - Turku Airport" },
{ code: "UTI", name: "Utti / Valkeala - Utti Air Base" },
{ code: "VAA", name: "Vaasa - Vaasa Airport" },
{ code: "VRK", name: "Varkaus / Joroinen - Varkaus Airport" },
{ code: "YLI", name: "Ylivieska - Ylivieska Airfield" },
{ code: "BFS", name: "Belfast - Belfast International Airport" },
{ code: "ENK", name: "Enniskillen, Fermanagh and Omagh - Enniskillen/St Angelo Airport" },
{ code: "BHD", name: "Belfast - George Best Belfast City Airport" },
{ code: "LDY", name: "Derry - City of Derry Airport" },
{ code: "BHX", name: "Birmingham, West Midlands - Birmingham Airport" },
{ code: "CVT", name: "Coventry, West Midlands - Coventry Airport" },
{ code: "GLO", name: "Staverton - Gloucestershire Airport" },
{ code: "NQT", name: "Nottingham - Nottingham City Airport" },
{ code: "MAN", name: "Manchester, Greater Manchester - Manchester Airport" },
{ code: "YEO", name: "Yeovil, Somerset - RNAS Yeovilton" },
{ code: "CAL", name: "Campbeltown - Campbeltown Airport" },
{ code: "EOI", name: "Eday - Eday Airport" },
{ code: "HAW", name: "Haverfordwest - Haverfordwest Airport" },
{ code: "CWL", name: "Cardiff - Cardiff International Airport" },
{ code: "SWS", name: "Swansea - Swansea Airport" },
{ code: "BRS", name: "Bristol - Bristol Airport" },
{ code: "LPL", name: "Liverpool - Liverpool John Lennon Airport" },
{ code: "LTN", name: "Luton, Bedfordshire - London Luton Airport" },
{ code: "BOH", name: "Bournemouth - Bournemouth Airport" },
{ code: "SOU", name: "Southampton - Southampton Airport" },
{ code: "NQY", name: "Newquay - Cornwall Airport Newquay" },
{ code: "ACI", name: "Saint Anne - Alderney Airport" },
{ code: "GCI", name: "Saint Peter Port - Guernsey Airport" },
{ code: "JER", name: "Saint Helier - Jersey Airport" },
{ code: "ESH", name: "Brighton, East Sussex - Brighton City Airport" },
{ code: "BQH", name: "London - London Biggin Hill Airport" },
{ code: "LGW", name: "London - London Gatwick Airport" },
{ code: "LCY", name: "London - London City Airport" },
{ code: "FAB", name: "Farnborough, Hampshire - Farnborough Airport" },
{ code: "BBS", name: "Camberley, Surrey - Blackbushe Airport" },
{ code: "LHR", name: "London - London Heathrow Airport" },
{ code: "SEN", name: "Southend-on-Sea, Essex - London Southend Airport" },
{ code: "LYX", name: "Romney Marsh, Kent - Lydd London Ashford Airport" },
{ code: "CAX", name: "Carlisle, Cumbria - Carlisle Lake District Airport" },
{ code: "BLK", name: "Blackpool - Blackpool Airport" },
{ code: "HUY", name: "Grimsby, Lincolnshire - Humberside Airport" },
{ code: "BWF", name: "Barrow-in-Furness - Barrow Walney Island Airport" },
{ code: "LBA", name: "Leeds, West Yorkshire - Leeds Bradford Airport" },
{ code: "WRT", name: "Warton - Warton Aerodrome" },
{ code: "CEG", name: "Broughton - Hawarden Airport" },
{ code: "IOM", name: "Castletown - Isle of Man Airport" },
{ code: "NCL", name: "Newcastle upon Tyne, Tyne and Wear - Newcastle International Airport" },
{ code: "MME", name: "Darlington, Durham - Teesside International Airport" },
{ code: "EMA", name: "Nottingham - East Midlands Airport" },
{ code: "VLY", name: "Angelsey - Anglesey Airport" },
{ code: "KOI", name: "Orkney Islands - Kirkwall Airport" },
{ code: "LSI", name: "Lerwick, Shetland - Sumburgh Airport" },
{ code: "WIC", name: "Wick - Wick John O'Groats Airport" },
{ code: "ABZ", name: "Aberdeen - Aberdeen International Airport" },
{ code: "INV", name: "Inverness - Inverness Airport" },
{ code: "GLA", name: "Glasgow - Glasgow Airport" },
{ code: "EDI", name: "Edinburgh - Edinburgh Airport" },
{ code: "ILY", name: "Isle of Islay, Argyll and Bute - Islay Airport" },
{ code: "PIK", name: "Prestwick, South Ayrshire - Glasgow Prestwick Airport" },
{ code: "BEB", name: "Balivanich - Benbecula Airport" },
{ code: "DND", name: "Dundee - Dundee Airport" },
{ code: "SYY", name: "Stornoway, Western Isles - Stornoway Airport" },
{ code: "BRR", name: "Eoligarry - Barra Airport" },
{ code: "TRE", name: "Balemartine - Tiree Airport" },
{ code: "ADX", name: "Leuchars, Fife - Leuchars Station Airfield" },
{ code: "LMO", name: "Lossiemouth - RAF Lossiemouth" },
{ code: "CBG", name: "Cambridge, Cambridgeshire - Cambridge City Airport" },
{ code: "NWI", name: "Norwich, Norfolk - Norwich Airport" },
{ code: "STN", name: "London - London Stansted Airport" },
{ code: "EXT", name: "Exeter, Devon - Exeter International Airport" },
{ code: "OXF", name: "Kidlington, Oxfordshire - London Oxford Airport" },
{ code: "BEX", name: "Wallingford, Oxfordshire - RAF Benson" },
{ code: "LKZ", name: "Brandon, Suffolk - RAF Lakenheath" },
{ code: "MHZ", name: "Bury Saint Edmunds, Suffolk - RAF Mildenhall" },
{ code: "FFD", name: "Fairford, Gloucestershire - RAF Fairford" },
{ code: "BZZ", name: "Carterton, Oxfordshire - RAF Brize Norton" },
{ code: "ODH", name: "Hook, Hampshire - RAF Odiham" },
{ code: "NHT", name: "London - RAF Northolt" },
{ code: "QCY", name: "Lincoln, Lincolnshire - RAF Coningsby" },
{ code: "BEQ", name: "Bury Saint Edmunds, Suffolk - RAF Honington" },
{ code: "WTN", name: "Lincoln, Lincolnshire - RAF Waddington" },
{ code: "KNF", name: "King's Lynn, Norfolk - RAF Marham" },
{ code: "MPN", name: "Mount Pleasant - Mount Pleasant Airport" },
{ code: "AMS", name: "Amsterdam - Amsterdam Airport Schiphol" },
{ code: "MST", name: "Maastricht - Maastricht Aachen Airport" },
{ code: "EIN", name: "Eindhoven - Eindhoven Airport" },
{ code: "GRQ", name: "Groningen - Groningen Airport Eelde" },
{ code: "GLZ", name: "Rijen - Gilze Rijen Air Base" },
{ code: "DHR", name: "Den Helder - De Kooy Airfield / Den Helder Naval Air Station" },
{ code: "LEY", name: "Lelystad - Lelystad Airport" },
{ code: "LWR", name: "Leeuwarden - Leeuwarden Air Base" },
{ code: "RTM", name: "Rotterdam - Rotterdam The Hague Airport" },
{ code: "ENS", name: "Enschede - Twente Airport" },
{ code: "UDE", name: "Uden - Volkel Air Base" },
{ code: "WOE", name: "Hoogerheide - Woensdrecht Air Base" },
{ code: "ORK", name: "Cork - Cork Airport" },
{ code: "CFN", name: "Donegal - Donegal Airport" },
{ code: "DUB", name: "Dublin - Dublin Airport" },
{ code: "NOC", name: "Charlestown - Ireland West Knock Airport" },
{ code: "KIR", name: "Farranfore - Kerry Airport" },
{ code: "SNN", name: "Shannon - Shannon Airport" },
{ code: "SXL", name: "Sligo - Sligo Airport" },
{ code: "WAT", name: "Waterford - Waterford Airport" },
{ code: "AAR", name: "Aarhus - Aarhus Airport" },
{ code: "BLL", name: "Billund - Billund Airport" },
{ code: "CPH", name: "Copenhagen - Copenhagen Kastrup Airport" },
{ code: "EBJ", name: "Esbjerg - Esbjerg Airport" },
{ code: "KRP", name: "Karup - Midtjyllands Airport / Air Base Karup" },
{ code: "MRW", name: "RÃ¸dby - Lolland Falster Maribo Airport" },
{ code: "ODE", name: "Odense - Odense Hans Christian Andersen Airport" },
{ code: "RKE", name: "Roskilde - Copenhagen Roskilde Airport" },
{ code: "RNN", name: "RÃ¸nne - Bornholm Airport" },
{ code: "SGD", name: "SÃ¸nderborg - SÃ¸nderborg Airport" },
{ code: "CNL", name: "Sindal - Sindal Airport" },
{ code: "SKS", name: "Vojens - Skrydstrup Air Base" },
{ code: "SQW", name: "Skive - Skive Airport" },
{ code: "TED", name: "Thisted - Thisted Airport" },
{ code: "FAE", name: "VÃ¡gar - VÃ¡gar Airport" },
{ code: "STA", name: "Skjern - Stauning Vestjylland  Airport" },
{ code: "AAL", name: "Aalborg - Aalborg Airport" },
{ code: "LUX", name: "Luxembourg - Luxembourg-Findel International Airport" },
{ code: "AES", name: "Ã…lesund - Ã…lesund Airport, Vigra" },
{ code: "ANX", name: "Andenes - AndÃ¸ya Airport, Andenes" },
{ code: "ALF", name: "Alta - Alta Airport" },
{ code: "BNN", name: "BrÃ¸nnÃ¸y - BrÃ¸nnÃ¸ysund Airport, BrÃ¸nnÃ¸y" },
{ code: "BOO", name: "BodÃ¸ - BodÃ¸ Airport" },
{ code: "BGO", name: "Bergen - Bergen Airport, Flesland" },
{ code: "BJF", name: "BÃ¥tsfjord - BÃ¥tsfjord Airport" },
{ code: "BVG", name: "BerlevÃ¥g - BerlevÃ¥g Airport" },
{ code: "KRS", name: "Kjevik - Kristiansand Airport, Kjevik" },
{ code: "BDU", name: "MÃ¥lselv - Bardufoss Airport" },
{ code: "EVE", name: "Evenes - Harstad/Narvik Airport, Evenes" },
{ code: "FRO", name: "FlorÃ¸ - FlorÃ¸ Airport" },
{ code: "OSL", name: "Oslo (Gardermoen) - Oslo Airport, Gardermoen" },
{ code: "HAU", name: "KarmÃ¸y - Haugesund Airport, KarmÃ¸y" },
{ code: "HFT", name: "Hammerfest - Hammerfest Airport" },
{ code: "HVG", name: "HonningsvÃ¥g - HonningsvÃ¥g Airport, Valan" },
{ code: "KSU", name: "Kvernberget - Kristiansund Airport, Kvernberget" },
{ code: "KKN", name: "Kirkenes - Kirkenes Airport, HÃ¸ybuktmoen" },
{ code: "LKN", name: "Leknes - Leknes Airport" },
{ code: "MEH", name: "Mehamn - Mehamn Airport" },
{ code: "MOL", name: "Ã…rÃ¸ - Molde Airport, Ã…rÃ¸" },
{ code: "MJF", name: "MosjÃ¸en - MosjÃ¸en Airport, KjÃ¦rstad" },
{ code: "LKL", name: "Lakselv - Lakselv Airport, Banak" },
{ code: "NTB", name: "Notodden - Notodden Airport" },
{ code: "OLA", name: "Ã˜rland - Ã˜rland Airport" },
{ code: "HOV", name: "Ã˜rsta - Ã˜rsta-Volda Airport, Hovden" },
{ code: "MQN", name: "Mo i Rana - Mo i Rana Airport, RÃ¸ssvoll" },
{ code: "RVK", name: "RÃ¸rvik - RÃ¸rvik Airport, Ryum" },
{ code: "RRS", name: "RÃ¸ros - RÃ¸ros Airport" },
{ code: "LYR", name: "Longyearbyen - Svalbard Airport, Longyear" },
{ code: "SVJ", name: "SvolvÃ¦r - SvolvÃ¦r Airport, Helle" },
{ code: "SKN", name: "Hadsel - Stokmarknes Airport, Skagen" },
{ code: "SRP", name: "Leirvik - Stord Airport, SÃ¸rstokken" },
{ code: "SOJ", name: "SÃ¸rkjosen - SÃ¸rkjosen Airport" },
{ code: "VAW", name: "VardÃ¸ - VardÃ¸ Airport, Svartnes" },
{ code: "SSJ", name: "Alstahaug - SandnessjÃ¸en Airport, Stokka" },
{ code: "TOS", name: "TromsÃ¸ - TromsÃ¸ Airport, Langnes" },
{ code: "TRF", name: "Torp - Sandefjord Airport, Torp" },
{ code: "TRD", name: "Trondheim - Trondheim Airport, VÃ¦rnes" },
{ code: "VDS", name: "VadsÃ¸ - VadsÃ¸ Airport" },
{ code: "SVG", name: "Stavanger - Stavanger Airport, Sola" },
{ code: "BZG", name: "Bydgoszcz - Bydgoszcz Ignacy Jan Paderewski Airport" },
{ code: "GDN", name: "GdaÅ„sk - GdaÅ„sk Lech WaÅ‚Ä™sa Airport" },
{ code: "KRK", name: "Balice - KrakÃ³w John Paul II International Airport" },
{ code: "KTW", name: "Katowice - Katowice Wojciech Korfanty International Airport" },
{ code: "LUZ", name: "Lublin - Lublin Airport" },
{ code: "LCJ", name: "ÅÃ³dÅº - ÅÃ³dÅº WÅ‚adysÅ‚aw Reymont Airport" },
{ code: "WMI", name: "Nowy DwÃ³r Mazowiecki - Modlin Airport" },
{ code: "POZ", name: "PoznaÅ„ - PoznaÅ„-Åawica Airport" },
{ code: "RDO", name: "Radom - Warsaw Radom Airport" },
{ code: "RZE", name: "Jasionka - RzeszÃ³w-Jasionka Airport" },
{ code: "SZZ", name: "Glewice - Solidarity Szczecinâ€“GoleniÃ³w Airport" },
{ code: "SZY", name: "Szymany - Olsztyn-Mazury Airport" },
{ code: "WAW", name: "Warsaw - Warsaw Chopin Airport" },
{ code: "WRO", name: "WrocÅ‚aw - Copernicus WrocÅ‚aw Airport" },
{ code: "IEG", name: "Nowe Kramsko - Zielona GÃ³ra-Babimost Airport" },
{ code: "RNB", name: "Ronneby - Ronneby Airport" },
{ code: "GOT", name: "GÃ¶teborg - GÃ¶teborg Landvetter Airport" },
{ code: "JKG", name: "JÃ¶nkÃ¶ping - JÃ¶nkÃ¶ping Airport" },
{ code: "GSE", name: "GÃ¶teborg - SÃ¤ve Airport" },
{ code: "KVB", name: "SkÃ¶vde - SkÃ¶vde Airport" },
{ code: "THN", name: "TrollhÃ¤ttan - TrollhÃ¤ttan-VÃ¤nersborg Airport" },
{ code: "KSK", name: "Karlskoga - Karlskoga Airport" },
{ code: "MXX", name: "Mora - Mora Airport" },
{ code: "NYO", name: "NykÃ¶ping - Stockholm Skavsta Airport" },
{ code: "SCR", name: "Malung-SÃ¤len - Scandinavian Mountains Airport" },
{ code: "KID", name: "Kristianstad - Kristianstad Airport" },
{ code: "KLR", name: "Kalmar - Kalmar Airport" },
{ code: "MMX", name: "MalmÃ¶ - MalmÃ¶ Sturup Airport" },
{ code: "HAD", name: "Halmstad - Halmstad Airport" },
{ code: "VXO", name: "VÃ¤xjÃ¶ - VÃ¤xjÃ¶ Kronoberg Airport" },
{ code: "GEV", name: "GÃ¤llivare - GÃ¤llivare Airport" },
{ code: "KRF", name: "Nyland - Kramfors-SollefteÃ¥ HÃ¶ga Kusten Airport" },
{ code: "LYC", name: "Lycksele - Lycksele Airport" },
{ code: "SDL", name: "Sundsvall/ HÃ¤rnÃ¶sand - Sundsvall-HÃ¤rnÃ¶sand Airport" },
{ code: "OER", name: "Ã–rnskÃ¶ldsvik - Ã–rnskÃ¶ldsvik Airport" },
{ code: "KRN", name: "Kiruna - Kiruna Airport" },
{ code: "SFT", name: "SkellefteÃ¥ - SkellefteÃ¥ Airport" },
{ code: "UME", name: "UmeÃ¥ - UmeÃ¥ Airport" },
{ code: "VHM", name: "Vilhelmina - Vilhelmina South Lapland Airport" },
{ code: "AJR", name: "Arvidsjaur - Arvidsjaur Airport" },
{ code: "SOO", name: "SÃ¶derhamn - SÃ¶derhamn Airport" },
{ code: "OSD", name: "Ã–stersund - Ã…re Ã–stersund Airport" },
{ code: "ORB", name: "Ã–rebro - Ã–rebro Airport" },
{ code: "KSD", name: "Karlstad - Karlstad Airport" },
{ code: "VST", name: "Stockholm / VÃ¤sterÃ¥s - Stockholm VÃ¤sterÃ¥s Airport" },
{ code: "LLA", name: "LuleÃ¥ - LuleÃ¥ Airport" },
{ code: "ARN", name: "Stockholm - Stockholm-Arlanda Airport" },
{ code: "BMA", name: "Stockholm - Stockholm-Bromma Airport" },
{ code: "BLE", name: "Borlange - Dala Airport" },
{ code: "GVX", name: "GÃ¤vle / Sandviken - GÃ¤vle Sandviken Airport" },
{ code: "LPI", name: "LinkÃ¶ping - LinkÃ¶ping City Airport" },
{ code: "NRK", name: "NorrkÃ¶ping - NorrkÃ¶ping Airport" },
{ code: "TYF", name: "Torsby - Torsby Airport" },
{ code: "EKT", name: "Eskilstuna - Eskilstuna Airport" },
{ code: "VBY", name: "Visby - Visby Airport" },
{ code: "AGH", name: "Ã„ngelholm - Ã„ngelholm-Helsingborg Airport" },
{ code: "SQO", name: "Storuman - Storuman Airport" },
{ code: "SPM", name: "Trier - Spangdahlem Air Base" },
{ code: "RMS", name: "Ramstein-Miesenbach - Ramstein Air Base" },
{ code: "FRZ", name: "Fritzlar - Fritzlar Army Airfield" },
{ code: "FCN", name: "Wurster NordseekÃ¼ste - Sea-Airport Cuxhaven/Nordholz / Nordholz Naval Airbase" },
{ code: "GKE", name: "Geilenkirchen - Geilenkirchen Air Base" },
{ code: "RLG", name: "Laage - Rostock-Laage Airport" },
{ code: "WBG", name: "Jagel - Schleswig Air Base" },
{ code: "WIE", name: "Wiesbaden - Wiesbaden Army Airfield" },
{ code: "IGS", name: "Manching - Ingolstadt Manching Airport" },
{ code: "LPX", name: "LiepÄja - LiepÄja International Airport" },
{ code: "RIX", name: "Riga - Riga International Airport" },
{ code: "KUN", name: "Kaunas - Kaunas International Airport" },
{ code: "PLQ", name: "Palanga - Palanga International Airport" },
{ code: "PNV", name: "PanevÄ—Å¾ys - PanevÄ—Å¾ys Air Base" },
{ code: "SQQ", name: "Å iauliai - Å iauliai International Airport" },
{ code: "VNO", name: "Vilnius - Vilnius International Airport" },
{ code: "ALJ", name: "Alexander Bay - Alexander Bay Airport" },
{ code: "AGZ", name: "Aggeneys - Aggeneys Airport" },
{ code: "BIY", name: "Bisho - Bisho Airport" },
{ code: "BFN", name: "Bloemfontain - Bram Fischer International Airport" },
{ code: "CPT", name: "Cape Town - Cape Town International Airport" },
{ code: "ELS", name: "East London - King Phalo Airport" },
{ code: "FCB", name: "Ficksburg - Ficksburg Sentraoes Airport" },
{ code: "GCJ", name: "Midrand - Grand Central Airport" },
{ code: "GRJ", name: "George - George Airport" },
{ code: "QRA", name: "Johannesburg - Rand Airport" },
{ code: "HRS", name: "Harrismith - Harrismith Airport" },
{ code: "KXE", name: "Klerksdorp - P C Pelser Airport" },
{ code: "KIM", name: "Kimberley - Kimberley Airport" },
{ code: "MQP", name: "Mpumalanga - Kruger Mpumalanga International Airport" },
{ code: "KMH", name: "Kuruman - Johan Pienaar Airport" },
{ code: "KLZ", name: "Kleinsee - Kleinsee Airport" },
{ code: "HLA", name: "Johannesburg - Lanseria International Airport" },
{ code: "LMR", name: "Lime Acres - Lime Acres Finsch Mine Airport" },
{ code: "DUR", name: "Durban - King Shaka International Airport" },
{ code: "SDB", name: "Langebaanweg - Langebaanweg Airport" },
{ code: "LAY", name: "Ladysmith - Ladysmith Airport" },
{ code: "AAM", name: "Malamala - Malamala Airport" },
{ code: "MGH", name: "Margate - Margate Airport" },
{ code: "MBD", name: "Mafeking - Mmabatho International Airport" },
{ code: "MZQ", name: "Mkuze - Mkuze Airport" },
{ code: "NCS", name: "Newcastle - Newcastle Airport" },
{ code: "OUH", name: "Oudtshoorn - Oudtshoorn Airport" },
{ code: "JNB", name: "Johannesburg - O.R. Tambo International Airport" },
{ code: "PLZ", name: "Gqeberha (Port Elizabeth) - Chief Dawid Stuurman International Airport" },
{ code: "PBZ", name: "Plettenberg Bay - Plettenberg Bay Airport" },
{ code: "PHW", name: "Phalaborwa - Hendrik Van Eck Airport" },
{ code: "JOH", name: "Port St Johns - Port St Johns Airport" },
{ code: "PZB", name: "Pietermaritzburg - Pietermaritzburg Airport" },
{ code: "PTG", name: "Polokwane - Polokwane International Airport" },
{ code: "PCF", name: "Potchefstroom - Potchefstroom Airport" },
{ code: "UTW", name: "Queenstown - Queenstown Airport" },
{ code: "RCB", name: "Richards Bay - Richards Bay Airport" },
{ code: "ROD", name: "Robertson - Robertson Airport" },
{ code: "SBU", name: "Springbok - Springbok Airport" },
{ code: "ZEC", name: "Secunda - Secunda Airport" },
{ code: "SIS", name: "Sishen - Sishen Airport" },
{ code: "SZK", name: "Skukuza - Skukuza Airport" },
{ code: "LTA", name: "Tzaneen - Tzaneen Airport" },
{ code: "ULD", name: "Ulundi - Prince Mangosuthu Buthelezi Airport" },
{ code: "UTN", name: "Upington - Pierre Van Ryneveld Airport" },
{ code: "UTT", name: "Mthatha - K. D. Matanzima Airport" },
{ code: "VRU", name: "Vyrburg - Vryburg Airport" },
{ code: "VIR", name: "Durban - Virginia Airport" },
{ code: "VRE", name: "Vredendal - Vredendal Airport" },
{ code: "PRY", name: "Pretoria - Wonderboom Airport" },
{ code: "WKF", name: "Pretoria - Waterkloof Air Force Base" },
{ code: "FRW", name: "Francistown - P G Matante Intl" },
{ code: "JWA", name: "Jwaneng - Jwaneng Airport" },
{ code: "BBK", name: "Kasane - Kasane Airport" },
{ code: "MUB", name: "Maun - Maun Airport" },
{ code: "GBE", name: "Gaborone - Sir Seretse Khama International Airport" },
{ code: "SXN", name: "Sowa - Sua Pan Airport" },
{ code: "PKW", name: "Selebi Phikwe - Selebi Phikwe Airport" },
{ code: "BZV", name: "Brazzaville - Maya-Maya Airport" },
{ code: "OLL", name: "Oyo - Oyo Ollombo Airport" },
{ code: "FTX", name: "Owando - Owando Airport" },
{ code: "OUE", name: " - Ouesso Airport" },
{ code: "DIS", name: "Dolisie - Ngot Nzoungou Airport" },
{ code: "PNR", name: "Pointe Noire - Antonio Agostinho-Neto International Airport" },
{ code: "MTS", name: "Manzini - Matsapha Airport" },
{ code: "SHO", name: "Mpaka - King Mswati III International Airport" },
{ code: "BGF", name: "Bangui - Bangui M'Poko International Airport" },
{ code: "BBT", name: "BerbÃ©rati - BerbÃ©rati Airport" },
{ code: "BSG", name: "Bata - Bata Airport" },
{ code: "SSG", name: "Malabo - Malabo Airport" },
{ code: "ASI", name: "Cat Hill - RAF Ascension Island" },
{ code: "MRU", name: "Plaine Magnien - Sir Seewoosagur Ramgoolam International Airport" },
{ code: "RRG", name: "Port Mathurin - Sir Charles Gaetan Duval Airport" },
{ code: "NKW", name: "Diego Garcia - Diego Garcia Naval Support Facility" },
{ code: "TKC", name: "Tiko - Tiko Airport" },
{ code: "DLA", name: "Douala - Douala International Airport" },
{ code: "MVR", name: "Maroua - Salak Airport" },
{ code: "FOM", name: "Foumban - Foumban Nkounja Airport" },
{ code: "NGE", name: "N'GaoundÃ©rÃ© - N'GaoundÃ©rÃ© Airport" },
{ code: "GOU", name: "Garoua - Garoua International Airport" },
{ code: "BFX", name: "Bafoussam - Bafoussam Airport" },
{ code: "BPC", name: "Bamenda - Bamenda Airport" },
{ code: "YAO", name: "YaoundÃ© - YaoundÃ© Airport" },
{ code: "NSI", name: "YaoundÃ© - YaoundÃ© Nsimalen International Airport" },
{ code: "CGJ", name: "Chingola - Kasompe Airport" },
{ code: "LVI", name: "Livingstone - Harry Mwanga Nkumbula International Airport" },
{ code: "LUN", name: "Lusaka - Kenneth Kaunda International Airport" },
{ code: "MFU", name: "Mfuwe - Mfuwe Airport" },
{ code: "MNR", name: "Mongu - Mongu Airport" },
{ code: "NLA", name: "Ndola - Simon Mwansa Kapwepwe International Airport" },
{ code: "KIW", name: "Kitwe - Southdowns Airport" },
{ code: "HAH", name: "Moroni - Prince Said Ibrahim International Airport" },
{ code: "NWA", name: "Fomboni - MohÃ©li Bandar Es Eslam Airport" },
{ code: "AJN", name: "Ouani - Ouani Airport" },
{ code: "DZA", name: "Dzaoudzi - Dzaoudzi Pamandzi International Airport" },
{ code: "RUN", name: "Sainte-Marie - Roland Garros Airport" },
{ code: "ZSE", name: "Saint-Pierre - Pierrefonds Airport" },
{ code: "TNR", name: "Antananarivo - Ivato Airport" },
{ code: "ZVA", name: "Miandrivazo - Miandrivazo Airport" },
{ code: "SMS", name: "Vohilava - Sainte Marie Airport" },
{ code: "TMM", name: "Toamasina - Toamasina Ambalamanasy Airport" },
{ code: "MOQ", name: "Morondava - Morondava Airport" },
{ code: "DIE", name: "Antisiranana - Arrachart Airport" },
{ code: "WMR", name: "Mananara Nord - Mananara Nord Airport" },
{ code: "ZWA", name: " - Andapa Airport" },
{ code: "ANM", name: "Antsirabe - Antsirabe Airport" },
{ code: "HVA", name: "Analalava - Analalava Airport" },
{ code: "MJN", name: "Mahajanga - Amborovy Airport" },
{ code: "NOS", name: "Nosy Be - Fascene Airport" },
{ code: "BPY", name: "Besalampy - Besalampy Airport" },
{ code: "WMN", name: "Maroantsetra - Maroantsetra Airport" },
{ code: "SVB", name: "Sambava - Sambava Airport" },
{ code: "VOH", name: "Vohemar - Vohemar Airport" },
{ code: "WAI", name: "Antsohihy - Ambalabe Airport" },
{ code: "FTU", name: "TÃ´lanaro - TÃ´lanaro Airport" },
{ code: "WFI", name: "Fianarantsoa - Fianarantsoa Airport" },
{ code: "WVK", name: "Manakara - Manakara Airport" },
{ code: "MNJ", name: "Mananjary - Mananjary Airport" },
{ code: "MXM", name: "Morombe - Morombe Airport" },
{ code: "TLE", name: "Toliara - Toliara Airport" },
{ code: "SSY", name: "Mbanza Congo - Mbanza Congo Airport" },
{ code: "BUG", name: "Benguela - Benguela Airport" },
{ code: "NBJ", name: "Luanda (Ãcolo e Bengo) - Dr. Antonio Agostinho Neto International Airport" },
{ code: "CAB", name: "Cabinda - Cabinda Airport" },
{ code: "CBT", name: "Catumbela - Catumbela Airport" },
{ code: "DUE", name: "Chitato - Dundo Airport" },
{ code: "VPE", name: "Ngiva - Ngjiva Pereira Airport" },
{ code: "NOV", name: "Huambo - Albano Machado Airport" },
{ code: "SVP", name: "Kuito - Kuito Airport" },
{ code: "LAD", name: "Luanda - Quatro de Fevereiro International Airport" },
{ code: "MEG", name: "Malanje - Malanje Airport" },
{ code: "SPP", name: "Menongue - Menongue Airport" },
{ code: "MSZ", name: "MoÃ§Ã¢medes - Welwitschia Mirabilis International Airport" },
{ code: "GXG", name: "Negage - Negage Airport" },
{ code: "PBN", name: "Port Amboim - Porto Amboim Airport" },
{ code: "VHC", name: "Saurimo - Saurimo Airport" },
{ code: "SZA", name: "Soyo - Soyo Airport" },
{ code: "NDD", name: "Sumbe - Sumbe Airport" },
{ code: "SDD", name: "Lubango - Lubango Airport" },
{ code: "LUO", name: "Luena - Luena Airport" },
{ code: "UGO", name: "Uige - Uige Airport" },
{ code: "XGN", name: "Xangongo - Xangongo Airport" },
{ code: "KOU", name: "Koulamoutou - Koulamoutou Mabimbi Airport" },
{ code: "MJL", name: "Mouila - Mouilla Ville Airport" },
{ code: "OYE", name: "Oyem - Oyem Airport" },
{ code: "OKN", name: "Okondja - Okondja Airport" },
{ code: "LBQ", name: "Lambarene - Lambarene Airport" },
{ code: "BMM", name: "Bitam - Bitam Airport" },
{ code: "POG", name: "Port Gentil - Port Gentil Airport" },
{ code: "OMB", name: "Omboue - Omboue Hospital Airport" },
{ code: "MKU", name: "Makokou - Makokou Airport" },
{ code: "LBV", name: "Libreville - Libreville Leon M'ba International Airport" },
{ code: "MVB", name: "Franceville - M'Vengue El Hadj Omar Bongo Ondimba International Airport" },
{ code: "PCP", name: "SÃ£o TomÃ© & PrÃ­ncipe - Principe Airport" },
{ code: "TMS", name: "SÃ£o TomÃ© - SÃ£o TomÃ© International Airport" },
{ code: "BEW", name: "Beira - Beira Airport" },
{ code: "VPY", name: "Chimoio - Chimoio Airport" },
{ code: "INH", name: "Inhambane - Inhambane Airport" },
{ code: "VXC", name: "Lichinga - Lichinga Airport" },
{ code: "MPM", name: "Maputo - Maputo Airport" },
{ code: "MUD", name: "Mueda - Mueda Airport" },
{ code: "MZB", name: "MocÃ­mboa da Praia - MocÃ­mboa da Praia Airport" },
{ code: "APL", name: "Nampula - Nampula Airport" },
{ code: "POL", name: "Pemba - Pemba Airport" },
{ code: "UEL", name: "Quelimane - Quelimane Airport" },
{ code: "TET", name: "Tete - Chingozi Airport" },
{ code: "VNX", name: "Vilanculo - Vilankulo Airport" },
{ code: "SEZ", name: "Mahe Island - Seychelles International Airport" },
{ code: "PRI", name: "Praslin Island - Praslin Island Airport" },
{ code: "AEH", name: "Abeche - Abeche Airport" },
{ code: "MQQ", name: "Moundou - Moundou Airport" },
{ code: "NDJ", name: "N'Djamena - N'Djamena International Airport" },
{ code: "FYT", name: "Faya-Largeau - Faya-Largeau Airport" },
{ code: "BUQ", name: "Bulawayo - Joshua Mqabuko Nkomo International Airport" },
{ code: "BFO", name: "Chiredzi - Buffalo Range Airport" },
{ code: "VFA", name: "Victoria Falls - Victoria Falls International Airport" },
{ code: "HRE", name: "Harare - Robert Gabriel Mugabe International Airport" },
{ code: "KAB", name: "Kariba - Kariba International Airport" },
{ code: "MVZ", name: "Masvingo - Masvingo International Airport" },
{ code: "GWE", name: "Gweru - Gweru - Thornhill Air Base" },
{ code: "HWN", name: "Gwayi River Farms - Hwange National Park Airport" },
{ code: "BLZ", name: "Blantyre - Chileka International Airport" },
{ code: "DWA", name: "Dwangwa - Dwangwa Airport" },
{ code: "KGJ", name: "Karonga - Karonga Airport" },
{ code: "LLW", name: "Lumbadzi - Kamuzu International Airport" },
{ code: "ZZU", name: "Mzuzu - Mzuzu Airport" },
{ code: "MSU", name: "Mazenod - Moshoeshoe I International Airport" },
{ code: "ADI", name: "Arandis - Arandis Airport" },
{ code: "GFY", name: "Grootfontein - Grootfontein Airport" },
{ code: "MPA", name: "Mpacha - Katima Mulilo Airport" },
{ code: "KMP", name: "Keetmanshoop - Keetmanshoop Airport" },
{ code: "LUD", name: "Luderitz - Luderitz Airport" },
{ code: "OND", name: "Ondangwa - Ondangwa Airport" },
{ code: "OMD", name: "Oranjemund - Oranjemund Airport" },
{ code: "NDU", name: "Rundu - Rundu Airport" },
{ code: "TSB", name: "Tsumeb - Tsumeb Airport" },
{ code: "WVB", name: "Rooikop - Walvis Bay Airport" },
{ code: "ERS", name: "Windhoek - Eros Airport" },
{ code: "WDH", name: "Windhoek - Hosea Kutako International Airport" },
{ code: "FIH", name: "Kinshasa - Ndjili International Airport" },
{ code: "NLO", name: "N'dolo - Ndolo Airport" },
{ code: "FDU", name: "Bandundu - Bandundu Airport" },
{ code: "KKW", name: "Kikwit - Kikwit Airport" },
{ code: "MDK", name: "Mbandaka - Mbandaka Airport" },
{ code: "BDT", name: "Gbadolite - Gbadolite Airport" },
{ code: "GMA", name: "Gemena - Gemena Airport" },
{ code: "LIQ", name: "Lisala - Lisala Airport" },
{ code: "FKI", name: "Kisangani - Bangoka International Airport" },
{ code: "IRP", name: "Isiro - Matari Airport" },
{ code: "BUX", name: "Bunia - Bunia Airport" },
{ code: "BZU", name: "Buta - Buta Zega Airport" },
{ code: "BKY", name: "Kamakombe - Bukavu Kavumu Airport" },
{ code: "GOM", name: "Goma - Goma International Airport" },
{ code: "KND", name: "Kindu - Kindu Airport" },
{ code: "FBM", name: "Lubumbashi - Lubumbashi International Airport" },
{ code: "KWZ", name: "Kolwezi - Kolwezi Airport" },
{ code: "FMI", name: "Kalemie - Kalemie Airport" },
{ code: "KGA", name: "Kananga - Kananga Airport" },
{ code: "MJM", name: "Mbuji Mayi - Mbuji Mayi Airport" },
{ code: "BKO", name: "Bamako - Modibo Keita International Airport" },
{ code: "GAQ", name: " - Gao Airport" },
{ code: "KYS", name: " - Kayes Dag Dag Airport" },
{ code: "MZI", name: "SÃ©varÃ© - Mopti AmbodÃ©djo International Airport" },
{ code: "TOM", name: "Timbuktu - Timbuktu Airport" },
{ code: "BJL", name: "Yundum - Banjul International Airport" },
{ code: "FUE", name: "El Matorral - Fuerteventura Airport" },
{ code: "VDE", name: "El Hierro Island - El Hierro Airport" },
{ code: "SPC", name: "Sta Cruz de la Palma, La Palma Island - La Palma Airport" },
{ code: "LPA", name: "Gran Canaria Island - Gran Canaria Airport" },
{ code: "ACE", name: "San BartolomÃ© - CÃ©sar Manrique-Lanzarote Airport" },
{ code: "TFS", name: "Tenerife - Tenerife Sur Airport" },
{ code: "TFN", name: "Tenerife - Tenerife Norte-Ciudad de La Laguna Airport" },
{ code: "MLN", name: "Melilla - Melilla Airport" },
{ code: "KBS", name: "Bo - Bo Airport" },
{ code: "KEN", name: "Kenema - Kenema Airport" },
{ code: "FNA", name: "Freetown (Lungi-Town) - Lungi International Airport" },
{ code: "WYE", name: "Yengema - Yengema Airport" },
{ code: "OXB", name: "Bissau - Osvaldo Vieira International Airport" },
{ code: "MLW", name: "Monrovia - Spriggs Payne Airport" },
{ code: "ROB", name: "Monrovia - Roberts International Airport" },
{ code: "AGA", name: "Agadir (Temsia) - Al Massira Airport" },
{ code: "TTA", name: "Tan Tan - Tan Tan Airport" },
{ code: "OZG", name: "Zagora - Zagora Airport" },
{ code: "UAR", name: "Bouarfa - Bouarfa Airport" },
{ code: "FEZ", name: "SaÃ¯ss - Fes SaÃ¯ss International Airport" },
{ code: "ERH", name: "Errachidia - Moulay Ali Cherif Airport" },
{ code: "MEK", name: "Meknes - Bassatine Airport" },
{ code: "OUD", name: "Ahl Angad - Oujda Angads Airport" },
{ code: "SMW", name: "Smara - Smara Airport" },
{ code: "RBA", name: "Rabat - Rabat-SalÃ© Airport" },
{ code: "VIL", name: "Dakhla - Dakhla Airport" },
{ code: "ESU", name: "Essaouira - Essaouira-Mogador Airport" },
{ code: "EUN", name: "El AaiÃºn - Hassan I Airport" },
{ code: "CMN", name: "Casablanca - Mohammed V International Airport" },
{ code: "NDR", name: "Al Aaroui - Nador Al Aaroui International Airport" },
{ code: "RAK", name: "Marrakech - Menara Airport" },
{ code: "NNA", name: "Kenitra - Kenitra Air Base" },
{ code: "OZZ", name: "Ouarzazate - Ouarzazate Airport" },
{ code: "AHU", name: "Al Hoceima - Cherif Al Idrissi Airport" },
{ code: "TTU", name: "TÃ©touan - Sania Ramel Airport" },
{ code: "TNG", name: "Tangier - Tangier Ibn Battuta Airport" },
{ code: "DSS", name: "Dakar - Blaise Diagne International Airport" },
{ code: "ZIG", name: "Ziguinchor - Ziguinchor Airport" },
{ code: "CSK", name: "Cap Skirring - Cap Skirring Airport" },
{ code: "KLC", name: "Kaolack - Kaolack Airport" },
{ code: "DKR", name: "Dakar - LÃ©opold SÃ©dar Senghor International Airport" },
{ code: "MAX", name: "Ouro Sogui - Ouro Sogui Airport" },
{ code: "XLS", name: "Saint Louis - Saint Louis Airport" },
{ code: "BXE", name: "Bakel - Bakel Airport" },
{ code: "KGG", name: "KÃ©dougou - KÃ©dougou Airport" },
{ code: "TUD", name: "Tambacounda - Tambacounda Airport" },
{ code: "NKC", name: "Nouakchott - Nouakchottâ€“Oumtounsy International Airport" },
{ code: "ATR", name: "Atar - Atar International Airport" },
{ code: "NDB", name: "Nouadhibou - Nouadhibou International Airport" },
{ code: "CKY", name: "Conakry - Conakry International Airport" },
{ code: "SID", name: "Espargos - AmÃ­lcar Cabral International Airport" },
{ code: "BVC", name: "Rabil - Rabil Airport" },
{ code: "MMO", name: "Vila do Maio - Maio Airport" },
{ code: "RAI", name: "Praia - Nelson Mandela International Airport" },
{ code: "SNE", name: "PreguiÃ§a - PreguiÃ§a Airport" },
{ code: "VXE", name: "SÃ£o Pedro - SÃ£o Pedro Airport" },
{ code: "ADD", name: "Addis Ababa - Addis Ababa Bole International Airport" },
{ code: "AMH", name: "Arba Minch - Arba Minch Airport" },
{ code: "AXU", name: "Axum - Axum Airport" },
{ code: "BJR", name: "Bahir Dar - Bahir Dar Airport" },
{ code: "DIR", name: "Dire Dawa - Aba Tenna Dejazmach Yilma International Airport" },
{ code: "GMB", name: "Gambela - Gambela Airport" },
{ code: "GDQ", name: "Azezo - Gondar Airport" },
{ code: "GDE", name: "Gode - Gode Airport" },
{ code: "QHR", name: "Debre Zeyit - Harar Meda Airport" },
{ code: "JIJ", name: "Jijiga - Wilwal International Airport" },
{ code: "JIM", name: "Jimma - Jimma Airport" },
{ code: "ABK", name: "Kebri Dahar - Kebri Dahar Airport" },
{ code: "AWA", name: "Hawassa - Hawassa International Airport" },
{ code: "MQX", name: "Mekele - Alula Aba Nega Airport" },
{ code: "ASO", name: "Asosa - Asosa Airport" },
{ code: "BJM", name: "Bujumbura - Bujumbura Melchior Ndadaye International Airport" },
{ code: "HGA", name: "Hargeisa - Egal International Airport" },
{ code: "BBO", name: "Berbera - Berbera Airport" },
{ code: "KMU", name: "Kismayo - Kismayo Airport" },
{ code: "MGQ", name: "Mogadishu - Aden Adde International Airport" },
{ code: "JIB", name: "Djibouti City - Djibouti-Ambouli Airport" },
{ code: "RDL", name: "El Hassana - Bardawil International Airport" },
{ code: "DBB", name: "El Alamein - El Alamein International Airport" },
{ code: "AAC", name: "El Arish - El Arish International Airport" },
{ code: "ATZ", name: "Asyut - Asyut International Airport" },
{ code: "HBE", name: "Alexandria - Borj El Arab International Airport" },
{ code: "ABS", name: "Abu Simbel - Abu Simbel Airport" },
{ code: "CAI", name: "Cairo - Cairo International Airport" },
{ code: "CCE", name: "New Cairo - Capital International Airport" },
{ code: "HRG", name: "Hurghada - Hurghada International Airport" },
{ code: "EGH", name: "El Jora - El Jora Airport" },
{ code: "LXR", name: "Luxor - Luxor International Airport" },
{ code: "RMF", name: "Marsa Alam - Marsa Alam International Airport" },
{ code: "MUH", name: "Marsa Matruh - Marsa Matruh International Airport" },
{ code: "PSD", name: "Port Said - Port Said International Airport" },
{ code: "SKV", name: "Saint Catherine - Saint Catherine International Airport" },
{ code: "HMB", name: "Suhaj - Suhaj Mubarak International Airport" },
{ code: "SSH", name: "Sharm El Sheikh - Sharm El Sheikh International Airport" },
{ code: "ASW", name: "Aswan - Aswan International Airport" },
{ code: "SPX", name: "Al Jiza - Sphinx International Airport" },
{ code: "TCP", name: "Taba - Taba International Airport" },
{ code: "ASM", name: "Asmara - Asmara International Airport" },
{ code: "MSW", name: "Massawa - Massawa International Airport" },
{ code: "ASA", name: "Assab - Assab International Airport" },
{ code: "JUB", name: "Juba - Juba International Airport" },
{ code: "ASV", name: "Amboseli National Park - Amboseli Airport" },
{ code: "EDL", name: "Eldoret - Eldoret International Airport" },
{ code: "NBO", name: "Nairobi - Jomo Kenyatta International Airport" },
{ code: "KIS", name: "Kisumu - Kisumu Airport" },
{ code: "KTL", name: "Kitale - Kitale Airport" },
{ code: "LKG", name: "Lokichogio - Lokichogio Airport" },
{ code: "LOK", name: "Lodwar - Lodwar Airport" },
{ code: "LAU", name: "Lamu - Manda Airport" },
{ code: "MYD", name: "Malindi - Malindi Airport" },
{ code: "MBA", name: "Mombasa - Moi International Airport" },
{ code: "MRE", name: "Masai Mara - Mara Serena Lodge Airstrip" },
{ code: "NYK", name: "Nanyuki - Nanyuki Airport" },
{ code: "WIL", name: "Nairobi - Nairobi Wilson Airport" },
{ code: "WJR", name: "Wajir - Wajir Airport" },
{ code: "SRX", name: "Sirt - Sirt International Airport / Ghardabiya Airbase" },
{ code: "GHT", name: "Ghat - Ghat Airport" },
{ code: "AKF", name: "Kufra - Kufra Airport" },
{ code: "BEN", name: "Benina - Benina International Airport" },
{ code: "MJI", name: "Tripoli - Mitiga International Airport" },
{ code: "LAQ", name: "Al Albraq - Al Abraq International Airport" },
{ code: "SEB", name: "Sabha - Sabha Airport" },
{ code: "LMQ", name: "Marsa al Brega - Marsa al Brega Airport" },
{ code: "LTD", name: "Ghadames - Ghadames East Airport" },
{ code: "GYI", name: "Gisenyi - Gisenyi Airport" },
{ code: "KGL", name: "Kigali - Kigali International Airport" },
{ code: "KME", name: "Kamembe - Kamembe Airport" },
{ code: "DOG", name: "Dongola - Dongola Airport" },
{ code: "ELF", name: "El Fasher - El Fasher Airport" },
{ code: "KSL", name: "Kassala - Kassala Airport" },
{ code: "MWE", name: "Merowe - Merowe Airport" },
{ code: "UYL", name: "Nyala - Nyala Airport" },
{ code: "EBD", name: "El-Obeid - El-Obeid Airport" },
{ code: "PZU", name: "Port Sudan - Port Sudan New International Airport" },
{ code: "KRT", name: "Khartoum - Khartoum International Airport" },
{ code: "MAK", name: "Malakal - Malakal Airport" },
{ code: "WUU", name: "Wau - Wau Airport" },
{ code: "ARK", name: "Arusha - Arusha Airport" },
{ code: "DAR", name: "Dar es Salaam - Julius Nyerere International Airport" },
{ code: "DOD", name: "Dodoma - Dodoma Airport" },
{ code: "MBI", name: "Mbeya - Songwe Airport" },
{ code: "IRI", name: "Nduli - Iringa Airport" },
{ code: "JRO", name: "Arusha - Kilimanjaro International Airport" },
{ code: "LKY", name: "Lake Manyara National Park - Lake Manyara Airport" },
{ code: "MYW", name: "Mtwara - Mtwara Airport" },
{ code: "MWZ", name: "Mwanza - Mwanza Airport" },
{ code: "PMA", name: "Chake Chake - Pemba Airport" },
{ code: "TGT", name: "Tanga - Tanga Airport" },
{ code: "ZNZ", name: "Zanzibar - Abeid Amani Karume International Airport" },
{ code: "RUA", name: "Arua - Arua Airport" },
{ code: "EBB", name: "Kampala - Entebbe International Airport" },
{ code: "ULU", name: "Gulu - Gulu Airport" },
{ code: "SRT", name: "Soroti - Soroti Airport" },
{ code: "HZU", name: "Chengdu (Jintang) - Chengdu Huaizhou Airport" },
{ code: "IBL", name: "Bazaruto Island - Indigo Bay Lodge Airport" },
{ code: "LHB", name: "há»“ chÃ­ minh - tylekeonhacaibuzz" },
{ code: "DHX", name: "Kediri - Dhoho International Airport" },
{ code: "UGU", name: "Sugapa - Bilogai-Sugapa Airport" },
{ code: "AYJ", name: "Faizabad - Ayodhya Airport" },
{ code: "SDW", name: "Chipi - Sindhudurg Airport" },
{ code: "NMI", name: "Navi Mumbai - Navi Mumbai International Airport" },
{ code: "RQY", name: "Shimoga - Rashtrakavi Kuvempu Airport" },
{ code: "HGI", name: "Hollongi - Itanagar Donyi Polo Hollongi Airport" },
{ code: "AHA", name: "Ambikapur - Maa Mahamaya Airport" },
{ code: "BLD", name: "Boulder City - Boulder City Municipal Airport" },
{ code: "MFH", name: "Mesquite - Mesquite International Airport" },
{ code: "ABE", name: "Allentown - Lehigh Valley International Airport" },
{ code: "ABI", name: "Abilene - Abilene Regional Airport" },
{ code: "ABQ", name: "Albuquerque - Albuquerque International Sunport" },
{ code: "ABR", name: "Aberdeen - Aberdeen Regional Airport" },
{ code: "ABY", name: "Albany - Southwest Georgia Regional Airport" },
{ code: "ACK", name: "Nantucket - Nantucket Memorial Airport" },
{ code: "ACT", name: "Waco - Waco Regional Airport" },
{ code: "ACV", name: "Arcata/Eureka - California Redwood Coast-Humboldt County Airport" },
{ code: "ACY", name: "Atlantic City - Atlantic City International Airport" },
{ code: "ADT", name: "Ada - Ada Regional Airport" },
{ code: "ADW", name: "Camp Springs - Joint Base Andrews" },
{ code: "AEX", name: "Alexandria - Alexandria International Airport" },
{ code: "AFW", name: "Fort Worth - Perot Field/Fort Worth Alliance Airport" },
{ code: "AGC", name: "Pittsburgh - Allegheny County Airport" },
{ code: "AGS", name: "Augusta - Augusta Regional At Bush Field" },
{ code: "AHN", name: "Athens - Athens Ben Epps Airport" },
{ code: "AIA", name: "Alliance - Alliance Municipal Airport" },
{ code: "AKC", name: "Akron - Akron Fulton International Airport" },
{ code: "ALB", name: "Albany - Albany International Airport" },
{ code: "ALI", name: "Alice - Alice International Airport" },
{ code: "ALM", name: "Alamogordo - Alamogordo White Sands Regional Airport" },
{ code: "ALN", name: "Alton/St Louis - St Louis Regional Airport" },
{ code: "ALO", name: "Waterloo - Waterloo Regional Airport" },
{ code: "ALS", name: "Alamosa - San Luis Valley Regional Airport/Bergman Field" },
{ code: "ALW", name: "Walla Walla - Walla Walla Regional Airport" },
{ code: "AMA", name: "Amarillo - Rick Husband Amarillo International Airport" },
{ code: "ANB", name: "Anniston - Anniston Regional Airport" },
{ code: "AND", name: "Anderson - Anderson Regional Airport" },
{ code: "AOO", name: "Altoona - Altoona Blair County Airport" },
{ code: "APA", name: "Denver - Centennial Airport" },
{ code: "APF", name: "Naples - Naples Municipal Airport" },
{ code: "APG", name: "Aberdeen - Phillips Army Air Field" },
{ code: "APN", name: "Alpena - Alpena County Regional Airport" },
{ code: "ARA", name: "New Iberia - Acadiana Regional Airport" },
{ code: "ART", name: "Watertown - Watertown International Airport" },
{ code: "ASE", name: "Aspen - Aspen-Pitkin County Airport (Sardy Field)" },
{ code: "AST", name: "Astoria - Astoria Regional Airport" },
{ code: "ATL", name: "Atlanta - Hartsfield Jackson Atlanta International Airport" },
{ code: "ATW", name: "Appleton - Appleton International Airport" },
{ code: "ATY", name: "Watertown - Watertown Regional Airport" },
{ code: "AUG", name: "Augusta - Augusta State Airport" },
{ code: "AUS", name: "Austin - Austin Bergstrom International Airport" },
{ code: "AUW", name: "Wausau - Wausau Downtown Airport" },
{ code: "AVL", name: "Asheville - Asheville Regional Airport" },
{ code: "AVP", name: "Wilkes-Barre/Scranton - Wilkes Barre Scranton International Airport" },
{ code: "AXN", name: "Alexandria - Chandler Field" },
{ code: "AZO", name: "Kalamazoo - Kalamazoo Battle Creek International Airport" },
{ code: "BAB", name: "Beale Air Force Base - Beale Air Force Base" },
{ code: "BAD", name: "Bossier City - Barksdale Air Force Base" },
{ code: "BAF", name: "Westfield - Westfield-Barnes Regional Airport" },
{ code: "CLU", name: "Columbus - Columbus Municipal Airport" },
{ code: "BBD", name: "Brady - Curtis Field" },
{ code: "BKG", name: "Branson - Branson Airport" },
{ code: "BCE", name: "Bryce Canyon - Bryce Canyon Airport" },
{ code: "BCT", name: "Boca Raton - Boca Raton Airport" },
{ code: "BDE", name: "Baudette - Baudette International Airport" },
{ code: "BDL", name: "Hartford - Bradley International Airport" },
{ code: "BDR", name: "Bridgeport - Igor I Sikorsky Memorial Airport" },
{ code: "BED", name: "Bedford - Laurence G Hanscom Field" },
{ code: "BFD", name: "Bradford - Bradford Regional Airport" },
{ code: "BFF", name: "Scottsbluff - Western Neb. Rgnl/William B. Heilig Airport" },
{ code: "BFI", name: "Seattle - Boeing Field King County International Airport" },
{ code: "BFL", name: "Bakersfield - Meadows Field" },
{ code: "BFM", name: "Mobile - Mobile Downtown Airport" },
{ code: "BGM", name: "Binghamton - Greater Binghamton/Edwin A Link field" },
{ code: "BGR", name: "Bangor - Bangor International Airport" },
{ code: "BHB", name: "Bar Harbor - Hancock County-Bar Harbor Airport" },
{ code: "BHM", name: "Birmingham - Birmingham-Shuttlesworth International Airport" },
{ code: "BIF", name: "Fort Bliss/El Paso - Biggs Army Air Field (Fort Bliss)" },
{ code: "BIH", name: "Bishop - Eastern Sierra Regional Airport" },
{ code: "BIL", name: "Billings - Billings Logan International Airport" },
{ code: "BIS", name: "Bismarck - Bismarck Municipal Airport" },
{ code: "BIX", name: "Biloxi - Keesler Air Force Base" },
{ code: "BJC", name: "Denver - Rocky Mountain Metropolitan Airport" },
{ code: "BJI", name: "Bemidji - Bemidji Regional Airport" },
{ code: "BKE", name: "Baker City - Baker City Municipal Airport" },
{ code: "BFK", name: "Aurora - Buckley Space Force Base" },
{ code: "BKL", name: "Cleveland - Burke Lakefront Airport" },
{ code: "BKW", name: "Beaver - Raleigh County Memorial Airport" },
{ code: "BLF", name: "Bluefield - Mercer County Airport" },
{ code: "BLH", name: "Blythe - Blythe Airport" },
{ code: "BLI", name: "Bellingham - Bellingham International Airport" },
{ code: "BLV", name: "Belleville - Scott AFB/Midamerica Airport" },
{ code: "BMG", name: "Bloomington - Monroe County Airport" },
{ code: "BMI", name: "Bloomington/Normal - Central Illinois Regional Airport at Bloomington-Normal" },
{ code: "BNA", name: "Nashville - Nashville International Airport" },
{ code: "BNO", name: "Burns - Burns Municipal Airport" },
{ code: "BOI", name: "Boise - Boise Air Terminal/Gowen Field" },
{ code: "BOS", name: "Boston - Logan International Airport" },
{ code: "BPI", name: "Big Piney - Miley Memorial Field" },
{ code: "WMH", name: "Mountain Home - Ozark Regional Airport" },
{ code: "BPT", name: "Beaumont/Port Arthur - Jack Brooks Regional Airport" },
{ code: "BQK", name: "Brunswick - Brunswick Golden Isles Airport" },
{ code: "BRD", name: "Brainerd - Brainerd Lakes Regional Airport" },
{ code: "BRL", name: "Burlington - Southeast Iowa Regional Airport" },
{ code: "BRO", name: "Brownsville - Brownsville South Padre Island International Airport" },
{ code: "BTL", name: "Battle Creek - Battle Creek Executive Airport at Kellogg Field" },
{ code: "BTM", name: "Butte - Bert Mooney Airport" },
{ code: "BTR", name: "Baton Rouge - Baton Rouge Metropolitan Airport" },
{ code: "BTV", name: "South Burlington - Burlington International Airport" },
{ code: "BUF", name: "Buffalo - Buffalo Niagara International Airport" },
{ code: "BUR", name: "Burbank - Hollywood Burbank Airport" },
{ code: "BFP", name: "Beaver Falls - Beaver County Airport" },
{ code: "BVY", name: "Beverly / Danvers - Beverly Regional Airport" },
{ code: "BWG", name: "Bowling Green - Bowling Green Warren County Regional Airport" },
{ code: "BWI", name: "Baltimore - Baltimore/Washington International Thurgood Marshall Airport" },
{ code: "NHZ", name: "Brunswick - Brunswick Executive Airport" },
{ code: "BYH", name: "Blytheville - Arkansas International Airport" },
{ code: "BYI", name: "Burley - Burley Municipal Airport" },
{ code: "BYS", name: "Fort Irwin/Barstow - Bicycle Lake Army Air Field" },
{ code: "BZN", name: "Bozeman - Bozeman Yellowstone International Airport" },
{ code: "CAE", name: "Columbia - Columbia Metropolitan Airport" },
{ code: "CAK", name: "Akron - Akron Canton Regional Airport" },
{ code: "CAR", name: "Caribou - Caribou Municipal Airport" },
{ code: "CBM", name: "Columbus - Columbus Air Force Base" },
{ code: "CCR", name: "Concord - Buchanan Field" },
{ code: "CCY", name: "Charles City - Northeast Iowa Regional Airport" },
{ code: "CDC", name: "Cedar City - Cedar City Regional Airport" },
{ code: "CDR", name: "Chadron - Chadron Municipal Airport" },
{ code: "CDS", name: "Childress - Childress Municipal Airport" },
{ code: "CEC", name: "Crescent City - Jack Mc Namara Field Airport" },
{ code: "CEF", name: "Chicopee - Westover Metropolitan Airport / Westover Air Reserve Base" },
{ code: "CEW", name: "Crestview - Bob Sikes Airport" },
{ code: "CEZ", name: "Cortez - Cortez Municipal Airport" },
{ code: "CGF", name: "Cleveland - Cuyahoga County Airport" },
{ code: "CGI", name: "Cape Girardeau - Cape Girardeau Regional Airport" },
{ code: "CHA", name: "Chattanooga - Chattanooga Metropolitan Airport (Lovell Field)" },
{ code: "CHO", name: "Charlottesville - Charlottesville Albemarle Airport" },
{ code: "CHS", name: "Charleston - Charleston International Airport" },
{ code: "CID", name: "Cedar Rapids - The Eastern Iowa Airport" },
{ code: "CIU", name: "Kincheloe - Chippewa County International Airport" },
{ code: "CKB", name: "Bridgeport - North Central West Virginia Airport" },
{ code: "CLE", name: "Cleveland - Cleveland Hopkins International Airport" },
{ code: "CLL", name: "College Station - Easterwood Field" },
{ code: "CLM", name: "Port Angeles - William R Fairchild International Airport" },
{ code: "CLT", name: "Charlotte - Charlotte Douglas International Airport" },
{ code: "CMH", name: "Columbus - John Glenn Columbus International Airport" },
{ code: "CMI", name: "Savoy - University of Illinois Willard Airport" },
{ code: "CMX", name: "Hancock - Houghton County Memorial Airport" },
{ code: "CNM", name: "Carlsbad - Cavern City Air Terminal" },
{ code: "CNU", name: "Chanute - Chanute Martin Johnson Airport" },
{ code: "CNY", name: "Moab - Canyonlands Regional Airport" },
{ code: "COD", name: "Cody - Yellowstone Regional Airport" },
{ code: "COE", name: "Coeur d'Alene - Coeur D'Alene Airport - Pappy Boyington Field" },
{ code: "COF", name: "Cocoa Beach - Patrick Space Force Base" },
{ code: "CON", name: "Concord - Concord Municipal Airport" },
{ code: "COS", name: "Colorado Springs - City of Colorado Springs Municipal Airport" },
{ code: "COU", name: "Columbia - Columbia Regional Airport" },
{ code: "CPR", name: "Casper - Casper-Natrona County International Airport" },
{ code: "CRE", name: "North Myrtle Beach - Grand Strand Airport" },
{ code: "CRG", name: "Jacksonville - Jacksonville Executive at Craig Airport" },
{ code: "CRP", name: "Corpus Christi - Corpus Christi International Airport" },
{ code: "CLD", name: "Carlsbad - McClellan-Palomar Airport" },
{ code: "CRW", name: "Charleston - Yeager Airport" },
{ code: "CSG", name: "Columbus - Columbus Metropolitan Airport" },
{ code: "CSV", name: "Crossville - Crossville Memorial Airport Whitson Field" },
{ code: "CTB", name: "Cut Bank - Cut Bank International Airport" },
{ code: "CUB", name: "Columbia - Jim Hamilton L.B. Owens Airport" },
{ code: "CVG", name: "Cincinnati / Covington - Cincinnati Northern Kentucky International Airport" },
{ code: "CVN", name: "Clovis - Clovis Municipal Airport" },
{ code: "CVO", name: "Corvallis - Corvallis Municipal Airport" },
{ code: "CVS", name: "Clovis - Cannon Air Force Base" },
{ code: "CWA", name: "Mosinee - Central Wisconsin Airport" },
{ code: "CXO", name: "Houston - Conroe-North Houston Regional Airport" },
{ code: "CYS", name: "Cheyenne - Cheyenne Regional Jerry Olson Field" },
{ code: "DAA", name: "Fort Belvoir - Davison Army Air Field" },
{ code: "DAB", name: "Daytona Beach - Daytona Beach International Airport" },
{ code: "DAG", name: "Daggett - Barstow Daggett Airport" },
{ code: "DAL", name: "Dallas - Dallas Love Field" },
{ code: "DAN", name: "Danville - Danville Regional Airport" },
{ code: "DAY", name: "Dayton - James M Cox Dayton International Airport" },
{ code: "DBQ", name: "Dubuque - Dubuque Regional Airport" },
{ code: "DCA", name: "Washington - Ronald Reagan Washington National Airport" },
{ code: "DDC", name: "Dodge City - Dodge City Regional Airport" },
{ code: "DEC", name: "Decatur - Decatur Airport" },
{ code: "DEN", name: "Denver - Denver International Airport" },
{ code: "DET", name: "Detroit - Coleman A. Young Municipal Airport" },
{ code: "DFW", name: "Dallas-Fort Worth - Dallas Fort Worth International Airport" },
{ code: "DHN", name: "Dothan - Dothan Regional Airport" },
{ code: "DHT", name: "Dalhart - Dalhart Municipal Airport" },
{ code: "DIK", name: "Dickinson - Dickinson Theodore Roosevelt Regional Airport" },
{ code: "DLF", name: "Del Rio - Laughlin Air Force Base" },
{ code: "DLH", name: "Duluth - Duluth International Airport" },
{ code: "DLS", name: "Dallesport / The Dalles - Columbia Gorge Regional Airport" },
{ code: "DMA", name: "Tucson - Davis Monthan Air Force Base" },
{ code: "DMN", name: "Deming - Deming Municipal Airport" },
{ code: "DNL", name: "Augusta - Daniel Field" },
{ code: "DOV", name: "Dover - Dover Air Force Base" },
{ code: "DPA", name: "Chicago/West Chicago - Dupage Airport" },
{ code: "DRA", name: "Mercury - Desert Rock Airport" },
{ code: "DRI", name: "DeRidder - Beauregard Regional Airport" },
{ code: "DRO", name: "Durango - Durango La Plata County Airport" },
{ code: "DRT", name: "Del Rio - Del Rio International Airport" },
{ code: "DSM", name: "Des Moines - Des Moines International Airport" },
{ code: "DSI", name: "Destin - Destin Executive Airport" },
{ code: "DTW", name: "Detroit - Detroit Metropolitan Wayne County Airport" },
{ code: "DUA", name: "Durant - Durant Regional Airport - Eaker Field" },
{ code: "DUG", name: "Douglas Bisbee - Bisbee Douglas International Airport" },
{ code: "DUJ", name: "Dubois - DuBois Regional Airport" },
{ code: "DVL", name: "Devils Lake - Devils Lake Regional Airport" },
{ code: "DXR", name: "Danbury - Danbury Municipal Airport" },
{ code: "DYS", name: "Abilene - Dyess Air Force Base" },
{ code: "EAR", name: "Kearney - Kearney Regional Airport" },
{ code: "EAT", name: "Wenatchee - Pangborn Memorial Airport" },
{ code: "EAU", name: "Eau Claire - Chippewa Valley Regional Airport" },
{ code: "ECG", name: "Elizabeth City - Elizabeth City Regional Airport & Coast Guard Air Station" },
{ code: "ECP", name: "Panama City Beach - Northwest Florida Beaches International Airport" },
{ code: "EDW", name: "Edwards - Edwards Air Force Base" },
{ code: "EED", name: "Needles - Needles Airport" },
{ code: "EEN", name: "Keene - Dillant Hopkins Airport" },
{ code: "EFD", name: "Houston - Ellington Airport" },
{ code: "EGE", name: "Eagle - Eagle County Regional Airport" },
{ code: "EGI", name: "Crestview - Duke Field" },
{ code: "EKA", name: "Eureka - Murray Field" },
{ code: "EKN", name: "Elkins - Elkins-Randolph County Regional Airport" },
{ code: "EKO", name: "Elko - Elko Regional Airport" },
{ code: "ELD", name: "El Dorado - South Arkansas Regional Airport at Goodwin Field" },
{ code: "ELM", name: "Elmira/Corning - Elmira Corning Regional Airport" },
{ code: "LYU", name: "Ely - Ely Municipal Airport" },
{ code: "ELP", name: "El Paso - El Paso International Airport" },
{ code: "ELY", name: "Ely - Ely Airport Yelland Field" },
{ code: "END", name: "Enid - Vance Air Force Base" },
{ code: "ENV", name: "Wendover - Wendover Airport" },
{ code: "ENW", name: "Kenosha - Kenosha Regional Airport" },
{ code: "ERI", name: "Erie - Erie International Tom Ridge Field" },
{ code: "ESC", name: "Escanaba - Delta County Airport" },
{ code: "ESF", name: "Alexandria - Esler Army Airfield / Esler Regional Airport" },
{ code: "EUG", name: "Eugene - Mahlon Sweet Field" },
{ code: "EVV", name: "Evansville - Evansville Regional Airport" },
{ code: "EVW", name: "Evanston - Evanston-Uinta County Airport-Burns Field" },
{ code: "EWB", name: "New Bedford - New Bedford Regional Airport" },
{ code: "EWN", name: "New Bern - Coastal Carolina Regional Airport" },
{ code: "EWR", name: "Newark - Newark Liberty International Airport" },
{ code: "EYW", name: "Key West - Key West International Airport" },
{ code: "FAF", name: "Newport News (Fort Eustis) - Felker Army Air Field" },
{ code: "FAR", name: "Fargo - Hector International Airport" },
{ code: "FAT", name: "Fresno - Fresno Yosemite International Airport" },
{ code: "FAY", name: "Fayetteville - Fayetteville Regional Airport - Grannis Field" },
{ code: "FBG", name: "Fort Bragg - Simmons Army Air Field" },
{ code: "FCS", name: "Fort Carson - Butts AAF (Fort Carson) Air Field" },
{ code: "FDY", name: "Findlay - Findlay Airport" },
{ code: "FFO", name: "Dayton - Wright-Patterson Air Force Base" },
{ code: "FRD", name: "Friday Harbor - Friday Harbor Airport" },
{ code: "FHU", name: "Fort Huachuca / Sierra Vista - Sierra Vista Municipal Airport / Libby Army Air Field" },
{ code: "FKL", name: "Franklin - Venango Regional Airport" },
{ code: "FLG", name: "Flagstaff - Flagstaff Pulliam International Airport" },
{ code: "FLL", name: "Fort Lauderdale - Fort Lauderdale Hollywood International Airport" },
{ code: "FLO", name: "Florence - Florence Regional Airport" },
{ code: "FME", name: "Fort Meade(Odenton) - Tipton Airport" },
{ code: "FMN", name: "Farmington - Four Corners Regional Airport" },
{ code: "FMY", name: "Fort Myers - Page Field" },
{ code: "FNL", name: "Loveland - Northern Colorado Regional Airport" },
{ code: "FNT", name: "Flint - Bishop International Airport" },
{ code: "FOD", name: "Fort Dodge - Fort Dodge Regional Airport" },
{ code: "FOE", name: "Topeka - Topeka Regional Airport" },
{ code: "FPR", name: "Fort Pierce - St Lucie County International Airport" },
{ code: "FRG", name: "Farmingdale - Republic Airport" },
{ code: "FRI", name: "Fort Riley (Junction City) - Marshall Army Air Field" },
{ code: "FSD", name: "Sioux Falls - Sioux Falls Regional Airport / Joe Foss Field" },
{ code: "FSI", name: "Fort Sill - Henry Post Army Air Field" },
{ code: "FSM", name: "Fort Smith - Fort Smith Regional Airport" },
{ code: "FST", name: "Fort Stockton - Fort Stockton Pecos County Airport" },
{ code: "FTK", name: "Fort Knox - Godman Army Air Field" },
{ code: "FTW", name: "Fort Worth - Fort Worth Meacham International Airport" },
{ code: "FTY", name: "Atlanta - Fulton County Airport Brown Field" },
{ code: "FWA", name: "Fort Wayne - Fort Wayne International Airport" },
{ code: "FXE", name: "Fort Lauderdale - Fort Lauderdale Executive Airport" },
{ code: "FYV", name: "Fayetteville - Drake Field" },
{ code: "GCC", name: "Gillette - Northeast Wyoming Regional Airport" },
{ code: "GCK", name: "Garden City - Garden City Regional Airport" },
{ code: "GCN", name: "Grand Canyon - Tusayan - Grand Canyon National Park Airport" },
{ code: "GDV", name: "Glendive - Dawson Community Airport" },
{ code: "GEG", name: "Spokane - Spokane International Airport" },
{ code: "GFK", name: "Grand Forks - Grand Forks International Airport" },
{ code: "GFL", name: "Glens Falls - Floyd Bennett Memorial Airport" },
{ code: "GGG", name: "Longview - East Texas Regional Airport" },
{ code: "GGW", name: "Glasgow - Glasgow Valley County Airport Wokal Field" },
{ code: "GJT", name: "Grand Junction - Grand Junction Regional Airport" },
{ code: "GLD", name: "Goodland - Goodland Municipal Airport" },
{ code: "GLH", name: "Greenville - Mid Delta Regional Airport" },
{ code: "GLS", name: "Galveston - Scholes International At Galveston Airport" },
{ code: "GMU", name: "Greenville - Greenville Downtown Airport" },
{ code: "GNV", name: "Gainesville - Gainesville Regional Airport" },
{ code: "GON", name: "Groton - Groton New London Airport" },
{ code: "FCA", name: "Kalispell - Glacier Park International Airport" },
{ code: "GPT", name: "Gulfport - Gulfport Biloxi International Airport" },
{ code: "GRB", name: "Green Bay - Austin Straubel International Airport" },
{ code: "GRF", name: "Fort Lewis/Tacoma - Gray Army Air Field" },
{ code: "GRI", name: "Grand Island - Central Nebraska Regional Airport" },
{ code: "GRK", name: "Fort Cavazos - Killeen Regional Airport / Robert Gray Army Airfield" },
{ code: "GRR", name: "Grand Rapids - Gerald R. Ford International Airport" },
{ code: "GSB", name: "Goldsboro - Seymour Johnson Air Force Base" },
{ code: "GSO", name: "Greensboro - Piedmont Triad International Airport" },
{ code: "GSP", name: "Greer - Greenville Spartanburg International Airport" },
{ code: "GTF", name: "Great Falls - Great Falls International Airport" },
{ code: "GTR", name: "Columbus/W Point/Starkville - Golden Triangle Regional Airport" },
{ code: "GUC", name: "Gunnison - Gunnison Crested Butte Regional Airport" },
{ code: "GUP", name: "Gallup - Gallup Municipal Airport" },
{ code: "GUS", name: "Peru - Grissom Air Reserve Base" },
{ code: "GUY", name: "Guymon - Guymon Municipal Airport" },
{ code: "GWO", name: "Greenwood - Greenwoodâ€“Leflore Airport" },
{ code: "PNX", name: "Denison - North Texas Regional Airport Perrin Field" },
{ code: "GYY", name: "Gary - Gary Chicago International Airport" },
{ code: "HBG", name: "Hattiesburg - Hattiesburg Bobby L Chain Municipal Airport" },
{ code: "HBR", name: "Hobart - Hobart Regional Airport" },
{ code: "HDN", name: "Hayden - Yampa Valley Airport" },
{ code: "MNZ", name: "Manassas - Manassas Regional Airport/Harry P. Davis Field" },
{ code: "HFD", name: "Hartford - Hartford Brainard Airport" },
{ code: "HGR", name: "Hagerstown - Hagerstown Regional Richard A Henson Field" },
{ code: "HHR", name: "Hawthorne - Jack Northrop Field Hawthorne Municipal Airport" },
{ code: "HIB", name: "Hibbing - Range Regional Airport" },
{ code: "HIF", name: "Ogden - Hill Air Force Base" },
{ code: "HII", name: "Lake Havasu City - Lake Havasu City International Airport" },
{ code: "HIO", name: "Portland - Portland Hillsboro Airport" },
{ code: "HKY", name: "Hickory - Hickory Regional Airport" },
{ code: "HLG", name: "Wheeling - Wheeling Ohio County Airport" },
{ code: "HLN", name: "Helena - Helena Regional Airport" },
{ code: "HMN", name: "Alamogordo - Holloman Air Force Base" },
{ code: "HOB", name: "Hobbs - Lea County Regional Airport" },
{ code: "HON", name: "Huron - Huron Regional Airport" },
{ code: "HOP", name: "Fort Campbell - Campbell Army Airfield (Fort Campbell)" },
{ code: "HOT", name: "Hot Springs - Memorial Field Airport" },
{ code: "HOU", name: "Houston - William P Hobby Airport" },
{ code: "HPN", name: "White Plains - Westchester County Airport" },
{ code: "HQM", name: "Hoquiam - Bowerman Airport" },
{ code: "HRL", name: "Harlingen - Valley International Airport" },
{ code: "HRO", name: "Harrison - Boone County Airport" },
{ code: "HST", name: "Homestead - Homestead ARB Airport" },
{ code: "HSV", name: "Huntsville - Huntsville International Carl T Jones Field" },
{ code: "HTS", name: "Huntington - Tri-State Airport / Milton J. Ferguson Field" },
{ code: "HUA", name: "Redstone Arsnl Huntsville - Redstone Army Air Field" },
{ code: "HUF", name: "Terre Haute - Terre Haute Regional Airport, Hulman Field" },
{ code: "HUL", name: "Houlton - Houlton International Airport" },
{ code: "HUT", name: "Hutchinson - Hutchinson Municipal Airport" },
{ code: "HVN", name: "New Haven - Tweed New Haven Airport" },
{ code: "HVR", name: "Havre - Havre City County Airport" },
{ code: "HHH", name: "Hilton Head Island - Hilton Head Airport" },
{ code: "HYA", name: "Hyannis - Cape Cod Gateway Airport" },
{ code: "HYR", name: "Hayward - Sawyer County Airport" },
{ code: "HYS", name: "Hays - Hays Regional Airport" },
{ code: "JFN", name: "Ashtabula - Northeast Ohio Regional Airport" },
{ code: "IAB", name: "Wichita - McConnell Air Force Base" },
{ code: "IAD", name: "Dulles - Washington Dulles International Airport" },
{ code: "IAG", name: "Niagara Falls - Niagara Falls International Airport" },
{ code: "IAH", name: "Houston - George Bush Intercontinental Houston Airport" },
{ code: "ICT", name: "Wichita - Wichita Eisenhower National Airport" },
{ code: "IDA", name: "Idaho Falls - Idaho Falls Regional Airport" },
{ code: "IFP", name: "Bullhead City - Laughlin Bullhead International Airport" },
{ code: "IGM", name: "Kingman - Kingman Airport" },
{ code: "IKK", name: "Kankakee - Greater Kankakee Airport" },
{ code: "ILG", name: "Wilmington - Wilmington Airport" },
{ code: "ILM", name: "Wilmington - Wilmington International Airport" },
{ code: "ILN", name: "Wilmington - Wilmington Airpark" },
{ code: "IMT", name: "Kingsford - Ford Airport" },
{ code: "IND", name: "Indianapolis - Indianapolis International Airport" },
{ code: "INK", name: "Wink - Winkler County Airport" },
{ code: "INL", name: "International Falls - Falls International Airport" },
{ code: "INT", name: "Winston Salem - Smith Reynolds Airport" },
{ code: "INW", name: "Winslow - Winslow Lindbergh Regional Airport" },
{ code: "IPL", name: "Imperial - Imperial County Airport" },
{ code: "IPT", name: "Williamsport - Williamsport Regional Airport" },
{ code: "IRK", name: "Kirksville - Kirksville Regional Airport" },
{ code: "ISM", name: "Orlando - Kissimmee Gateway Airport" },
{ code: "ISO", name: "Kinston - Kinston Regional Jetport At Stallings Field" },
{ code: "ISP", name: "Islip - Long Island Mac Arthur Airport" },
{ code: "ITH", name: "Ithaca - Ithaca Tompkins Regional Airport" },
{ code: "AZA", name: "Mesa - Mesa Gateway Airport" },
{ code: "JAC", name: "Jackson - Jackson Hole Airport" },
{ code: "JAN", name: "Jackson - Jackson-Medgar Wiley Evers International Airport" },
{ code: "JAX", name: "Jacksonville - Jacksonville International Airport" },
{ code: "JBR", name: "Jonesboro - Jonesboro Municipal Airport" },
{ code: "JCT", name: "Junction - Kimble County Airport" },
{ code: "JFK", name: "New York - John F Kennedy International Airport" },
{ code: "JHW", name: "Jamestown - Chautauqua County-Jamestown Airport" },
{ code: "JLN", name: "Joplin - Joplin Regional Airport" },
{ code: "JMS", name: "Jamestown - Jamestown Regional Airport" },
{ code: "USA", name: "Concord - Concord-Padgett Regional Airport" },
{ code: "JST", name: "Johnstown - John Murtha Johnstown Cambria County Airport" },
{ code: "JXN", name: "Jackson - Jackson County Airport/Reynolds Field" },
{ code: "KLS", name: "Kelso - Southwest Washington Regional Airport" },
{ code: "LAA", name: "Lamar - Southeast Colorado Regional Airport" },
{ code: "LAF", name: "West Lafayette - Purdue University Airport" },
{ code: "LAL", name: "Lakeland - Lakeland Linder International Airport" },
{ code: "LAN", name: "Lansing - Capital City Airport" },
{ code: "LAR", name: "Laramie - Laramie Regional Airport" },
{ code: "LAS", name: "Las Vegas - Harry Reid International Airport" },
{ code: "LAW", name: "Lawton - Lawton Fort Sill Regional Airport" },
{ code: "LAX", name: "Los Angeles - Los Angeles International Airport" },
{ code: "LBB", name: "Lubbock - Lubbock Preston Smith International Airport" },
{ code: "LBE", name: "Latrobe - Arnold Palmer Regional Airport" },
{ code: "LBF", name: "North Platte - North Platte Regional Airport Lee Bird Field" },
{ code: "LBL", name: "Liberal - Liberal Mid-America Regional Airport" },
{ code: "LBT", name: "Lumberton - Lumberton Regional Airport" },
{ code: "LJN", name: "Angleton - Texas Gulf Coast Regional Airport" },
{ code: "LCH", name: "Lake Charles - Lake Charles Regional Airport" },
{ code: "LCK", name: "Columbus - Rickenbacker International Airport" },
{ code: "LEB", name: "Lebanon - Lebanon Municipal Airport" },
{ code: "LEE", name: "Leesburg - Leesburg International Airport" },
{ code: "LEX", name: "Lexington - Blue Grass Airport" },
{ code: "LFI", name: "Hampton - Langley Air Force Base" },
{ code: "LFK", name: "Lufkin - Angelina County Airport" },
{ code: "LFT", name: "Lafayette - Lafayette Regional Airport" },
{ code: "LGA", name: "New York - LaGuardia Airport" },
{ code: "LGB", name: "Long Beach - Long Beach Airport (Daugherty Field)" },
{ code: "LGU", name: "Logan - Logan-Cache Airport" },
{ code: "LIT", name: "Little Rock - Bill & Hillary Clinton National Airport/Adams Field" },
{ code: "LMT", name: "Klamath Falls - Crater Lake-Klamath Regional Airport" },
{ code: "LND", name: "Lander - Hunt Field" },
{ code: "LNK", name: "Lincoln - Lincoln Airport" },
{ code: "LNS", name: "Lancaster - Lancaster Airport" },
{ code: "LOL", name: "Lovelock - Derby Field" },
{ code: "LOU", name: "Louisville - Bowman Field" },
{ code: "LOZ", name: "London - London-Corbin Airport/Magee Field" },
{ code: "LRD", name: "Laredo - Laredo International Airport" },
{ code: "LRF", name: "Jacksonville - Little Rock Air Force Base" },
{ code: "LRU", name: "Las Cruces - Las Cruces International Airport" },
{ code: "LSE", name: "La Crosse - La Crosse Regional Airport" },
{ code: "LSF", name: "Fort Benning - Lawson Army Air Field" },
{ code: "LSV", name: "Las Vegas - Nellis Air Force Base" },
{ code: "LTS", name: "Altus - Altus Air Force Base" },
{ code: "LUF", name: "Glendale - Luke Air Force Base" },
{ code: "LUK", name: "Cincinnati - Cincinnati Municipal Airport Lunken Field" },
{ code: "LVM", name: "Livingston - Mission Field" },
{ code: "LVS", name: "Las Vegas - Las Vegas Municipal Airport" },
{ code: "LWB", name: "Lewisburg - Greenbrier Valley Airport" },
{ code: "LWM", name: "Lawrence - Lawrence Municipal Airport" },
{ code: "LWS", name: "Lewiston - Lewiston Nez Perce County Airport" },
{ code: "LWT", name: "Lewistown - Lewistown Municipal Airport" },
{ code: "LYH", name: "Lynchburg - Lynchburg Regional Airport - Preston Glenn Field" },
{ code: "MAF", name: "Midland - Midland International Air and Space Port" },
{ code: "MBG", name: "Mobridge - Mobridge Municipal Airport" },
{ code: "MBS", name: "Freeland - MBS International Airport" },
{ code: "MCB", name: "McComb - McComb-Pike County Airport / John E Lewis Field" },
{ code: "MCC", name: "Sacramento - McClellan Airfield" },
{ code: "MCE", name: "Merced - Merced Regional Macready Field" },
{ code: "MCF", name: "Tampa - MacDill Air Force Base" },
{ code: "MCI", name: "Kansas City - Kansas City International Airport" },
{ code: "MCK", name: "McCook - McCook Ben Nelson Regional Airport" },
{ code: "MCN", name: "Macon - Middle Georgia Regional Airport" },
{ code: "MCO", name: "Orlando - Orlando International Airport" },
{ code: "MCW", name: "Mason City - Mason City Municipal Airport" },
{ code: "MDH", name: "Murphysboro - Southern Illinois Airport" },
{ code: "MDT", name: "Harrisburg - Harrisburg International Airport" },
{ code: "MDW", name: "Chicago - Chicago Midway International Airport" },
{ code: "MEI", name: "Meridian - Key Field / Meridian Regional Airport" },
{ code: "MEM", name: "Memphis - Memphis International Airport" },
{ code: "MER", name: "Merced - Castle Airport" },
{ code: "MFD", name: "Mansfield - Mansfield Lahm Regional Airport" },
{ code: "MFE", name: "McAllen - McAllen Miller International Airport" },
{ code: "MFR", name: "Medford - Rogue Valley International Medford Airport" },
{ code: "MGE", name: "Marietta - Dobbins Air Reserve Base" },
{ code: "MGM", name: "Montgomery - Montgomery Regional (Dannelly Field) Airport" },
{ code: "MGW", name: "Morgantown - Morgantown Municipal Airport Walter L. (Bill) Hart Field" },
{ code: "MHK", name: "Manhattan - Manhattan Regional Airport" },
{ code: "MHR", name: "Sacramento - Sacramento Mather Airport" },
{ code: "MHT", name: "Manchester - Manchester-Boston Regional Airport" },
{ code: "MIA", name: "Miami - Miami International Airport" },
{ code: "MIB", name: "Minot - Minot Air Force Base" },
{ code: "MIE", name: "Muncie - Delaware County Johnson Field" },
{ code: "MIV", name: "Millville - Millville Municipal Airport" },
{ code: "MKC", name: "Kansas City - Charles B. Wheeler Downtown Airport" },
{ code: "MKE", name: "Milwaukee - General Mitchell International Airport" },
{ code: "MKG", name: "Muskegon - Muskegon County Airport" },
{ code: "MKL", name: "Jackson - McKellar-Sipes Regional Airport" },
{ code: "MLB", name: "Melbourne - Melbourne Orlando International Airport" },
{ code: "MLC", name: "Mc Alester - Mc Alester Regional Airport" },
{ code: "MLI", name: "Moline - Quad City International Airport" },
{ code: "MLS", name: "Miles City - Miles City Airport - Frank Wiley Field" },
{ code: "MLU", name: "Monroe - Monroe Regional Airport" },
{ code: "MMT", name: "Eastover - Mc Entire Joint National Guard Base" },
{ code: "MMU", name: "Morristown - Morristown Municipal Airport" },
{ code: "MOB", name: "Mobile - Mobile Regional Airport" },
{ code: "MOD", name: "Modesto - Modesto City Co-Harry Sham Field" },
{ code: "MOT", name: "Minot - Minot International Airport" },
{ code: "MPV", name: "Barre/Montpelier - Edward F Knapp State Airport" },
{ code: "MQY", name: "Smyrna - Smyrna Airport" },
{ code: "MRB", name: "Martinsburg - Eastern WV Regional Airport/Shepherd Field" },
{ code: "MRY", name: "Monterey - Monterey Peninsula Airport" },
{ code: "MSL", name: "Muscle Shoals - Northwest Alabama Regional Airport" },
{ code: "MSN", name: "Madison - Dane County Regional Truax Field" },
{ code: "MSO", name: "Missoula - Missoula International Airport" },
{ code: "MSP", name: "Minneapolis - Minneapolisâ€“Saint Paul International Airport / Woldâ€“Chamberlain Field" },
{ code: "MSS", name: "Massena - Massena International Airport Richards Field" },
{ code: "MSY", name: "New Orleans - Louis Armstrong New Orleans International Airport" },
{ code: "MTC", name: "Mount Clemens - Selfridge Air National Guard Base Airport" },
{ code: "MTH", name: "Marathon - The Florida Keys Marathon Airport" },
{ code: "MTJ", name: "Montrose - Montrose Regional Airport" },
{ code: "MTN", name: "Baltimore - Martin State Airport" },
{ code: "MUI", name: "Fort Indiantown Gap(Annville) - Muir Army Air Field (Fort Indiantown Gap) Airport" },
{ code: "MUO", name: "Mountain Home - Mountain Home Air Force Base" },
{ code: "MWA", name: "Marion - Veterans Airport of Southern Illinois" },
{ code: "MWH", name: "Moses Lake - Grant County International Airport" },
{ code: "MXF", name: "Montgomery - Maxwell Air Force Base" },
{ code: "MYL", name: "McCall - McCall Municipal Airport" },
{ code: "MYR", name: "Myrtle Beach - Myrtle Beach International Airport" },
{ code: "MYV", name: "Marysville - Yuba County Airport" },
{ code: "NBG", name: "New Orleans - New Orleans NAS JRB/Alvin Callender Field" },
{ code: "NEL", name: "Lakehurst - Lakehurst Maxfield Field Airport" },
{ code: "NEW", name: "New Orleans - Lakefront Airport" },
{ code: "NFL", name: "Fallon - Fallon Naval Air Station" },
{ code: "FWH", name: "Fort Worth - NAS Fort Worth JRB / Carswell Field" },
{ code: "NGP", name: "Corpus Christi - Naval Air Station Corpus Christi Truax Field" },
{ code: "NGU", name: "Norfolk - Norfolk Naval Station (Chambers Field)" },
{ code: "NHK", name: "Patuxent River - Patuxent River Naval Air Station (Trapnell Field)" },
{ code: "NIP", name: "Jacksonville - Jacksonville Naval Air Station (Towers Field)" },
{ code: "NJK", name: "El Centro - El Centro NAF Airport (Vraciu Field)" },
{ code: "NKX", name: "San Diego - Miramar Marine Corps Air Station - Mitscher Field" },
{ code: "NLC", name: "Lemoore - Lemoore Naval Air Station (Reeves Field) Airport" },
{ code: "NPA", name: "Pensacola - Naval Air Station Pensacola Forrest Sherman Field" },
{ code: "NQA", name: "Millington - Millington-Memphis Airport" },
{ code: "NQI", name: "Kingsville - Kingsville Naval Air Station" },
{ code: "NQX", name: "Key West - Naval Air Station Key West/Boca Chica Field" },
{ code: "NRB", name: "Jacksonville - Naval Station Mayport / Admiral David L McDonald Field" },
{ code: "NSE", name: "Milton - Whiting Field Naval Air Station - North" },
{ code: "NTD", name: "Point Mugu - Point Mugu Naval Air Station (Naval Base Ventura Co)" },
{ code: "NTU", name: "Virginia Beach - Oceana Naval Air Station" },
{ code: "NUQ", name: "Mountain View - Moffett Federal Airfield" },
{ code: "NUW", name: "Oak Harbor - Whidbey Island Naval Air Station (Ault Field)" },
{ code: "NYG", name: "Quantico - Quantico Marine Corps Airfield / Turner Field" },
{ code: "YUM", name: "Yuma - Yuma International Airport / Marine Corps Air Station Yuma" },
{ code: "NZY", name: "San Diego - North Island Naval Air Station-Halsey Field" },
{ code: "OAJ", name: "Richlands - Albert J Ellis Airport" },
{ code: "OAK", name: "Oakland - San Francisco Bay Oakland International Airport" },
{ code: "OFF", name: "Omaha - Offutt Air Force Base" },
{ code: "OFK", name: "Norfolk - Karl Stefan Memorial Airport" },
{ code: "OGB", name: "Orangeburg - Orangeburg Municipal Airport" },
{ code: "OGD", name: "Ogden - Ogden Hinckley Airport" },
{ code: "OGS", name: "Ogdensburg - Ogdensburg International Airport" },
{ code: "OKC", name: "Oklahoma City - Will Rogers World Airport" },
{ code: "OLF", name: "Wolf Point - L M Clayton Airport" },
{ code: "OLM", name: "Olympia - Olympia Regional Airport" },
{ code: "OLS", name: "Nogales - Nogales International Airport" },
{ code: "OLU", name: "Columbus - Columbus Municipal Airport" },
{ code: "OMA", name: "Omaha - Eppley Airfield" },
{ code: "ONO", name: "Oregon - Ontario Municipal Airport" },
{ code: "ONP", name: "Newport - Newport Municipal Airport" },
{ code: "ONT", name: "Ontario - Ontario International Airport" },
{ code: "OPF", name: "Miami - Miami-Opa Locka Executive Airport" },
{ code: "NCO", name: "North Kingstown - Quonset State Airport" },
{ code: "ORD", name: "Chicago - Chicago O'Hare International Airport" },
{ code: "ORF", name: "Norfolk - Norfolk International Airport" },
{ code: "ORH", name: "Worcester - Worcester Regional Airport" },
{ code: "ESD", name: "Eastsound - Orcas Island Airport" },
{ code: "OSH", name: "Oshkosh - Wittman Regional Airport" },
{ code: "OSU", name: "Columbus - The Ohio State University Airport - Don Scott Field" },
{ code: "OTH", name: "North Bend - Southwest Oregon Regional Airport" },
{ code: "OTM", name: "Ottumwa - Ottumwa Regional Airport" },
{ code: "OWB", name: "Owensboro - Owensboro Daviess County Airport" },
{ code: "OWD", name: "Norwood - Norwood Memorial Airport" },
{ code: "OXR", name: "Oxnard - Oxnard Airport" },
{ code: "OZR", name: "Fort Rucker/Ozark - Cairns AAF (Fort Rucker) Air Field" },
{ code: "PAE", name: "Everett - Seattle Paine Field International Airport" },
{ code: "PAH", name: "Paducah - Barkley Regional Airport" },
{ code: "PAM", name: "Panama City - Tyndall Air Force Base" },
{ code: "PAO", name: "Palo Alto - Palo Alto Airport" },
{ code: "PBF", name: "Pine Bluff - Pine Bluff Regional Airport, Grider Field" },
{ code: "PBG", name: "Plattsburgh - Plattsburgh International Airport" },
{ code: "PBI", name: "West Palm Beach - Palm Beach International Airport" },
{ code: "PDK", name: "Atlanta - DeKalb Peachtree Airport" },
{ code: "PDT", name: "Pendleton - Eastern Oregon Regional Airport at Pendleton" },
{ code: "PDX", name: "Portland - Portland International Airport" },
{ code: "PGA", name: "Page - Page Municipal Airport" },
{ code: "PGD", name: "Punta Gorda - Punta Gorda Airport" },
{ code: "PGV", name: "Greenville - Pitt-Greenville Airport" },
{ code: "PHF", name: "Newport News - Newport News Williamsburg International Airport" },
{ code: "PHL", name: "Philadelphia - Philadelphia International Airport" },
{ code: "PHX", name: "Phoenix - Phoenix Sky Harbor International Airport" },
{ code: "PIA", name: "Peoria - General Wayne A. Downing Peoria International Airport" },
{ code: "PIB", name: "Moselle - Hattiesburg Laurel Regional Airport" },
{ code: "PIE", name: "Pinellas Park - St. Petersburg Clearwater International Airport" },
{ code: "PIH", name: "Pocatello - Pocatello Regional Airport" },
{ code: "PIR", name: "Pierre - Pierre Regional Airport" },
{ code: "PIT", name: "Pittsburgh - Pittsburgh International Airport" },
{ code: "PKB", name: "Parkersburg (Williamstown) - Mid Ohio Valley Regional Airport" },
{ code: "PLN", name: "Pellston - Pellston Regional Airport of Emmet County Airport" },
{ code: "PMD", name: "Palmdale - Palmdale Regional Airport / USAF Plant 42 Airport" },
{ code: "PWY", name: "Pinedale - Ralph Wenz Field" },
{ code: "PNC", name: "Ponca City - Ponca City Regional Airport" },
{ code: "PNE", name: "Philadelphia - Northeast Philadelphia Airport" },
{ code: "PNS", name: "Pensacola - Pensacola International Airport" },
{ code: "POB", name: "Fort Bragg - Pope Field" },
{ code: "POE", name: "Fort Polk - Polk Army Air Field" },
{ code: "POU", name: "Poughkeepsie - Dutchess County Airport" },
{ code: "PQI", name: "Presque Isle - Presque Isle International Airport" },
{ code: "PRB", name: "Paso Robles - Paso Robles Municipal Airport" },
{ code: "PRC", name: "Prescott - Prescott International Airport - Ernest A. Love Field" },
{ code: "PRX", name: "Paris - Cox Field" },
{ code: "PSC", name: "Pasco - Tri Cities Airport" },
{ code: "PSM", name: "Portsmouth - Portsmouth International at Pease Airport" },
{ code: "PSP", name: "Palm Springs - Palm Springs International Airport" },
{ code: "PTK", name: "Pontiac - Oakland County International Airport" },
{ code: "PUB", name: "Pueblo - Pueblo Memorial Airport" },
{ code: "PUW", name: "Pullman - Pullman-Moscow Regional Airport" },
{ code: "PVD", name: "Warwick - Theodore Francis Green State Airport" },
{ code: "PVU", name: "Provo - Provo-Utah Lake International Airport" },
{ code: "PWK", name: "Chicago/Prospect Heights/Wheeling - Chicago Executive Airport" },
{ code: "PWM", name: "Portland - Portland International Jetport" },
{ code: "PWT", name: "Bremerton - Bremerton National Airport" },
{ code: "RAL", name: "Riverside - Riverside Municipal Airport" },
{ code: "RAP", name: "Rapid City - Rapid City Regional Airport" },
{ code: "RBL", name: "Red Bluff - Red Bluff Municipal Airport" },
{ code: "RCA", name: "Rapid City - Ellsworth Air Force Base" },
{ code: "RDD", name: "Redding - Redding Municipal Airport" },
{ code: "RDG", name: "Reading - Reading Regional Airport (Carl A Spaatz Field)" },
{ code: "RDM", name: "Redmond - Roberts Field" },
{ code: "RDR", name: "Grand Forks - Grand Forks Air Force Base" },
{ code: "RDU", name: "Raleigh/Durham - Raleigh Durham International Airport" },
{ code: "RFD", name: "Chicago/Rockford - Chicago Rockford International Airport" },
{ code: "RHI", name: "Rhinelander - Rhinelander Oneida County Airport" },
{ code: "RIC", name: "Richmond - Richmond International Airport" },
{ code: "RIL", name: "Rifle - Garfield County Regional Airport" },
{ code: "RIV", name: "Riverside - March Air Reserve Base" },
{ code: "RIW", name: "Riverton - Central Wyoming Regional Airport" },
{ code: "RKD", name: "Rockland - Knox County Regional Airport" },
{ code: "RKS", name: "Rock Springs - Southwest Wyoming Regional Airport" },
{ code: "RME", name: "Rome - Griffiss International Airport" },
{ code: "RMG", name: "Rome - Richard B Russell Airport" },
{ code: "RND", name: "Universal City - Randolph Air Force Base" },
{ code: "RNH", name: "New Richmond - New Richmond Regional Airport" },
{ code: "RNO", name: "Reno - Reno Tahoe International Airport" },
{ code: "ROA", name: "Roanoke - Roanokeâ€“Blacksburg Regional Airport" },
{ code: "ROC", name: "Rochester - Frederick Douglass Greater Rochester International Airport" },
{ code: "ROW", name: "Roswell - Roswell Air Center Airport" },
{ code: "RSL", name: "Russell - Russell Municipal Airport" },
{ code: "RST", name: "Rochester - Rochester International Airport" },
{ code: "RSW", name: "Fort Myers - Southwest Florida International Airport" },
{ code: "RUT", name: "Rutland - Rutland - Southern Vermont Regional Airport" },
{ code: "RVS", name: "Tulsa - Tulsa Riverside Airport" },
{ code: "RWF", name: "Redwood Falls - Redwood Falls Municipal Airport" },
{ code: "RWI", name: "Rocky Mount - Rocky Mount Wilson Regional Airport" },
{ code: "RWL", name: "Rawlins - Rawlins Municipal Airport/Harvey Field" },
{ code: "SAC", name: "Sacramento - Sacramento Executive Airport" },
{ code: "SAF", name: "Santa Fe - Santa Fe Municipal Airport" },
{ code: "SAN", name: "San Diego - San Diego International Airport" },
{ code: "SAT", name: "San Antonio - San Antonio International Airport" },
{ code: "SAV", name: "Savannah - Savannah Hilton Head International Airport" },
{ code: "MQT", name: "Gwinn - Marquette/Sawyer International Airport" },
{ code: "SBA", name: "Santa Barbara - Santa Barbara Municipal Airport" },
{ code: "SBD", name: "San Bernardino - San Bernardino International Airport" },
{ code: "SBN", name: "South Bend - South Bend Regional Airport" },
{ code: "SBP", name: "San Luis Obispo - San Luis County Regional Airport" },
{ code: "SBY", name: "Salisbury - Salisbury Ocean City Wicomico Regional Airport" },
{ code: "SCH", name: "Schenectady - Schenectady County Airport" },
{ code: "SCK", name: "Stockton - Stockton Metropolitan Airport" },
{ code: "SDF", name: "Louisville - Louisville Muhammad Ali International Airport" },
{ code: "SDM", name: "San Diego - Brown Field Municipal Airport" },
{ code: "SDY", name: "Sidney - Sidney - Richland Regional Airport" },
{ code: "SEA", name: "Seattle - Seattleâ€“Tacoma International Airport" },
{ code: "SFB", name: "Orlando - Orlando Sanford International Airport" },
{ code: "SFF", name: "Spokane - Felts Field" },
{ code: "SFO", name: "San Francisco - San Francisco International Airport" },
{ code: "SGF", name: "Springfield - Springfield Branson National Airport" },
{ code: "SGH", name: "Springfield - Springfield-Beckley Municipal Airport" },
{ code: "UST", name: "St Augustine - Northeast Florida Regional Airport" },
{ code: "SGR", name: "Houston - Sugar Land Regional Airport" },
{ code: "SGU", name: "St George - St George Regional Airport" },
{ code: "SHD", name: "Weyers Cave - Shenandoah Valley Regional Airport" },
{ code: "SHR", name: "Sheridan - Sheridan County Airport" },
{ code: "SHV", name: "Shreveport - Shreveport Regional Airport" },
{ code: "SJC", name: "San Jose - Norman Y. Mineta San Jose International Airport" },
{ code: "SJT", name: "San Angelo - San Angelo Regional Mathis Field" },
{ code: "SKA", name: "Spokane - Fairchild Air Force Base" },
{ code: "SKF", name: "San Antonio - Lackland Air Force Base" },
{ code: "TSM", name: "Taos - Taos Regional Airport" },
{ code: "SLC", name: "Salt Lake City - Salt Lake City International Airport" },
{ code: "SLE", name: "Salem - Salem-Willamette Valley Airport/McNary Field" },
{ code: "SLK", name: "Saranac Lake - Adirondack Regional Airport" },
{ code: "SLN", name: "Salina - Salina Municipal Airport" },
{ code: "SME", name: "Somerset - Lake Cumberland Regional Airport" },
{ code: "SMF", name: "Sacramento - Sacramento International Airport" },
{ code: "SMN", name: "Salmon - Lemhi County Airport" },
{ code: "SMO", name: "Santa Monica - Santa Monica Municipal Airport" },
{ code: "SMX", name: "Santa Maria - Santa Maria Public Airport Captain G Allan Hancock Field" },
{ code: "SNA", name: "Santa Ana - John Wayne Orange County International Airport" },
{ code: "SNS", name: "Salinas - Salinas Municipal Airport" },
{ code: "SNY", name: "Sidney - Sidney Municipal Airport Lloyd W Carr Field" },
{ code: "SOW", name: "Show Low - Show Low Regional Airport" },
{ code: "SPI", name: "Springfield - Abraham Lincoln Capital Airport" },
{ code: "SPS", name: "Wichita Falls - Wichita Falls Municipal Airport / Sheppard Air Force Base" },
{ code: "SQL", name: "San Carlos - San Carlos Airport" },
{ code: "SRQ", name: "Sarasota/Bradenton - Sarasota Bradenton International Airport" },
{ code: "RUI", name: "Alto - Sierra Blanca Regional Airport" },
{ code: "SSC", name: "Sumter - Shaw Air Force Base" },
{ code: "SSF", name: "San Antonio - Stinson Municipal Airport" },
{ code: "SSI", name: "St Simons Island - St Simons Island Airport" },
{ code: "STC", name: "Saint Cloud - Saint Cloud Regional Airport" },
{ code: "STJ", name: "St Joseph - Rosecrans Memorial Airport" },
{ code: "STL", name: "St Louis - St. Louis Lambert International Airport" },
{ code: "STP", name: "Saint Paul - Saint Paul Downtown Holman Field" },
{ code: "STS", name: "Santa Rosa - Charles M. Schulz Sonoma County Airport" },
{ code: "SUN", name: "Hailey - Friedman Memorial Airport" },
{ code: "SUS", name: "St Louis - Spirit of St Louis Airport" },
{ code: "SUU", name: "Fairfield - Travis Air Force Base" },
{ code: "SUX", name: "Sioux City - Sioux Gateway Airport / Brigadier General Bud Day Field" },
{ code: "SVC", name: "Silver City - Grant County Airport" },
{ code: "SVN", name: "Savannah - Hunter Army Air Field" },
{ code: "SWF", name: "Newburgh - New York Stewart International Airport" },
{ code: "SWO", name: "Stillwater - Stillwater Regional Airport" },
{ code: "SYR", name: "Syracuse - Syracuse Hancock International Airport" },
{ code: "SZL", name: "Knob Noster - Whiteman Air Force Base" },
{ code: "TBN", name: "Fort Leonard Wood - Waynesville-St. Robert Regional Airport-Forney Field" },
{ code: "TCC", name: "Tucumcari - Tucumcari Municipal Airport" },
{ code: "TCL", name: "Tuscaloosa - Tuscaloosa National Airport" },
{ code: "TCM", name: "Tacoma - McChord Air Force Base" },
{ code: "TCS", name: "Truth or Consequences - Truth or Consequences Municipal Airport" },
{ code: "TEB", name: "Teterboro - Teterboro Airport" },
{ code: "TEX", name: "Telluride - Telluride Regional Airport" },
{ code: "TIK", name: "Oklahoma City - Tinker Air Force Base" },
{ code: "TIW", name: "Tacoma - Tacoma Narrows Airport" },
{ code: "TIX", name: "Titusville - Space Coast Regional Airport" },
{ code: "TLH", name: "Tallahassee - Tallahassee Regional Airport" },
{ code: "TMB", name: "Miami - Miami Executive Airport" },
{ code: "TOI", name: "Troy - Troy Municipal Airport at N Kenneth Campbell Field" },
{ code: "TOL", name: "Toledo - Eugene F. Kranz Toledo Express Airport" },
{ code: "TOP", name: "Topeka - Philip Billard Municipal Airport" },
{ code: "TPA", name: "Tampa - Tampa International Airport" },
{ code: "TPH", name: "Tonopah - Tonopah Airport" },
{ code: "TPL", name: "Temple - Draughon Miller Central Texas Regional Airport" },
{ code: "TRI", name: "Blountville - Tri-Cities Regional TN/VA Airport" },
{ code: "TKF", name: "Truckee - Truckee Tahoe Airport" },
{ code: "TRM", name: "Palm Springs - Jacqueline Cochran Regional Airport" },
{ code: "TTD", name: "Portland - Portland Troutdale Airport" },
{ code: "TTN", name: "Ewing Township - Trenton Mercer Airport" },
{ code: "TUL", name: "Tulsa - Tulsa International Airport" },
{ code: "TUP", name: "Tupelo - Tupelo Regional Airport" },
{ code: "TUS", name: "Tucson - Tucson International Airport / Morris Air National Guard Base" },
{ code: "TVC", name: "Traverse City - Cherry Capital Airport" },
{ code: "TVF", name: "Thief River Falls - Thief River Falls Regional Airport" },
{ code: "TVL", name: "South Lake Tahoe - Lake Tahoe Airport" },
{ code: "TWF", name: "Twin Falls - Joslin Field Magic Valley Regional Airport" },
{ code: "TXK", name: "Texarkana - Texarkana Regional Airport (Webb Field)" },
{ code: "TYR", name: "Tyler - Tyler Pounds Regional Airport" },
{ code: "TYS", name: "Alcoa - McGhee Tyson Airport" },
{ code: "UIN", name: "Quincy - Quincy Regional Airport Baldwin Field" },
{ code: "UKI", name: "Ukiah - Ukiah Municipal Airport" },
{ code: "SCE", name: "State College - State College Regional Airport" },
{ code: "UOX", name: "Oxford - University Oxford Airport" },
{ code: "HTV", name: "Huntsville - Huntsville Regional Airport" },
{ code: "VAD", name: "Valdosta - Moody Air Force Base" },
{ code: "VBG", name: "Lompoc - Vandenberg Space Force Base" },
{ code: "VCT", name: "Victoria - Victoria Regional Airport" },
{ code: "VEL", name: "Vernal - Vernal Regional Airport" },
{ code: "VGT", name: "Las Vegas - North Las Vegas Metropolitan International Airport" },
{ code: "VIS", name: "Visalia - Visalia Municipal Airport" },
{ code: "VLD", name: "Valdosta - Valdosta Regional Airport" },
{ code: "VNY", name: "Van Nuys - Van Nuys Airport" },
{ code: "VOK", name: "Camp Douglas - Volk Field" },
{ code: "VPS", name: "Valparaiso - Destin-Fort Walton Beach Airport" },
{ code: "VPZ", name: "Valparaiso - Porter County Municipal Airport" },
{ code: "VQQ", name: "Jacksonville - Cecil Airport" },
{ code: "VRB", name: "Vero Beach - Vero Beach Regional Airport" },
{ code: "VTN", name: "Valentine - Miller Field" },
{ code: "WJF", name: "Lancaster - General William J Fox Airfield" },
{ code: "WMC", name: "Winnemucca - Winnemucca Municipal Airport" },
{ code: "WRB", name: "Warner Robins - Robins Air Force Base" },
{ code: "WRI", name: "Wrightstown - Mc Guire Air Force Base" },
{ code: "WRL", name: "Worland - Worland Municipal Airport" },
{ code: "WST", name: "Westerly - Westerly State Airport" },
{ code: "WWD", name: "Wildwood - Cape May County Airport" },
{ code: "WWR", name: "Woodward - West Woodward Airport" },
{ code: "KWY", name: "Kiwayu - Kiwayu Airport" },
{ code: "WYS", name: "West Yellowstone - Yellowstone Airport" },
{ code: "XNA", name: "Fayetteville/Springdale/Rogers - Northwest Arkansas National Airport" },
{ code: "XWA", name: "Williston - Williston Basin International Airport" },
{ code: "YIP", name: "Detroit - Willow Run Airport" },
{ code: "YKM", name: "Yakima - Yakima Air Terminal McAllister Field" },
{ code: "YKN", name: "Yankton - Chan Gurney Municipal Airport" },
{ code: "YNG", name: "Youngstown/Warren - Youngstown Warren Regional Airport" },
{ code: "ZZV", name: "Zanesville - Zanesville Municipal Airport" },
{ code: "BOR", name: "Ton Phueng - Bokeo International Airport" },
{ code: "KFZ", name: "KukÃ«s - KukÃ«s International Airport" },
{ code: "TIA", name: "Rinas - Tirana International Airport Mother Teresa" },
{ code: "BOJ", name: "Burgas - Burgas Airport" },
{ code: "GOZ", name: "Gorna Oryahovitsa - Gorna Oryahovitsa Airport" },
{ code: "PDV", name: "Plovdiv - Plovdiv International Airport" },
{ code: "SOF", name: "Sofia - Sofia Airport" },
{ code: "VAR", name: "Varna - Varna Airport" },
{ code: "ECN", name: "Tymbou (Kirklar) - Nicosia (LefkoÅŸa) Ercan International Airport" },
{ code: "GEC", name: "Lefkoniko (GeÃ§itkale) - Lefkoniko Airport / GeÃ§itkale Air Base" },
{ code: "LCA", name: "Larnaca - Larnaca International Airport" },
{ code: "PFO", name: "Paphos - Paphos International Airport" },
{ code: "AKT", name: "Akrotiri - RAF Akrotiri" },
{ code: "DBV", name: "ÄŒilipi - Dubrovnik RuÄ‘er BoÅ¡koviÄ‡ Airport" },
{ code: "OSI", name: "Klisa - Osijek Airport" },
{ code: "PUY", name: "Pula - Pula Airport" },
{ code: "RJK", name: "OmiÅ¡alj - Rijeka Airport" },
{ code: "BWK", name: "Gornji Humac - BraÄ Airport" },
{ code: "SPU", name: "KaÅ¡tel Å tafiliÄ‡ - Split Airport" },
{ code: "ZAG", name: "Velika Gorica - Zagreb Franjo TuÄ‘man International Airport" },
{ code: "ZAD", name: "Zemunik Donji (Zadar) - Zadar Airport" },
{ code: "ABC", name: "Albacete - Albacete Airport / Los Llanos Air Base" },
{ code: "ALC", name: "Alicante - Alicante-Elche Miguel HernÃ¡ndez Airport" },
{ code: "LEI", name: "AlmerÃ­a - AlmerÃ­a Airport" },
{ code: "OVD", name: "RanÃ³n - Asturias Airport" },
{ code: "ODB", name: "CÃ³rdoba - CÃ³rdoba Airport" },
{ code: "BIO", name: "Bilbao - Bilbao Airport" },
{ code: "RGS", name: "Burgos - Burgos Airport" },
{ code: "BCN", name: "Barcelona - Josep Tarradellas Barcelona-El Prat Airport" },
{ code: "BJZ", name: "Badajoz - Badajoz Airport" },
{ code: "CDT", name: "CastellÃ³n de la Plana - CastellÃ³n-Costa Azahar Airport" },
{ code: "LCG", name: "Culleredo - A CoruÃ±a Airport" },
{ code: "ILD", name: "Lleida - Lleida-Alguaire Airport" },
{ code: "GRO", name: "Girona - Girona-Costa Brava Airport" },
{ code: "GRX", name: "Granada - F.G.L. Airport Granada-JaÃ©n Airport" },
{ code: "IBZ", name: "Ibiza (Eivissa) - Ibiza Airport" },
{ code: "XRY", name: "Jerez de la Frontera - Jerez Airport" },
{ code: "LEN", name: "La Virgen Del Camino - LeÃ³n Int'l Airport" },
{ code: "RJL", name: "LogroÃ±o - LogroÃ±o-Agoncillo Airport" },
{ code: "MAD", name: "Madrid - Adolfo SuÃ¡rez Madridâ€“Barajas Airport" },
{ code: "AGP", name: "MÃ¡laga - MÃ¡laga-Costa del Sol Airport" },
{ code: "MAH", name: "MahÃ³n (MaÃ³) - Menorca Airport" },
{ code: "RMU", name: "Corvera - RegiÃ³n de Murcia International Airport" },
{ code: "OZP", name: "MorÃ³n - Moron Air Base" },
{ code: "PMI", name: "Palma de Mallorca - Palma de Mallorca Airport" },
{ code: "PNA", name: "Pamplona - Pamplona Airport" },
{ code: "CQM", name: "Ciudad Real - Ciudad Real International Airport" },
{ code: "REU", name: "Reus - Reus Airport" },
{ code: "ROZ", name: "Rota - Rota Naval Station Airport" },
{ code: "SLM", name: "Salamanca - Salamanca Airport" },
{ code: "EAS", name: "Hondarribia - San SebastiÃ¡n Airport" },
{ code: "SCQ", name: "Santiago de Compostela - Santiago-RosalÃ­a de Castro Airport" },
{ code: "TEV", name: "Teruel - Teruel Airport" },
{ code: "TOJ", name: "Madrid - Madridâ€“TorrejÃ³n Airport / TorrejÃ³n Air Base" },
{ code: "VLC", name: "Valencia - Valencia Airport" },
{ code: "VLL", name: "Valladolid - Valladolid Airport" },
{ code: "VIT", name: "Alava - Vitoria Airport" },
{ code: "VGO", name: "Vigo - Vigo Airport" },
{ code: "SDR", name: "Santander - Seve Ballesteros-Santander Airport" },
{ code: "ZAZ", name: "Zaragoza - Zaragoza Airport" },
{ code: "SVQ", name: "Sevilla - Sevilla Airport" },
{ code: "CQF", name: "Marck - Calais-Dunkerque Airport" },
{ code: "LTQ", name: "Le Touquet-Paris-Plage - Le Touquet-CÃ´te d'Opale Airport" },
{ code: "AGF", name: "Agen/La Garenne - Agen-La Garenne Airport" },
{ code: "BOD", name: "Bordeaux/MÃ©rignac - Bordeaux-MÃ©rignac Airport" },
{ code: "EGC", name: "Bergerac/RoumaniÃ¨re - Bergerac Dordogne PÃ©rigord Airport" },
{ code: "CNG", name: "Cognac/ChÃ¢teaubernard - Cognac-ChÃ¢teaubernard (BA 709) Air Base" },
{ code: "LRH", name: "La Rochelle/ÃŽle de RÃ© - La Rochelle-ÃŽle de RÃ© Airport" },
{ code: "PIS", name: "Poitiers/Biard - Poitiers-Biard Airport" },
{ code: "MCU", name: "LÃ©paud, Creuse - MontluÃ§on-GuÃ©ret Airport" },
{ code: "LIG", name: "Limoges/Bellegarde - Limoges Airport" },
{ code: "NIT", name: "Niort/SouchÃ© - Niort - Marais Poitevin Airport" },
{ code: "TLS", name: "Toulouse/Blagnac - Toulouse-Blagnac Airport" },
{ code: "PUF", name: "Pau/PyrÃ©nÃ©es (Uzein) - Pau PyrÃ©nÃ©es Airport" },
{ code: "LDE", name: "Tarbes/Lourdes/PyrÃ©nÃ©es - Tarbes-Lourdes-PyrÃ©nÃ©es Airport" },
{ code: "ANG", name: "AngoulÃªme/Brie/Champniers - AngoulÃªme-Brie-Champniers Airport" },
{ code: "PGX", name: "PÃ©rigueux/Bassillac - PÃ©rigueux-Bassillac Airport" },
{ code: "BIQ", name: "Biarritz/Anglet/Bayonne - Biarritz-Anglet-Bayonne Airport" },
{ code: "ZAO", name: "Cahors/Lalbenque - AÃ©rodrome de Cahors-Lalbenque" },
{ code: "LBI", name: "Albi/Le SÃ©questre - Albi-Le SÃ©questre Airport" },
{ code: "DCM", name: "Castres/Mazamet - Castres-Mazamet Airport" },
{ code: "RDZ", name: "Rodez/Marcillac - Rodezâ€“Aveyron Airport" },
{ code: "RYN", name: "Royan/MÃ©dis - Royan-MÃ©dis Airport" },
{ code: "RCO", name: "Rochefort/Saint-Agnant - Rochefort-Saint-Agnant (BA 721) Airport" },
{ code: "CMR", name: "Colmar, Haut-Rhin - Colmar-Houssen Airport" },
{ code: "DLE", name: "Tavaux, Jura - Dole-Jura Airport" },
{ code: "OBS", name: "Lanas, ArdÃ¨che - Aubenas-South ArdÃ¨che Airport" },
{ code: "ETZ", name: "Goin - Metz-Nancy-Lorraine Airport" },
{ code: "ANE", name: "MarcÃ©, Maine-et-Loire - Angers-Loire Airport" },
{ code: "BIA", name: "Bastia/Poretta - Bastia-Poretta Airport" },
{ code: "CLY", name: "Calvi/Sainte-Catherine - Calvi-Sainte-Catherine Airport" },
{ code: "FSC", name: "Figari Sud-Corse - Figari Sud-Corse Airport" },
{ code: "AJA", name: "Ajaccio/NapolÃ©on Bonaparte - Ajaccio-NapolÃ©on Bonaparte Airport" },
{ code: "SOZ", name: "Solenzara - Solenzara (BA 126) Air Base" },
{ code: "AUF", name: "Appoigny, Yonne - Auxerre-Branches Airport" },
{ code: "CMF", name: "Viviers-du-Lac - ChambÃ©ry Savoie Mont Blanc Airport" },
{ code: "CFE", name: "Aulnat, Puy-de-DÃ´me - Clermont-Ferrand Auvergne Airport" },
{ code: "BOU", name: "Bourges, Cher - Bourges Airport" },
{ code: "LYS", name: "Colombier-Saugnieu, RhÃ´ne - Lyon Saint-ExupÃ©ry Airport" },
{ code: "SYT", name: "L'HÃ´pital-le-Mercier, SaÃ´ne-et-Loire - Saint-Yan Airport" },
{ code: "RNE", name: "Saint-LÃ©ger-sur-Roanne - Roanne-Renaison Airport" },
{ code: "NCY", name: "Epagny Metz-Tessy - Annecy Haute-Savoie Mont Blanc Airport" },
{ code: "GNB", name: "Saint-Ã‰tienne-de-Saint-Geoirs, IsÃ¨re - Grenoble Alpes IsÃ¨re Airport" },
{ code: "VAF", name: "Chabeuil, DrÃ´me - Valence-Chabeuil Airport" },
{ code: "VHY", name: "Charmeil, Allier - Vichy-Charmeil Airport" },
{ code: "AUR", name: "Aurillac - Aurillac Airport" },
{ code: "CHR", name: "DÃ©ols, Indre - ChÃ¢teauroux-DÃ©ols Marcel Dassault Airport" },
{ code: "LYN", name: "Chassieu, Lyon - Lyon Bron Airport" },
{ code: "CEQ", name: "Cannes, Alpes-Maritimes - Cannes-Mandelieu Airport" },
{ code: "EBU", name: "AndrÃ©zieux-BouthÃ©on, Loire - Saint-Ã‰tienne-BouthÃ©on Airport" },
{ code: "CCF", name: "Carcassonne/Salvaza - Carcassonne Airport" },
{ code: "MRS", name: "Marignane, Bouches-du-RhÃ´ne - Marseille Provence Airport" },
{ code: "NCE", name: "Nice, Alpes-Maritimes - Nice-CÃ´te d'Azur Airport" },
{ code: "PGF", name: "Perpignan/Rivesaltes - Perpignan-Rivesaltes (LlabanÃ¨re) Airport" },
{ code: "CTT", name: "Le Castellet, Var - Le Castellet Airport" },
{ code: "MPL", name: "Montpellier/MÃ©diterranÃ©e - Montpellier-MÃ©diterranÃ©e Airport" },
{ code: "BZR", name: "BÃ©ziers/Vias - BÃ©ziers-Vias Airport" },
{ code: "AVN", name: "Avignon, Vaucluse - Avignon-Caumont Airport" },
{ code: "MEN", name: "Mende/BrÃ©noux - Mende-Brenoux Airfield" },
{ code: "BVA", name: "TillÃ© - Paris-Beauvais Airport" },
{ code: "EVX", name: "Fauville, Eure - Ã‰vreux-Fauville (BA 105) Air Base" },
{ code: "LEH", name: "Le Havre - Le Havre-Octeville Airport" },
{ code: "XCR", name: "Bussy-LettrÃ©e - ChÃ¢lons-Vatry Airport" },
{ code: "URO", name: "Boos - Rouen VallÃ©e de Seine Airport" },
{ code: "TUF", name: "Tours, Indre-et-Loire - Tours Val de Loire Airport" },
{ code: "LVA", name: "Laval, Mayenne - Laval-Entrammes Airport" },
{ code: "LBG", name: "Paris (Le Bourget, Seine-Saint-Denis) - Paris-Le Bourget Airport" },
{ code: "CSF", name: "Creil - Creil Air Base" },
{ code: "CDG", name: "Paris (Roissy-en-France, Val-d'Oise) - Charles de Gaulle International Airport" },
{ code: "TNF", name: "Toussus-le-Noble, Yvelines - Toussus-le-Noble Airport" },
{ code: "ORY", name: "Paris (Orly, Val-de-Marne) - Paris-Orly Airport" },
{ code: "POX", name: "Cormeilles-en-Vexin, Val-d'Oise - Pontoise-Cormeilles Aerodrome" },
{ code: "VIY", name: "VÃ©lizy-Villacoublay, Yvelines - VÃ©lizy-Villacoublay Air Base" },
{ code: "NVS", name: "Marzy, NiÃ¨vre - Nevers-Fourchambault Airport" },
{ code: "LIL", name: "Lesquin - Lille Airport" },
{ code: "HZB", name: "Merville, Nord - Merville-Calonne Airport" },
{ code: "BES", name: "Brest/Guipavas - Brest Bretagne Airport" },
{ code: "CER", name: "Gonneville-Le Theil, Manche - Cherbourg-Maupertus Airport" },
{ code: "DNR", name: "Pleurtuit, Ille-et-Vilaine - Dinard-Pleurtuit-Saint-Malo Airport" },
{ code: "LBY", name: "La Baule-Escoublac - La Baule-Escoublac Airport" },
{ code: "GFR", name: "BrÃ©ville-sur-Mer, Manche - Granville Airport" },
{ code: "DOL", name: "Deauville, Calvados - Deauville-Normandie Airport" },
{ code: "LRT", name: "Lorient/Lann/BihouÃ© - Lorient South Brittany (Bretagne Sud) Airport" },
{ code: "EDM", name: "La Roche-sur-Yon/Les Ajoncs - La Roche-sur-Yon Airport" },
{ code: "LDV", name: "Landivisiau - Landivisiau Air Base" },
{ code: "CFR", name: "Carpiquet, Calvados - Caen-Carpiquet Airport" },
{ code: "LME", name: "Le Mans, Sarthe - Le Mans-Arnage Airport" },
{ code: "RNS", name: "Saint-Jacques-de-la-Lande, Ille-et-Vilaine - Rennes-Saint-Jacques Airport" },
{ code: "LAI", name: "Lannion - Lannion-CÃ´te de Granit Airport" },
{ code: "UIP", name: "Quimper/Pluguffan - Quimper-Cornouaille Airport" },
{ code: "NTE", name: "Nantes - Nantes Atlantique Airport" },
{ code: "SBK", name: "TrÃ©muson, CÃ´tes-d'Armor - Saint-Brieuc-Armor Airport" },
{ code: "MXN", name: "Morlaix/Ploujean - Morlaix-Ploujean Airport" },
{ code: "VNE", name: "Vannes/Meucon - Vannes-Meucon Airport" },
{ code: "SNR", name: "Saint-Nazaire/Montoir - Saint-Nazaire-Montoir Airport" },
{ code: "BSL", name: "Saint-Louis - EuroAirport Basel-Mulhouse-Freiburg" },
{ code: "DIJ", name: "Ouges, CÃ´te-d'Or - Dijon-Bourgogne Airport" },
{ code: "EPL", name: "Juvaincourt, Vosges - Ã‰pinal-Mirecourt Airport" },
{ code: "BVE", name: "Brive la Gaillarde - Brive-Souillac Airport" },
{ code: "ENC", name: "Tomblaine, Meurthe-et-Moselle - Nancy-Essey Airport" },
{ code: "SXB", name: "Strasbourg - Strasbourg Airport" },
{ code: "TLN", name: "HyÃ¨res, Var - Toulon-HyÃ¨res Airport" },
{ code: "FNI", name: "NÃ®mes/Garons - NÃ®mes-Arles-Camargue Airport" },
{ code: "FSP", name: "Saint-Pierre - St Pierre Airport" },
{ code: "PYR", name: "Andravida - Andravida Air Base" },
{ code: "AXD", name: "Alexandroupolis - Alexandroupoli Democritus Airport" },
{ code: "ATH", name: "Spata-Artemida - Athens Eleftherios Venizelos International Airport" },
{ code: "VOL", name: "Nea Anchialos - Nea Anchialos National Airport" },
{ code: "JKH", name: "Chios Island - Chios Island National Airport" },
{ code: "IOA", name: "Ioannina - Ioannina King Pyrrhus National Airport" },
{ code: "HER", name: "Heraklion - Heraklion International Nikos Kazantzakis Airport" },
{ code: "EFL", name: "Kefallinia Island - Kefallinia Airport" },
{ code: "KLX", name: "Kalamata - Kalamata Airport" },
{ code: "KGS", name: "Kos Island - Kos Airport" },
{ code: "AOK", name: "Karpathos Island - Karpathos Airport" },
{ code: "CFU", name: "Kerkyra (Corfu) - Corfu Ioannis Kapodistrias International Airport" },
{ code: "KVA", name: "Kavala - Kavala Alexander the Great International Airport" },
{ code: "KZI", name: "Kozani - Kozani National Airport Filippos" },
{ code: "JMK", name: "Mykonos - Mykonos Island National Airport" },
{ code: "MJT", name: "Mytilene - Mytilene International Airport" },
{ code: "PVK", name: "Preveza - Aktion National Airport" },
{ code: "RHO", name: "Rhodes - Diagoras Airport" },
{ code: "GPA", name: "Patras - Patras Araxos Agamemnon Airport" },
{ code: "CHQ", name: "Souda - Chania International Airport" },
{ code: "JSI", name: "Skiathos - Skiathos Island National Airport" },
{ code: "SMI", name: "Samos Island - Samos Airport" },
{ code: "JTR", name: "Santorini Island - Santorini Airport" },
{ code: "JSH", name: "Crete Island - Sitia Airport" },
{ code: "SKG", name: "Thessaloniki - Thessaloniki Macedonia International Airport" },
{ code: "ZTH", name: "Zakynthos - Zakynthos International Airport Dionysios Solomos" },
{ code: "BUD", name: "Budapest - Budapest Liszt Ferenc International Airport" },
{ code: "DEB", name: "Debrecen - Debrecen International Airport" },
{ code: "PEV", name: "PÃ©cs - PÃ©cs-PogÃ¡ny Airport" },
{ code: "SOB", name: "SÃ¡rmellÃ©k - HÃ©vÃ­zâ€“Balaton Airport" },
{ code: "CRV", name: "Isola di Capo Rizzuto (KR) - Crotone Sant'Anna Pythagoras Airport" },
{ code: "BRI", name: "Bari - Bari Karol WojtyÅ‚a International Airport" },
{ code: "FOG", name: "Foggia (FG) - Foggia Gino Lisa Airport" },
{ code: "TAR", name: "Grottaglie - Taranto-Grottaglie Marcello Arlotta Airport" },
{ code: "LCC", name: "Galatina (LE) - Lecce Galatina Air Base / Galatina Fortunato Cesari Airport" },
{ code: "PSR", name: "Pescara - Abruzzo Airport" },
{ code: "BDS", name: "Brindisi - Brindisi Airport" },
{ code: "SUF", name: "Lamezia Terme (CZ) - Lamezia Terme Sant'Eufemia International Airport" },
{ code: "CIY", name: "Comiso - Comiso Airport" },
{ code: "CTA", name: "Catania - Catania-Fontanarossa Airport" },
{ code: "LMP", name: "Lampedusa - Lampedusa Airport" },
{ code: "PNL", name: "Pantelleria (TP) - Pantelleria Airport" },
{ code: "PMO", name: "Palermo - Falconeâ€“Borsellino Airport" },
{ code: "REG", name: "Reggio Calabria - Reggio Calabria Airport" },
{ code: "TPS", name: "Trapani (TP) - Vincenzo Florio Airport Trapani-Birgi" },
{ code: "AHO", name: "Alghero - Alghero-Fertilia Airport" },
{ code: "DCI", name: "Decimomannu - Decimomannu Air Base" },
{ code: "CAG", name: "Cagliari - Cagliari Elmas Airport" },
{ code: "OLB", name: "Olbia (SS) - Olbia Costa Smeralda Airport" },
{ code: "MXP", name: "Ferno (VA) - Milan Malpensa International Airport" },
{ code: "BGY", name: "Orio al Serio (BG) - Milan Bergamo Airport / Antonio Locatelli Air Base" },
{ code: "TRN", name: "Caselle Torinese (TO) - Turin Airport" },
{ code: "GOA", name: "Genova (GE) - Genoa Cristoforo Colombo Airport" },
{ code: "LIN", name: "Segrate (MI) - Milano Linate Airport" },
{ code: "PMF", name: "Parma (PR) - Parma Airport" },
{ code: "AOT", name: "Saint-Christophe (AO) - Aosta Corrado Gex Airport" },
{ code: "CUF", name: "Levaldigi (CN) - Cuneo International Airport" },
{ code: "AVB", name: "Aviano (PN) - Aviano Air Base" },
{ code: "BZO", name: "Bolzano (BZ) - Bolzano Airport" },
{ code: "BLQ", name: "Bologna - Bologna Guglielmo Marconi Airport" },
{ code: "TSF", name: "Treviso (TV) - Treviso Antonio Canova Airport" },
{ code: "FRL", name: "ForlÃ¬ (FC) - ForlÃ¬ Luigi Ridolfi Airport" },
{ code: "VBS", name: "Montichiari (BS) - Brescia Gabriele d'Annunzio Airport" },
{ code: "TRS", name: "Ronchi dei Legionari (GO) - Triesteâ€“Friuli Venezia Giulia Airport" },
{ code: "RMI", name: "Rimini (RN) - Federico Fellini International Airport" },
{ code: "VRN", name: "Caselle (VR) - Verona Villafranca Valerio Catullo Airport" },
{ code: "AOI", name: "Falconara Marittima (AN) - Marche Airport" },
{ code: "VCE", name: "Venezia (VE) - Venice Marco Polo Airport" },
{ code: "CIA", name: "Rome - Ciampinoâ€“G. B. Pastine International Airport" },
{ code: "FCO", name: "Rome - Romeâ€“Fiumicino Leonardo da Vinci International Airport" },
{ code: "QSR", name: "Salerno - Salerno Costa d'Amalfi Airport" },
{ code: "EBA", name: "Campo nell'Elba (LI) - Marina di Campo Airport" },
{ code: "NAP", name: "Napoli - Naples International Airport" },
{ code: "PSA", name: "Pisa (PI) - Pisa International Airport" },
{ code: "FLR", name: "Firenze (FI) - Florence Airport, Peretola" },
{ code: "GRS", name: "Grosseto (GR) - Grosseto Corrado Baccarini Air Base / Grosseto Airport" },
{ code: "PEG", name: "Perugia (PG) - Perugia San Francesco d'Assisi â€“ Umbria International Airport" },
{ code: "LJU", name: "Zgornji Brnik - Ljubljana JoÅ¾e PuÄnik Airport" },
{ code: "MBX", name: "Orehova Vas - Maribor Edvard Rusjan Airport" },
{ code: "POW", name: "SeÄovlje - PortoroÅ¾ Airport" },
{ code: "UHE", name: "UherskÃ© HradiÅ¡tÄ› - Kunovice Airport" },
{ code: "KLV", name: "Karlovy Vary - Karlovy Vary Airport" },
{ code: "OSR", name: "MoÅ¡nov - Ostrava Leos JanÃ¡Äek Airport" },
{ code: "PED", name: "Pardubice - Pardubice Airport" },
{ code: "PRV", name: "PÅ™erov - PÅ™erov Air Base" },
{ code: "PRG", name: "Prague - VÃ¡clav Havel Airport Prague" },
{ code: "BRQ", name: "Brno - Brno-TuÅ™any Airport" },
{ code: "VOD", name: "Vodochody - Vodochody Airport" },
{ code: "TLV", name: "Tel Aviv - Ben Gurion International Airport" },
{ code: "ETM", name: "Eilat - Ramon International Airport" },
{ code: "HFA", name: "Haifa - Haifa International Airport" },
{ code: "RPN", name: "Rosh Pina - Rosh Pina Airport" },
{ code: "MTZ", name: "Masada - Bar Yehuda Airfield" },
{ code: "VTM", name: "Beersheba - Nevatim Air Base" },
{ code: "MIP", name: "Beersheba - Ramon Air Base" },
{ code: "MLA", name: "Valletta - Malta International Airport" },
{ code: "GRZ", name: "Feldkirchen bei Graz - Graz Airport" },
{ code: "INN", name: "Innsbruck - Innsbruck Airport" },
{ code: "KLU", name: "Klagenfurt am WÃ¶rthersee - Klagenfurt Airport" },
{ code: "LNZ", name: "Linz - Linz-HÃ¶rsching Airport / Vogler Air Base" },
{ code: "SZG", name: "Salzburg - Salzburg Airport" },
{ code: "VIE", name: "Vienna - Vienna International Airport" },
{ code: "SMA", name: "Vila do Porto - Santa Maria Airport" },
{ code: "BGC", name: "BraganÃ§a - BraganÃ§a Airport" },
{ code: "BYJ", name: "Beja - Beja Airport / Airbase" },
{ code: "CAT", name: "Cascais - Cascais Airport" },
{ code: "FLW", name: "Santa Cruz das Flores - Flores Airport" },
{ code: "FAO", name: "Faro - Faro Airport" },
{ code: "GRW", name: "Santa Cruz da Graciosa - Graciosa Airport" },
{ code: "HOR", name: "Horta - Horta Airport" },
{ code: "TER", name: "Praia da VitÃ³ria - Lajes Airport" },
{ code: "FNC", name: "Funchal - Madeira International Airport Cristiano Ronaldo" },
{ code: "PDL", name: "Ponta Delgada - JoÃ£o Paulo II Airport" },
{ code: "PIX", name: "Pico Island - Pico Airport" },
{ code: "PRM", name: "PortimÃ£o - PortimÃ£o Airport" },
{ code: "OPO", name: "Porto - Francisco de SÃ¡ Carneiro Airport" },
{ code: "PXO", name: "Vila Baleira - Porto Santo Airport" },
{ code: "LIS", name: "Lisbon - Lisbon Humberto Delgado Airport" },
{ code: "SJZ", name: "Velas - SÃ£o Jorge Airport" },
{ code: "VRL", name: "Vila Real - Vila Real Airport" },
{ code: "VSE", name: "Viseu - Aerodromo Goncalves Lobato (Viseu Airport)" },
{ code: "BNX", name: "Mahovljani - Banja Luka International Airport" },
{ code: "OMO", name: "Mostar - Mostar International Airport" },
{ code: "SJJ", name: "Sarajevo - Sarajevo International Airport" },
{ code: "TZL", name: "Dubrave Gornje - Tuzla International Airport" },
{ code: "ARW", name: "Arad - Arad International Airport" },
{ code: "BCM", name: "BacÄƒu - BacÄƒu George Enescu International  Airport" },
{ code: "BAY", name: "TÄƒuÈ›ii-MÄƒgherÄƒuÈ™ - MaramureÈ™ International Airport" },
{ code: "BBU", name: "Bucharest - Bucharest BÄƒneasa Aurel Vlaicu International Airport" },
{ code: "GHV", name: "BraÈ™ov (Ghimbav) - BraÈ™ov-Ghimbav International Airport" },
{ code: "CND", name: "Mihail KogÄƒlniceanu - Mihail KogÄƒlniceanu International Airport" },
{ code: "CLJ", name: "Cluj-Napoca - Cluj Avram Iancu International Airport" },
{ code: "CSB", name: "CaransebeÅŸ - CaransebeÅŸ Airport" },
{ code: "CRA", name: "Craiova - Craiova International Airport" },
{ code: "IAS", name: "IaÅŸi - IaÅŸi Airport" },
{ code: "OMR", name: "Oradea - Oradea International Airport" },
{ code: "OTP", name: "Otopeni - Bucharest Henri CoandÄƒ International Airport" },
{ code: "SBZ", name: "Sibiu - Sibiu International Airport" },
{ code: "SUJ", name: "Satu Mare - Satu Mare International Airport" },
{ code: "SCV", name: "Suceava - Suceava Stefan cel Mare Airport" },
{ code: "TCE", name: "Mihail KogÄƒlniceanu - Tulcea Danube Delta Airport" },
{ code: "TGM", name: "Recea - TÃ¢rgu MureÅŸ Transilvania International Airport" },
{ code: "TSR", name: "TimiÅŸoara - TimiÅŸoara Traian Vuia Airport" },
{ code: "GVA", name: "Geneva - Geneva Cointrin International Airport" },
{ code: "SIR", name: "Sion - Sion Airport" },
{ code: "EML", name: "Emmen - Emmen Air Base" },
{ code: "VIP", name: "Payerne - Payerne Air Base" },
{ code: "LUG", name: "Agno - Lugano Airport" },
{ code: "BRN", name: "Bern - Bern Airport" },
{ code: "ZRH", name: "Zurich - ZÃ¼rich Airport" },
{ code: "ACH", name: "St. Gallen - Sankt Gallen Altenrhein Airport" },
{ code: "SMV", name: "Samedan - Samedan Airport" },
{ code: "ESB", name: "Ankara - EsenboÄŸa International Airport" },
{ code: "ANK", name: "Ankara - Etimesgut Air Base" },
{ code: "ADA", name: "Seyhan - Adana ÅžakirpaÅŸa Airport" },
{ code: "UAB", name: "SarÄ±Ã§am - Ä°ncirlik Air Base" },
{ code: "AFY", name: "Afyonkarahisar - Afyon Air Base" },
{ code: "AYT", name: "Antalya - Antalya International Airport" },
{ code: "GZT", name: "Gaziantep - Gaziantep International Airport" },
{ code: "KFS", name: "Kastamonu - Kastamonu Airport" },
{ code: "KYA", name: "Konya - Konya Airport" },
{ code: "ONQ", name: "Zonguldak - Zonguldak Ã‡aycuma Airport" },
{ code: "MLX", name: "Malatya - Malatya ErhaÃ§ Airport" },
{ code: "ASR", name: "Kayseri - Kayseri Erkilet Airport" },
{ code: "TJK", name: "Tokat - Tokat Airport" },
{ code: "DNZ", name: "Denizli - Ã‡ardak Airport" },
{ code: "ISL", name: "BakÄ±rkÃ¶y, Istanbul - Ä°stanbul AtatÃ¼rk Airport" },
{ code: "BZI", name: "BalÄ±kesir - BalÄ±kesir Airport" },
{ code: "BDM", name: "BandÄ±rma - BandÄ±rma Airport" },
{ code: "CKZ", name: "Ã‡anakkale - Ã‡anakkale Airport" },
{ code: "ESK", name: "EskiÅŸehir - EskiÅŸehir Air Base" },
{ code: "ADB", name: "Gaziemir - Adnan Menderes International Airport" },
{ code: "IGL", name: "Ã‡iÄŸli - Ã‡iÄŸli Airbase" },
{ code: "USQ", name: "UÅŸak - UÅŸak Airport" },
{ code: "KCO", name: "Kartepe - Cengiz Topel Airport" },
{ code: "YEI", name: "YeniÅŸehir - Bursa YeniÅŸehir Airport" },
{ code: "DLM", name: "Dalaman - Dalaman International Airport" },
{ code: "TEQ", name: "Ã‡orlu - TekirdaÄŸ Ã‡orlu Airport" },
{ code: "AOE", name: "EskiÅŸehir - Anadolu Airport" },
{ code: "EZS", name: "ElazÄ±ÄŸ - ElazÄ±ÄŸ Airport" },
{ code: "OGU", name: "Ordu - Orduâ€“Giresun Airport" },
{ code: "DIY", name: "DiyarbakÄ±r - DiyarbakÄ±r Airport" },
{ code: "ERC", name: "Erzincan - Erzincan Airport" },
{ code: "ERZ", name: "Erzurum - Erzurum International Airport" },
{ code: "KSY", name: "Kars - Kars Airport" },
{ code: "TZX", name: "Trabzon - Trabzon International Airport" },
{ code: "VAN", name: "Van - Van Ferit Melen Airport" },
{ code: "BAL", name: "Batman - Batman Airport" },
{ code: "MSR", name: "MuÅŸ - MuÅŸ Airport" },
{ code: "SXZ", name: "Siirt - Siirt Airport" },
{ code: "NOP", name: "Sinop - Sinop Airport" },
{ code: "KCM", name: "KahramanmaraÅŸ - KahramanmaraÅŸ Airport" },
{ code: "AJI", name: "AÄŸrÄ± - AÄŸrÄ± Airport" },
{ code: "ADF", name: "AdÄ±yaman - AdÄ±yaman Airport" },
{ code: "MQM", name: "Mardin - Mardin Airport" },
{ code: "GNY", name: "ÅžanlÄ±urfa - ÅžanlÄ±urfa GAP Airport" },
{ code: "IGD", name: "IÄŸdÄ±r - IÄŸdÄ±r Airport" },
{ code: "NKT", name: "ÅžÄ±rnak - ÅžÄ±rnak Åžerafettin ElÃ§i Airport" },
{ code: "YKO", name: "Hakkari - Hakkari YÃ¼ksekova Airport" },
{ code: "HTY", name: "Antakya - Hatay Airport" },
{ code: "COV", name: "Tarsus - Ã‡ukurova International Airport" },
{ code: "ISE", name: "Isparta - SÃ¼leyman Demirel International Airport" },
{ code: "EDO", name: "Edremit - BalÄ±kesir Koca Seyit Airport" },
{ code: "BJV", name: "Bodrum - Milas Bodrum International Airport" },
{ code: "GZP", name: "GazipaÅŸa - GazipaÅŸa-Alanya Airport" },
{ code: "SZF", name: "Samsun - Samsun-Ã‡arÅŸamba Airport" },
{ code: "SAW", name: "Pendik, Istanbul - Istanbul Sabiha GÃ¶kÃ§en International Airport" },
{ code: "IST", name: "ArnavutkÃ¶y, Istanbul - Ä°stanbul Airport" },
{ code: "RZV", name: "Rize - Rizeâ€“Artvin Airport" },
{ code: "BZY", name: "BÄƒlÈ›i - BÄƒlÈ›i International Airport" },
{ code: "RMO", name: "ChiÅŸinÄƒu - ChiÅŸinÄƒu International Airport" },
{ code: "OHD", name: "Ohrid - Ohrid St. Paul the Apostle Airport" },
{ code: "SKP", name: "Ilinden - Skopje International Airport" },
{ code: "GIB", name: "Gibraltar - Gibraltar Airport" },
{ code: "BCQ", name: "Brak - Brak Airport" },
{ code: "BEG", name: "Belgrade - Belgrade Nikola Tesla Airport" },
{ code: "BJY", name: "Zemun - Batajnica Air Base" },
{ code: "KVO", name: "Kraljevo - Morava Airport" },
{ code: "INI", name: "NiÅ¡ - NiÅ¡ Constantine the Great Airport" },
{ code: "TGD", name: "Podgorica - Podgorica Airport / Podgorica Golubovci Airbase" },
{ code: "TIV", name: "Tivat - Tivat Airport" },
{ code: "UZC", name: "Stapari - Ponikve Airport" },
{ code: "LZG", name: "Nanchong (Langzhong) - Langzhong Gucheng Airport" },
{ code: "BTS", name: "Bratislava - M. R. Å tefÃ¡nik Airport" },
{ code: "KSC", name: "KoÅ¡ice - KoÅ¡ice International Airport" },
{ code: "PZY", name: "PieÅ¡Å¥any - PieÅ¡Å¥any Airport" },
{ code: "SLD", name: "SliaÄ - SliaÄ Airport" },
{ code: "TAT", name: "Poprad - Poprad-Tatry Airport" },
{ code: "ILZ", name: "DolnÃ½ HriÄov - Å½ilina-DolnÃ½ HriÄov Airport" },
{ code: "GDT", name: "Cockburn Town - JAGS McCartney International Airport" },
{ code: "NCA", name: "North Caicos - North Caicos Airport" },
{ code: "PLS", name: "Providenciales - Providenciales International Airport" },
{ code: "XSC", name: "South Caicos - South Caicos Airport" },
{ code: "BRX", name: "Barahona - Maria Montez International Airport" },
{ code: "CBJ", name: "Cabo Rojo - Cabo Rojo Airport" },
{ code: "AZS", name: "Samana - SamanÃ¡ El Catey International Airport" },
{ code: "JBQ", name: "La Isabela - La Isabela International Airport" },
{ code: "LRM", name: "La Romana - Casa De Campo International Airport" },
{ code: "PUJ", name: "Punta Cana - Punta Cana International Airport" },
{ code: "POP", name: "Puerto Plata - Gregorio Luperon International Airport" },
{ code: "SDQ", name: "Santo Domingo - Las AmÃ©ricas International Airport" },
{ code: "STI", name: "Santiago - Cibao International Airport" },
{ code: "CBV", name: "Coban - Coban Airport" },
{ code: "GUA", name: "Guatemala City - La Aurora Airport" },
{ code: "PBR", name: "Puerto Barrios - Puerto Barrios Airport" },
{ code: "RUV", name: "Rubelsanto - Rubelsanto Airport" },
{ code: "RER", name: "Retalhuleu - Retalhuleu Airport" },
{ code: "GSJ", name: "Puerto San JosÃ© - San JosÃ© Airport" },
{ code: "FRS", name: "San Benito - Mundo Maya International Airport" },
{ code: "LCE", name: "La Ceiba - Goloson International Airport" },
{ code: "SAP", name: "San Pedro Sula - RamÃ³n Villeda Morales International Airport" },
{ code: "GJA", name: "Guanaja - La Laguna Airport" },
{ code: "RTB", name: "Coxen Hole - Juan Manuel GÃ¡lvez International Airport" },
{ code: "XPL", name: "Palmerola - Palmerola International Airport / JosÃ© Enrique Soto Cano Air Base" },
{ code: "TEA", name: "Tela - Tela Airport" },
{ code: "TGU", name: "Tegucigalpa - ToncontÃ­n International Airport" },
{ code: "TJI", name: "Trujillo - Trujillo Airport" },
{ code: "OCJ", name: "Boscobel - Ian Fleming International Airport" },
{ code: "KIN", name: "Kingston - Norman Manley International Airport" },
{ code: "MBJ", name: "Montego Bay - Sangster International Airport" },
{ code: "POT", name: "Ken Jones - Ken Jones Airport" },
{ code: "KTP", name: "Tinson Pen - Tinson Pen Airport" },
{ code: "ACA", name: "Acapulco - General Juan N. Ãlvarez International Airport" },
{ code: "NTR", name: "Monterrey - Del Norte International Airport" },
{ code: "AGU", name: "Aguascalientes - JesÃºs TerÃ¡n Peredo International Airport" },
{ code: "HUX", name: "Huatulco - BahÃ­as de Huatulco International Airport" },
{ code: "CVJ", name: "Temixco - General Mariano Matamoros International Airport" },
{ code: "CME", name: "Ciudad del Carmen - Ciudad del Carmen International Airport" },
{ code: "CUL", name: "CuliacÃ¡n - Bachigualato Federal International Airport" },
{ code: "CTM", name: "Chetumal - Chetumal International Airport" },
{ code: "CEN", name: "Ciudad ObregÃ³n - Ciudad ObregÃ³n International Airport" },
{ code: "CPE", name: "Campeche - Ingeniero Alberto AcuÃ±a Ongay International Airport" },
{ code: "CJS", name: "Ciudad JuÃ¡rez - Abraham GonzÃ¡lez International Airport" },
{ code: "CUU", name: "Chihuahua - General Roberto Fierro Villalobos International Airport" },
{ code: "CVM", name: "Ciudad Victoria - General Pedro Jose Mendez International Airport" },
{ code: "CYW", name: "Celaya - Captain Rogelio Castillo National Airport" },
{ code: "CZM", name: "Cozumel - Cozumel International Airport" },
{ code: "DGO", name: "Durango - General Guadalupe Victoria International Airport" },
{ code: "TPQ", name: "Tepic - Amado Nervo National Airport" },
{ code: "GDL", name: "Guadalajara - Guadalajara International Airport" },
{ code: "GYM", name: "Guaymas - General JosÃ© MarÃ­a YÃ¡Ã±ez International Airport" },
{ code: "HMO", name: "Hermosillo - General Ignacio P. Garcia International Airport" },
{ code: "CLQ", name: "Colima - Licenciado Miguel de la Madrid International Airport" },
{ code: "SLW", name: "Saltillo - Plan De Guadalupe International Airport" },
{ code: "IZT", name: "Ixtepec - General Antonio CÃ¡rdenas RodrÃ­guez National Airport / Ixtepec Air Base" },
{ code: "JAL", name: "Emiliano Zapata - El Lencero Airport" },
{ code: "LZC", name: "LÃ¡zaro CÃ¡rdenas - LÃ¡zaro CÃ¡rdenas Airport" },
{ code: "LMM", name: "Los Mochis - Valle del Fuerte International Airport" },
{ code: "BJX", name: "Silao - Del BajÃ­o International Airport" },
{ code: "LAP", name: "La Paz - Manuel MÃ¡rquez de LeÃ³n International Airport" },
{ code: "LTO", name: "Loreto - Loreto International Airport" },
{ code: "MAM", name: "Matamoros - General Servando Canales International Airport" },
{ code: "MID", name: "MÃ©rida - Manuel Crescencio RejÃ³n International Airport" },
{ code: "MXL", name: "Mexicali - General Rodolfo SÃ¡nchez Taboada International Airport" },
{ code: "MLM", name: "Morelia - General Francisco J. Mujica International Airport" },
{ code: "MTT", name: "Cosoleacaque - MinatitlÃ¡n/Coatzacoalcos International Airport" },
{ code: "LOV", name: "Monclova - Monclova International Airport" },
{ code: "MEX", name: "Ciudad de MÃ©xico - Benito JuÃ¡rez International Airport" },
{ code: "MTY", name: "Monterrey - Monterrey International Airport" },
{ code: "MZT", name: "MazatlÃ n - General Rafael Buelna International Airport" },
{ code: "NLD", name: "Nuevo Laredo - QuetzalcÃ³atl International Airport" },
{ code: "OAX", name: "Oaxaca - XoxocotlÃ¡n International Airport" },
{ code: "PAZ", name: "Poza Rica - El TajÃ­n National Airport" },
{ code: "PBC", name: "Puebla - Hermanos SerdÃ¡n International Airport" },
{ code: "PDS", name: "Piedras Negras - Piedras Negras International Airport" },
{ code: "UPN", name: "Uruapan - Uruapan - Licenciado y General Ignacio Lopez Rayon International Airport" },
{ code: "PVR", name: "Puerto Vallarta - Puerto Vallarta International Airport" },
{ code: "PXM", name: "Puerto Escondido - Puerto Escondido International Airport" },
{ code: "QRO", name: "QuerÃ©taro - QuerÃ©taro Intercontinental Airport" },
{ code: "REX", name: "Reynosa - General Lucio Blanco International Airport" },
{ code: "SJD", name: "San JosÃ© del Cabo - Los Cabos International Airport" },
{ code: "NLU", name: "Mexico City - General Felipe Ãngeles International Airport" },
{ code: "SLP", name: "San Luis PotosÃ­ - Ponciano Arriaga International Airport" },
{ code: "TRC", name: "TorreÃ³n - Francisco Sarabia Tinoco International Airport" },
{ code: "TGZ", name: "Tuxtla GutiÃ©rrez - Angel Albino Corzo International Airport" },
{ code: "TIJ", name: "Tijuana - General Abelardo L. Rodriguez International Airport" },
{ code: "TQO", name: "Tulum - Felipe Carrillo Puerto International Airport" },
{ code: "TAM", name: "Tampico - General Francisco Javier Mina International Airport" },
{ code: "TLC", name: "Toluca - Adolfo LÃ³pez Mateos International Airport" },
{ code: "TAP", name: "Tapachula - Tapachula International Airport" },
{ code: "CUN", name: "CancÃºn - CancÃºn International Airport" },
{ code: "VSA", name: "Villahermosa - Carlos Rovirosa PÃ©rez International Airport" },
{ code: "VER", name: "Veracruz - General Heriberto Jara International Airport" },
{ code: "ZCL", name: "Zacatecas - General Leobardo C. Ruiz International Airport" },
{ code: "ZIH", name: "Ixtapa - Ixtapa-Zihuatanejo International Airport" },
{ code: "ZLO", name: "Manzanillo - Playa de Oro International Airport" },
{ code: "BEF", name: "Bluefileds - Bluefields Airport" },
{ code: "MGA", name: "Managua - Augusto C. Sandino (Managua) International Airport" },
{ code: "PUZ", name: "Puerto Cabezas - Puerto Cabezas Airport" },
{ code: "BOC", name: "Isla ColÃ³n - Bocas del Toro International Airport" },
{ code: "CTD", name: "ChitrÃ© - Alonso Valderrama Airport" },
{ code: "CHX", name: "Changuinola - Changuinola Captain Manuel NiÃ±o International Airport" },
{ code: "DAV", name: "David - Enrique Malek International Airport" },
{ code: "ONX", name: "ColÃ³n - Enrique Adolfo Jimenez Airport" },
{ code: "PAC", name: "Albrook - Marcos A. Gelabert International Airport" },
{ code: "SYP", name: "Santiago - Ruben Cantu Airport" },
{ code: "PTY", name: "Tocumen - Tocumen International Airport" },
{ code: "BAI", name: "Punta Arenas - Buenos Aires Airport" },
{ code: "BCL", name: "Pococi - Barra del Colorado Airport" },
{ code: "OTR", name: "Corredores - Coto 47 Airport" },
{ code: "GLF", name: "Golfito - Golfito Airport" },
{ code: "GPL", name: "Pococi - Guapiles Airport" },
{ code: "LIR", name: "Liberia - Guanacaste Airport" },
{ code: "LSL", name: "Los Chiles - Los Chiles Airport" },
{ code: "LIO", name: "Puerto Limon - Limon International Airport" },
{ code: "NOB", name: "Nicoya - Nosara Airport" },
{ code: "SJO", name: "San JosÃ© (Alajuela) - Juan SantamarÃ­a International Airport" },
{ code: "PJM", name: "Puerto Jimenez - Puerto Jimenez Airport" },
{ code: "PMZ", name: "Palmar Sur - Palmar Sur Airport" },
{ code: "SYQ", name: "San Jose - TobÃ­as BolaÃ±os International Airport" },
{ code: "XQP", name: "Quepos - Quepos Managua Airport" },
{ code: "UPL", name: "Upala - Upala Airport" },
{ code: "SAL", name: "San Salvador (San Luis Talpa) - MonseÃ±or Ã“scar Arnulfo Romero International Airport" },
{ code: "ILS", name: "San Salvador - Ilopango International Airport" },
{ code: "CYA", name: "Les Cayes - Antoine-Simon International Airport" },
{ code: "CAP", name: "Cap Haitien - Cap Haitien International Airport" },
{ code: "JAK", name: "Jacmel - Jacmel Airport" },
{ code: "JEE", name: "Carrefour Sanon - JÃ©rÃ©mie Airport" },
{ code: "PAP", name: "Port-au-Prince - Toussaint Louverture International Airport" },
{ code: "PAX", name: "Port-de-Paix - Port-de-Paix Airport" },
{ code: "BCA", name: "Baracoa - Gustavo Rizo Airport" },
{ code: "BYM", name: "Bayamo - Carlos Manuel de Cespedes Airport" },
{ code: "AVI", name: "Ciro Redondo - MÃ¡ximo GÃ³mez Airport" },
{ code: "CCC", name: "Cayo Coco - Jardines Del Rey Airport" },
{ code: "CFG", name: "Cienfuegos - Jaime Gonzalez Airport" },
{ code: "CYO", name: "Cayo Largo del Sur - Vilo AcuÃ±a International Airport" },
{ code: "CMW", name: "Camaguey - Ignacio Agramonte International Airport" },
{ code: "SCU", name: "Santiago - Antonio Maceo International Airport" },
{ code: "NBW", name: "Guantanamo Bay Naval Station - Leeward Point Field" },
{ code: "GAO", name: "GuantÃ¡namo - Mariana Grajales Airport" },
{ code: "HAV", name: "Havana - JosÃ© MartÃ­ International Airport" },
{ code: "HOG", name: "Holguin - Frank Pais International Airport" },
{ code: "VRO", name: "Santa Marta - Kawama Airport" },
{ code: "LCL", name: "Pinar del Rio - La Coloma Airport" },
{ code: "MOA", name: "Moa - Orestes Acosta Airport" },
{ code: "MZO", name: "Manzanillo - Sierra Maestra International Airport" },
{ code: "GER", name: "Nueva Gerona - Rafael Cabrera Airport" },
{ code: "UPB", name: "Havana - Playa Baracoa Airport" },
{ code: "SNU", name: "Santa Clara - Abel Santamaria Airport" },
{ code: "SNJ", name: "Sandino - San JuliÃ¡n Air Base" },
{ code: "SZJ", name: "Isla de la Juventud - Siguanea Airport" },
{ code: "TND", name: "Trinidad - Alberto Delgado Airport" },
{ code: "VRA", name: "Matanzas - Juan Gualberto Gomez International Airport" },
{ code: "VTU", name: "Las Tunas - Hermanos Ameijeiras Airport" },
{ code: "CYB", name: "West End - Charles Kirkconnell International Airport" },
{ code: "LYB", name: "Blossom Village - Edward Bodden Little Cayman Airfield" },
{ code: "GCM", name: "George Town - Owen Roberts International Airport" },
{ code: "MAY", name: "Mangrove Cay - Clarence A. Bain Airport" },
{ code: "ASD", name: "Andros Town - Andros Town Airport" },
{ code: "TZN", name: "Andros - Congo Town Airport" },
{ code: "MHH", name: "Marsh Harbour - Leonard M Thompson International Airport" },
{ code: "SAQ", name: "Andros Island - San Andros Airport" },
{ code: "AXP", name: "Spring Point - Spring Point Airport" },
{ code: "TCB", name: "Treasure Cay - Treasure Cay Airport" },
{ code: "CCZ", name: "Chub Cay - Chub Cay Airport" },
{ code: "GHC", name: "Bullocks Harbour - Great Harbour Cay Airport" },
{ code: "BIM", name: "South Bimini - South Bimini Airport" },
{ code: "ATC", name: "Arthur's Town - Arthur's Town Airport" },
{ code: "TBI", name: "Cat Island - New Bight Airport" },
{ code: "CRI", name: "Colonel Hill - Colonel Hill Airport" },
{ code: "GGT", name: "Moss Town - Exuma International Airport" },
{ code: "ELH", name: "North Eleuthera - North Eleuthera Airport" },
{ code: "GHB", name: "Governor's Harbour - Governor's Harbour Airport" },
{ code: "NMC", name: "Normans Cay - Normans Cay Airport" },
{ code: "RSD", name: "Rock Sound - Rock Sound Airport" },
{ code: "TYM", name: "Staniel Cay - Staniel Cay Airport" },
{ code: "FPO", name: "Freeport - Grand Bahama International Airport" },
{ code: "IGA", name: "Matthew Town - Inagua Airport" },
{ code: "LGI", name: "Deadman's Cay - Deadman's Cay Airport" },
{ code: "SML", name: "Stella Maris - Stella Maris Airport" },
{ code: "MYG", name: "Abraham Bay Settlement - Mayaguana Airport" },
{ code: "NAS", name: "Nassau - Lynden Pindling International Airport" },
{ code: "DCT", name: "Duncan Town - Duncan Town Airport" },
{ code: "ZSA", name: "San Salvador - San Salvador Airport" },
{ code: "BZE", name: "Belize City - Philip S. W. Goldson International Airport" },
{ code: "PLJ", name: "Placencia - Placencia Airport" },
{ code: "RAR", name: "Avarua - Rarotonga International Airport" },
{ code: "NAN", name: "Nadi - Nadi International Airport" },
{ code: "SUV", name: "Nausori - Nausori International Airport" },
{ code: "LBS", name: "Labasa - Labasa Airport" },
{ code: "TBU", name: "Nuku'alofa - Fua'amotu International Airport" },
{ code: "HPA", name: "Lifuka - Lifuka Island Airport" },
{ code: "VAV", name: "Vava'u Island - Vava'u International Airport" },
{ code: "FUN", name: "Funafuti - Funafuti International Airport" },
{ code: "TRW", name: "Tarawa - Bonriki International Airport" },
{ code: "TBF", name: " - Tabiteuea North Airport" },
{ code: "IUE", name: "Alofi - Niue International Airport" },
{ code: "NLH", name: "Ninglang - Ninglang Luguhu Airport" },
{ code: "WLS", name: "Wallis Island - Hihifo Airport" },
{ code: "PHH", name: "Pokhara - Pokhara International Airport" },
{ code: "APW", name: "Apia - Faleolo International Airport" },
{ code: "PPG", name: "Pago Pago - Pago Pago International Airport" },
{ code: "PPT", name: "Papeete - Faa'a International Airport" },
{ code: "RUR", name: " - Rurutu Airport" },
{ code: "TUB", name: " - Tubuai Airport" },
{ code: "AAA", name: "Anaa - Anaa Airport" },
{ code: "FGU", name: "Fangatau - Fangatau Airport" },
{ code: "TIH", name: " - Tikehau Airport" },
{ code: "REA", name: "Reao - Reao Airport" },
{ code: "FAV", name: " - Fakarava Airport" },
{ code: "XMH", name: " - Manihi Airport" },
{ code: "GMR", name: " - Totegegie Airport" },
{ code: "KKR", name: "Raitahiti - Kaukura Airport" },
{ code: "MKP", name: "Makemo - Makemo Airport" },
{ code: "TKP", name: " - Takapoto Airport" },
{ code: "AXR", name: " - Arutua Airport" },
{ code: "MVT", name: " - Mataiva Airport" },
{ code: "AHE", name: "Ahe Atoll - Ahe Airport" },
{ code: "TKX", name: " - Takaroa Airport" },
{ code: "NHV", name: "Nuku Hiva - Nuku Hiva Airport" },
{ code: "AUQ", name: "Hiva Oa Island - Hiva Oa-Atuona Airport" },
{ code: "BOB", name: "Motu Mute - Bora Bora Airport" },
{ code: "RGI", name: " - Rangiroa Airport" },
{ code: "HUH", name: "Fare - Huahine-Fare Airport" },
{ code: "MOZ", name: "Moorea-Maiao - Moorea Temae Airport" },
{ code: "HOI", name: "Otepa - Hao Airport" },
{ code: "MAU", name: " - Maupiti Airport" },
{ code: "RFP", name: "Uturoa - Raiatea Airport" },
{ code: "ZGU", name: "Gaua Island - Gaua Island Airport" },
{ code: "SON", name: "Luganville - Santo Pekoa International Airport" },
{ code: "VLI", name: "Port Vila - Bauerfield International Airport" },
{ code: "TAH", name: "Tanna Island - Whitegrass Airport" },
{ code: "TGJ", name: "Tiga - Tiga Airport" },
{ code: "KNQ", name: "KonÃ© - KonÃ© Airport" },
{ code: "ILP", name: "ÃŽle des Pins - ÃŽle des Pins Airport" },
{ code: "LIF", name: "Lifou - Lifou Airport" },
{ code: "GEA", name: "NoumÃ©a - NoumÃ©a Magenta Airport" },
{ code: "MEE", name: "MarÃ© - MarÃ© Airport" },
{ code: "TOU", name: "Touho - Touho Airport" },
{ code: "UVE", name: "OuvÃ©a - OuvÃ©a Airport" },
{ code: "NOU", name: "NoumÃ©a (La Tontouta) - La Tontouta International Airport" },
{ code: "AKL", name: "Auckland - Auckland International Airport" },
{ code: "TUO", name: "Taupo - Taupo Airport" },
{ code: "AMZ", name: "Manurewa - Ardmore Airport" },
{ code: "CHC", name: "Christchurch - Christchurch International Airport" },
{ code: "CHT", name: "Te One - Chatham Islands / Tuuta Airport" },
{ code: "DUD", name: "Dunedin - Dunedin International Airport" },
{ code: "GIS", name: "Gisborne - Gisborne Airport" },
{ code: "GTN", name: "Glentanner Station - Glentanner Airport" },
{ code: "HKK", name: " - Hokitika Airfield" },
{ code: "HLZ", name: "Hamilton - Hamilton International Airport" },
{ code: "KKE", name: "Kerikeri - Kerikeri Airport" },
{ code: "KAT", name: "Awanui - Kaitaia Airport" },
{ code: "ALR", name: "Alexandra - Alexandra Aerodrome" },
{ code: "MON", name: " - Mount Cook Airport" },
{ code: "TEU", name: " - Manapouri Airport" },
{ code: "MRO", name: "Masterton - Hood Airport" },
{ code: "NPL", name: "New Plymouth - New Plymouth Airport" },
{ code: "NPE", name: "Napier - Hawke's Bay Airport" },
{ code: "NSN", name: "Nelson - Nelson Airport" },
{ code: "IVC", name: "Invercargill - Invercargill Airport" },
{ code: "OHA", name: " - RNZAF Base Ohakea" },
{ code: "OAM", name: " - Oamaru Airport" },
{ code: "PMR", name: "Palmerston North - Palmerston North Airport" },
{ code: "PPQ", name: " - Paraparaumu Airport" },
{ code: "ZQN", name: "Queenstown - Queenstown International Airport" },
{ code: "ROT", name: "Rotorua - Rotorua Regional Airport" },
{ code: "TRG", name: "Tauranga - Tauranga Airport" },
{ code: "TIU", name: " - Timaru Airport" },
{ code: "TWZ", name: "Twitzel - Pukaki Airport" },
{ code: "BHE", name: "Blenheim - Woodbourne Airport" },
{ code: "WKA", name: "Wanaka - Wanaka Airport" },
{ code: "WHK", name: " - Whakatane Airport" },
{ code: "WLG", name: "Wellington - Wellington International Airport" },
{ code: "WIR", name: "Wairoa - Wairoa Airport" },
{ code: "WRE", name: "Whangarei - Whangarei Airport" },
{ code: "WSZ", name: "Westport - Westport Airport" },
{ code: "WAG", name: "Wanganui - Wanganui Airport" },
{ code: "HEA", name: "Guzara - Herat - Khwaja Abdullah Ansari International Airport" },
{ code: "OAI", name: "Bagram - Bagram Airfield" },
{ code: "JAA", name: "Jalalabad - Jalalabad Airport" },
{ code: "KBL", name: "Kabul - Kabul International Airport" },
{ code: "KDH", name: "Khvoshab - Ahmad Shah Baba International Airport / Kandahar Airfield" },
{ code: "KHT", name: "Khost - Khost International Airport" },
{ code: "MMZ", name: "Maymana - Maymana Zahiraddin Faryabi Airport" },
{ code: "MZR", name: "Mazar-i-Sharif - Mazar-i-Sharif International Airport" },
{ code: "UND", name: "Kunduz - Kunduz Airport" },
{ code: "BAH", name: "Manama - Bahrain International Airport" },
{ code: "AHB", name: "Abha - Abha International Airport" },
{ code: "HOF", name: "Hofuf - Al-Ahsa International Airport" },
{ code: "ULH", name: "Al Ula - Majeed Bin Abdulaziz Airport" },
{ code: "ABT", name: "Al-Baha - King Saud Bin Abdulaziz (Al Baha) Airport" },
{ code: "BHH", name: "Bisha - Bisha Airport" },
{ code: "DMM", name: "Ad Dammam - King Fahd International Airport" },
{ code: "DWD", name: "Dawadmi - King Salman Abdulaziz Airport" },
{ code: "DHA", name: "Dhahran - King Abdulaziz Air Base" },
{ code: "GIZ", name: "Jizan - Jizan Regional Airport / King Abdullah bin Abdulaziz Airport" },
{ code: "ELQ", name: "Buraidah - Gassim Airport" },
{ code: "URY", name: "Gurayat - Gurayat Domestic Airport" },
{ code: "HAS", name: "Ha'il - Ha'il Airport" },
{ code: "QJB", name: "Jubail - Jubail Airport" },
{ code: "JED", name: "Jeddah - King Abdulaziz International Airport" },
{ code: "KMC", name: "King Khaled Military City - King Khaled Military City Airport" },
{ code: "KMX", name: "Khamis Mushait - King Khalid Air Base" },
{ code: "MED", name: "Medina - Prince Mohammad Bin Abdulaziz Airport" },
{ code: "EAM", name: "Najran - Najran Domestic Airport" },
{ code: "NUM", name: "Sharma - Neom Bay Airport" },
{ code: "AQI", name: "Qaisumah - Al Qaisumah/Hafr Al Batin Airport" },
{ code: "AKH", name: "Al Kharj - Prince Sultan Air Base" },
{ code: "RAH", name: "Rafha - Rafha Domestic Airport" },
{ code: "RUH", name: "Riyadh - King Khaled International Airport" },
{ code: "RAE", name: "Arar - Arar Domestic Airport" },
{ code: "SHW", name: "Sharurah - Sharurah Domestic Airport" },
{ code: "AJF", name: "Al-Jawf - Al-Jawf Domestic Airport" },
{ code: "TUU", name: "Tabuk - Tabuk Airport" },
{ code: "TIF", name: "Taâ€™if - Taâ€™if Regional Airport" },
{ code: "TUI", name: "Turaif - Turaif Domestic Airport" },
{ code: "WAE", name: "Wadi Al Dawasir - Wadi Al Dawasir Domestic Airport" },
{ code: "EJH", name: "Al Wajh - Al Wajh Domestic Airport" },
{ code: "YNB", name: "Yanbu - Prince Abdul Mohsin bin Abdulaziz International Airport / Yanbu Airport" },
{ code: "ABD", name: "Abadan - Abadan Airport" },
{ code: "DEF", name: "Dezful - Dezful Airport" },
{ code: "AKW", name: "Aghajari - Aghajari Airport" },
{ code: "GCH", name: "Gachsaran - Gachsaran Airport" },
{ code: "QMJ", name: "Masjed Soleyman - Shahid Asiyaee Airport" },
{ code: "MRX", name: "Mahshahr - Mahshahr Airport" },
{ code: "AWZ", name: "Ahvaz - Lieutenant General Qasem Soleimani International Airport" },
{ code: "AEU", name: "Abu Musa - Abu Musa Island Airport" },
{ code: "BUZ", name: "Bushehr - Bushehr Airport" },
{ code: "KNR", name: "Jam - Jam Airport" },
{ code: "KIH", name: "Kish Island - Kish International Airport" },
{ code: "BDH", name: "Bandar Lengeh - Bandar Lengeh International Airport" },
{ code: "PGU", name: "Khiyaroo - Persian Gulf International Airport" },
{ code: "KHK", name: "Khark - Khark Airport" },
{ code: "SXI", name: "Siri - Siri Airport" },
{ code: "LVP", name: "Lavan Airport - Lavan Airport" },
{ code: "KSH", name: "Kermanshah - Shahid Ashrafi Esfahani Airport" },
{ code: "IIL", name: "Ilam - Ilam Airport" },
{ code: "KHD", name: " - Khoram Abad Airport" },
{ code: "SDG", name: " - Sanandaj Airport" },
{ code: "KKS", name: "Kashan - Kashan Airport" },
{ code: "IFN", name: "Isfahan - Isfahan Shahid Beheshti International Airport" },
{ code: "CQD", name: "Shahrekord - Shahrekord Airport" },
{ code: "RAS", name: "Rasht - Sardar-e-Jangal Airport" },
{ code: "HDM", name: "Hamadan - Hamadan Airport" },
{ code: "NUJ", name: "Amirabad - Nojeh Air Base" },
{ code: "IKA", name: "Tehran - Imam Khomeini International Airport" },
{ code: "THR", name: "Tehran - Mehrabad International Airport" },
{ code: "GZW", name: "Qazvin - Qazvin Airport" },
{ code: "PYK", name: "Karaj - Payam Karaj International Airport" },
{ code: "BND", name: "Bandar Abbas - Bandar Abbas International Airport" },
{ code: "JYR", name: "Jiroft - Jiroft Airport" },
{ code: "KER", name: "Kerman - Ayatollah Hashemi Rafsanjani International Airport" },
{ code: "BXR", name: "Bam - Bam Airport" },
{ code: "RJN", name: "Rafsanjan - Rafsanjan Airport" },
{ code: "SYJ", name: "Sirjan - Sirjan Airport" },
{ code: "XBJ", name: "Birjand - Birjand International Airport" },
{ code: "CKT", name: "Sarakhs - Sarakhs Airport" },
{ code: "MHD", name: "Mashhad - Mashhad International Airport" },
{ code: "BJB", name: "Bojnord - Bojnord Airport" },
{ code: "AFZ", name: "Sabzevar - Sabzevar National Airport" },
{ code: "TCX", name: "Tabas - Tabas Airport" },
{ code: "GBT", name: "Gorgan - Gorgan Airport" },
{ code: "NSH", name: "Nowshahr - Nowshahr Airport" },
{ code: "RZR", name: "Ramsar - Ramsar Airport" },
{ code: "SRY", name: "Sari - Sari Dasht-e Naz International Airport" },
{ code: "FAZ", name: "Fasa - Fasa Airport" },
{ code: "LRR", name: "Lar - Lar Airport" },
{ code: "LFM", name: "Lamerd - Lamerd Airport" },
{ code: "SYZ", name: "Shiraz - Shiraz Shahid Dastghaib International Airport" },
{ code: "YES", name: "Yasuj - Yasuj Airport" },
{ code: "ADU", name: "Ardabil - Ardabil Airport" },
{ code: "OMH", name: "Urmia - Urmia Airport" },
{ code: "TBZ", name: "Tabriz - Tabriz International Airport" },
{ code: "IMQ", name: "Showt - Maku National Airport" },
{ code: "JWN", name: "Zanjan - Zanjan Airport" },
{ code: "AZD", name: "Yazd - Shahid Sadooghi Airport" },
{ code: "ACZ", name: "Zabol - Zabol Airport" },
{ code: "ZBR", name: "Konarak - Chabahar Konarak International Airport" },
{ code: "ZAH", name: "Zahedan - Zahedan International Airport" },
{ code: "IHR", name: "Iranshahr - Iranshahr Airport" },
{ code: "AMM", name: "Amman - Queen Alia International Airport" },
{ code: "ADJ", name: "Amman - Amman Civil (Marka International) Airport" },
{ code: "AQJ", name: "Aqaba - Aqaba King Hussein International Airport" },
{ code: "XIJ", name: "Ahmed Al Jaber AB - Ahmed Al Jaber Air Base" },
{ code: "KWI", name: "Kuwait City - Kuwait International Airport" },
{ code: "BEY", name: "Beirut - Beirut Rafic Hariri International Airport" },
{ code: "KYE", name: "Tripoli - Rene Mouawad Air Base / Kleyate Airport" },
{ code: "DQM", name: "Duqm - Duqm International Airport" },
{ code: "MNH", name: "Al Masna'ah - Mussanah Airport" },
{ code: "AUH", name: "Abu Dhabi - Zayed International Airport" },
{ code: "AZI", name: "Abu Dhabi - Al Bateen Executive Airport" },
{ code: "AAN", name: "Al Ain - Al Ain International Airport" },
{ code: "DHF", name: " - Al Dhafra Air Base" },
{ code: "XSB", name: "Sir Bani Yas - Sir Bani Yas Airport" },
{ code: "DXB", name: "Dubai - Dubai International Airport" },
{ code: "NHD", name: "Dubai - Al Minhad Air Base" },
{ code: "DWC", name: "Jebel Ali - Al Maktoum International Airport" },
{ code: "FJR", name: "Fujairah - Fujairah International Airport" },
{ code: "RKT", name: "Ras Al Khaimah - Ras Al Khaimah International Airport" },
{ code: "SHJ", name: "Sharjah - Sharjah International Airport" },
{ code: "KHS", name: "Khasab - Khasab Airport" },
{ code: "MSH", name: "Masirah - RAFO Masirah" },
{ code: "MCT", name: "Muscat - Muscat International Airport" },
{ code: "SLL", name: "Salalah - Salalah Airport" },
{ code: "TTH", name: "Thumrait - Thumrait Air Base" },
{ code: "BHV", name: "Bahawalpur - Bahawalpur Airport" },
{ code: "CJL", name: "Chitral - Chitral Airport" },
{ code: "DEA", name: "Dera Ghazi Khan - Dera Ghazi Khan Airport" },
{ code: "DSK", name: "Dera Ismael Khan - Dera Ismael Khan Airport" },
{ code: "LYP", name: "Faisalabad - Faisalabad International Airport" },
{ code: "GWD", name: "Gurandani - New Gwadar International Airport" },
{ code: "GIL", name: "Gilgit - Gilgit Airport" },
{ code: "ISB", name: "Attock - Islamabad International Airport" },
{ code: "JAG", name: "Jacobabad - Shahbaz Air Base" },
{ code: "KHI", name: "Karachi - Jinnah International Airport" },
{ code: "LHE", name: "Lahore - Allama Iqbal International Airport" },
{ code: "XJM", name: "Mangla - Mangla Airport" },
{ code: "MFG", name: "Muzaffarabad - Muzaffarabad Airport" },
{ code: "MWD", name: "Mianwali - Mianwali Air Base" },
{ code: "MJD", name: "Moenjodaro - Moenjodaro Airport" },
{ code: "ATG", name: "Kamra - Minhas Air Base" },
{ code: "MUX", name: "Multan - Multan International Airport" },
{ code: "WNS", name: "Nawabashah - Shaheed Benazirabad Airport" },
{ code: "PJG", name: "Panjgur - Panjgur Airport" },
{ code: "PSI", name: "Pasni - Pasni Airport" },
{ code: "PEW", name: "Peshawar - Peshawar International Airport" },
{ code: "UET", name: "Quetta - Quetta International Airport" },
{ code: "RYK", name: "Rahim Yar Khan - Shaikh Zaid Airport" },
{ code: "RAZ", name: "Rawalakot - Rawalakot Airport" },
{ code: "KDU", name: "Skardu - Skardu Airport" },
{ code: "SKZ", name: "Mirpur Khas - Sukkur Airport" },
{ code: "SYW", name: "Sehwan Sharif - Sehwan Sharif Airport" },
{ code: "SGI", name: "Sargodha - Mushaf Air Base" },
{ code: "SDT", name: "Saidu Sharif - Saidu Sharif Airport" },
{ code: "SKT", name: "Sialkot - Sialkot International Airport" },
{ code: "SUL", name: "Sui - Sui Airport" },
{ code: "TUK", name: "Turbat - Turbat International Airport" },
{ code: "PZH", name: "Fort Sandeman - Zhob Airport" },
{ code: "IQA", name: "HÄ«t - Al Asad Air Base" },
{ code: "TQD", name: "Al Habbaniyah - Al Taqaddum Air Base" },
{ code: "BGW", name: "Baghdad - Baghdad International Airport / New Al Muthana Air Base" },
{ code: "OSM", name: "Mosul - Mosul International Airport" },
{ code: "EBL", name: "Arbil - Erbil International Airport" },
{ code: "KIK", name: "Kirkuk - Kirkuk Air Base" },
{ code: "BSR", name: "Basra - Basra International Airport" },
{ code: "NJF", name: "Najaf - Al Najaf International Airport" },
{ code: "RQW", name: "Qayyarah - Qayyarah West Airport" },
{ code: "ISU", name: "Sulaymaniyah - Sulaymaniyah International Airport" },
{ code: "XNH", name: "Nasiriyah - Ali Air Base" },
{ code: "ALP", name: "Aleppo - Aleppo International Airport" },
{ code: "DAM", name: "Damascus - Damascus International Airport" },
{ code: "DEZ", name: "Deir ez-Zor - Deir ez-Zor Airport" },
{ code: "KAC", name: "Qamishly - Qamishli Airport" },
{ code: "LTK", name: "Latakia - Hmeimim Air Base" },
{ code: "PMS", name: "Tadmur - Palmyra Airport" },
{ code: "DIA", name: "Doha - Doha International Airport" },
{ code: "XJD", name: "Ar Rayyan - Al Udeid Air Base" },
{ code: "DOH", name: "Doha - Hamad International Airport" },
{ code: "ADE", name: "Aden - Aden International Airport" },
{ code: "AXK", name: "Ataq - Ataq Airport" },
{ code: "AAY", name: "Al Ghaydah - Al Ghaydah International Airport" },
{ code: "RIY", name: "Riyan - Riyan Mukalla International Airport" },
{ code: "SAH", name: "Sanaa - Sanaa International Airport" },
{ code: "SCT", name: "Mori - Socotra International Airport" },
{ code: "GXF", name: "Seiyun - Seiyun Hadhramaut International Airport" },
{ code: "TAI", name: "Ta'izz - Ta'izz International Airport" },
{ code: "PAQ", name: "Palmer - Warren Bud Woods Palmer Municipal Airport" },
{ code: "BTI", name: "Barter Island - Barter Island Long Range Radar Station Airport" },
{ code: "BET", name: "Bethel - Bethel Airport" },
{ code: "BIG", name: "Delta Junction Ft Greely - Allen Army Airfield" },
{ code: "BRW", name: "UtqiaÄ¡vik - Wiley Post Will Rogers Memorial Airport" },
{ code: "CDB", name: "Cold Bay - Cold Bay Airport" },
{ code: "CDV", name: "Cordova - Merle K (Mudhole) Smith Airport" },
{ code: "CZF", name: "Cape Romanzof - Cape Romanzof LRRS Airport" },
{ code: "DRG", name: "Deering - Deering Airport" },
{ code: "ADK", name: "Adak - Adak Airport" },
{ code: "DLG", name: "Dillingham - Dillingham Airport" },
{ code: "ADQ", name: "Kodiak - Kodiak Airport" },
{ code: "DUT", name: "Unalaska - Tom Madsen (Dutch Harbor) Airport" },
{ code: "EDF", name: "Anchorage - Elmendorf Air Force Base" },
{ code: "EHM", name: "Cape Newenham - Cape Newenham LRRS Airport" },
{ code: "EIL", name: "Fairbanks - Eielson Air Force Base" },
{ code: "EMK", name: "Emmonak - Emmonak Airport" },
{ code: "ENA", name: "Kenai - Kenai Municipal Airport" },
{ code: "FAI", name: "Fairbanks - Fairbanks International Airport" },
{ code: "FBK", name: "Fairbanks - Ladd Army Airfield" },
{ code: "ABL", name: "Ambler - Ambler Airport" },
{ code: "GAL", name: "Galena - Edward G. Pitka Sr Airport" },
{ code: "GKN", name: "Gulkana - Gulkana Airport" },
{ code: "GAM", name: "Gambell - Gambell Airport" },
{ code: "GST", name: "Gustavus - Gustavus Airport" },
{ code: "HCR", name: "Holy Cross - Holy Cross Airport" },
{ code: "HSL", name: "Huslia - Huslia Airport" },
{ code: "HNS", name: "Haines - Haines Airport" },
{ code: "HOM", name: "Homer - Homer Airport" },
{ code: "EGX", name: "Egegik - Egegik Airport" },
{ code: "IAN", name: "Kiana - Bob Baker Memorial Airport" },
{ code: "ILI", name: "Iliamna - Iliamna Airport" },
{ code: "UTO", name: "Utopia Creek - Indian Mountain LRRS Airport" },
{ code: "JNU", name: "Juneau - Juneau International Airport" },
{ code: "AKN", name: "King Salmon - King Salmon Airport" },
{ code: "AKP", name: "Anaktuvuk Pass - Anaktuvuk Pass Airport" },
{ code: "KTN", name: "Ketchikan - Ketchikan International Airport" },
{ code: "KLW", name: "Klawock - Klawock Airport" },
{ code: "LUR", name: "Cape Lisburne - Cape Lisburne LRRS Airport" },
{ code: "MCG", name: "McGrath - McGrath Airport" },
{ code: "MRI", name: "Anchorage - Merrill Field" },
{ code: "MYU", name: "Mekoryuk - Mekoryuk Airport" },
{ code: "ANC", name: "Anchorage - Ted Stevens Anchorage International Airport" },
{ code: "ANI", name: "Aniak - Aniak Airport" },
{ code: "ENN", name: "Nenana - Nenana Municipal Airport" },
{ code: "ANN", name: "Metlakatla - Annette Island Airport" },
{ code: "ANV", name: "Anvik - Anvik Airport" },
{ code: "OME", name: "Nome - Nome Airport" },
{ code: "ORT", name: "Northway - Northway Airport" },
{ code: "OTZ", name: "Kotzebue - Ralph Wien Memorial Airport" },
{ code: "STG", name: "St George - St George Airport" },
{ code: "KPC", name: "Port Clarence - Port Clarence Coast Guard Station" },
{ code: "PSG", name: "Petersburg - Petersburg James A Johnson Airport" },
{ code: "PTH", name: "Port Heiden - Port Heiden Airport" },
{ code: "PTU", name: "Platinum - Platinum Airport" },
{ code: "NUI", name: "Nuiqsut - Nuiqsut Airport" },
{ code: "ARC", name: "Arctic Village - Arctic Village Airport" },
{ code: "RBY", name: "Ruby - Ruby Airport" },
{ code: "SVA", name: "Savoonga - Savoonga Airport" },
{ code: "SCC", name: "Deadhorse - Deadhorse Airport" },
{ code: "SDP", name: "Sand Point - Sand Point Airport" },
{ code: "SIT", name: "Sitka - Sitka Rocky Gutierrez Airport" },
{ code: "SNP", name: "St Paul Island - St Paul Island Airport" },
{ code: "SVW", name: "Sparrevohn - Sparrevohn LRRS Airport" },
{ code: "SXQ", name: "Soldotna - Soldotna Airport" },
{ code: "SYA", name: "Shemya - Eareckson Air Station" },
{ code: "TKA", name: "Talkeetna - Talkeetna Airport" },
{ code: "TLJ", name: "Takotna - Tatalina LRRS Airport" },
{ code: "ATK", name: "Atqasuk - Atqasuk Edward Burnell Sr Memorial Airport" },
{ code: "UNK", name: "Unalakleet - Unalakleet Airport" },
{ code: "VDZ", name: "Valdez - Valdez Pioneer Field" },
{ code: "SWD", name: "Seward - Seward Airport" },
{ code: "WRG", name: "Wrangell - Wrangell Airport" },
{ code: "AIN", name: "Wainwright - Wainwright Airport" },
{ code: "WWA", name: "Wasilla - Wasilla Airport" },
{ code: "YAK", name: "Yakutat - Yakutat Airport" },
{ code: "CIS", name: "Abariringa - Canton Island Airport" },
{ code: "FYU", name: "Fort Yukon - Fort Yukon Airport" },
{ code: "ROP", name: "Rota Island - Rota International Airport" },
{ code: "SPN", name: "I Fadang, Saipan - Saipan International Airport" },
{ code: "UAM", name: "Yigo - Andersen Air Force Base" },
{ code: "GUM", name: "HagÃ¥tÃ±a - Antonio B. Won Pat International Airport" },
{ code: "TIQ", name: "Tinian Island - Tinian International Airport" },
{ code: "BKH", name: "Kekaha - Barking Sands Airport" },
{ code: "HNM", name: "Hana - Hana Airport" },
{ code: "HIK", name: "Honolulu - Hickam Air Force Base" },
{ code: "JHM", name: "Lahaina - Kapalua Airport" },
{ code: "JRF", name: "Kapolei - Kalaeloa Airport" },
{ code: "KOA", name: "Kailua-Kona - Ellison Onizuka Kona International Airport at Keahole" },
{ code: "LIH", name: "Lihue - Lihue Airport" },
{ code: "MKK", name: "Kaunakakai - Molokai Airport" },
{ code: "MUE", name: "Waimea (Kamuela) - Waimea Kohala Airport" },
{ code: "NGF", name: "Kaneohe - Kaneohe Bay MCAS (Marion E. Carl Field) Airport" },
{ code: "HNL", name: "Honolulu, Oahu - Daniel K Inouye International Airport" },
{ code: "LNY", name: "Lanai City - Lanai Airport" },
{ code: "OGG", name: "Kahului - Kahului International Airport" },
{ code: "ITO", name: "Hilo - Hilo International Airport" },
{ code: "MAJ", name: "Majuro Atoll - Marshall Islands International Airport" },
{ code: "KWA", name: "Kwajalein - Bucholz Army Air Field" },
{ code: "CXI", name: "Kiritimati - Cassidy International Airport" },
{ code: "MDY", name: "Sand Island - Henderson Field" },
{ code: "PIZ", name: "Point Lay - Point Lay LRRS Airport" },
{ code: "TKK", name: "Weno Island - Chuuk International Airport" },
{ code: "PNI", name: "Pohnpei Island - Pohnpei International Airport" },
{ code: "ROR", name: "Babelthuap Island - Babelthuap Airport" },
{ code: "KSA", name: "Okat - Kosrae International Airport" },
{ code: "YAP", name: "Yap Island - Yap International Airport" },
{ code: "AWK", name: "Wake Island - Wake Island Airfield" },
{ code: "KNH", name: "Shang-I - Kinmen Airport" },
{ code: "LZN", name: "Matsu (Nangan) - Matsu Nangan Airport" },
{ code: "TTT", name: "Taitung City - Taitung Airport" },
{ code: "KHH", name: "Kaohsiung (Xiaogang) - Kaohsiung International Airport" },
{ code: "CYI", name: "Shuishang - Chiayi Airport" },
{ code: "HCN", name: "Hengchun - Hengchun Airport" },
{ code: "KYD", name: "Orchid Island - Lanyu Airport" },
{ code: "RMQ", name: "Taichung (Qingshui) - Taichung International Airport / Ching Chuang Kang Air Base" },
{ code: "MFK", name: "Matsu (Beigan) - Matsu Beigan Airport" },
{ code: "TNN", name: "Tainan (Rende) - Tainan International Airport / Tainan Air Base" },
{ code: "HSZ", name: "Hsinchu City - Hsinchu Air Base" },
{ code: "MZG", name: "Huxi - Penghu Magong Airport" },
{ code: "PIF", name: "Pingtung - Pingtung Air Force Base North" },
{ code: "TSA", name: "Taipei (Songshan) - Taipei Songshan Airport" },
{ code: "TPE", name: "Taoyuan - Taiwan Taoyuan International Airport" },
{ code: "HUN", name: "Hualien City - Hualien Airport" },
{ code: "NRT", name: "Narita - Narita International Airport" },
{ code: "MMJ", name: "Matsumoto - Shinshu-Matsumoto Airport" },
{ code: "IBR", name: "Omitama - Ibaraki Airport / JASDF Hyakuri Air Base" },
{ code: "IWO", name: "Ogasawara - Ioto (Iwo Jima) Airbase" },
{ code: "KIX", name: "Osaka - Kansai International Airport" },
{ code: "SHM", name: "Shirahama - Nanki Shirahama Airport" },
{ code: "UKB", name: "Kobe - Kobe Airport" },
{ code: "TJH", name: "Toyooka - Konotori Tajima Airport" },
{ code: "OBO", name: "Obihiro - Tokachi-Obihiro Airport" },
{ code: "CTS", name: "Sapporo - New Chitose Airport" },
{ code: "HKD", name: "Hakodate - Hakodate Airport" },
{ code: "KUH", name: "Kushiro - Kushiro Airport" },
{ code: "MMB", name: "ÅŒzora - Memanbetsu Airport" },
{ code: "SHB", name: "Nakashibetsu - Nakashibetsu Airport" },
{ code: "OKD", name: "Sapporo - Sapporo Okadama Airport" },
{ code: "WKJ", name: "Wakkanai - Wakkanai Airport" },
{ code: "IKI", name: "Iki - Iki Airport" },
{ code: "UBJ", name: "Ube - Yamaguchi Ube Airport" },
{ code: "TSJ", name: "Tsushima - Tsushima Airport" },
{ code: "MBE", name: "Monbetsu - Monbetsu Airport" },
{ code: "AKJ", name: "Higashikagura - Asahikawa Airport" },
{ code: "OIR", name: "Okushiri Island - Okushiri Airport" },
{ code: "RIS", name: "Rishiri - Rishiri Airport" },
{ code: "KUM", name: "Yakushima - Yakushima Airport" },
{ code: "FUJ", name: "Goto - Fukue Airport" },
{ code: "FUK", name: "Fukuoka - Fukuoka Airport" },
{ code: "TNE", name: "Tanegashima - New Tanegashima Airport" },
{ code: "KOJ", name: "Kagoshima - Kagoshima Airport" },
{ code: "KMI", name: "Miyazaki - Miyazaki Airport" },
{ code: "OIT", name: "Oita - Oita Airport" },
{ code: "KKJ", name: "Kitakyushu - Kitakyushu Airport" },
{ code: "HSG", name: "Saga - Saga Airport" },
{ code: "KMJ", name: "Kumamoto - Kumamoto Airport" },
{ code: "NGS", name: "Nagasaki - Nagasaki Airport" },
{ code: "NGO", name: "Tokoname - Chubu Centrair International Airport" },
{ code: "ASJ", name: "Amami - Amami Airport" },
{ code: "OKE", name: "Wadomari - Okinoerabu Airport" },
{ code: "KKX", name: "Kikai - Kikai Airport" },
{ code: "TKN", name: "Amagi - Tokunoshima Airport" },
{ code: "NKM", name: "Nagoya - Nagoya Airport / JASDF Komaki Air Base" },
{ code: "FKJ", name: "Fukui - Fukui Airport" },
{ code: "QGU", name: "Gifu - Gifu Airport" },
{ code: "KMQ", name: "Kanazawa - Komatsu Airport / JASDF Komatsu Air Base" },
{ code: "OKI", name: "Okinoshima - Oki Global Geopark Airport" },
{ code: "FSZ", name: "Makinohara / Shimada - Mount Fuji Shizuoka Airport" },
{ code: "TOY", name: "Toyama - Toyama Airport" },
{ code: "NTQ", name: "Wajima - Noto Satoyama Airport" },
{ code: "HIJ", name: "Hiroshima - Hiroshima Airport" },
{ code: "OKJ", name: "Okayama - Okayama Momotaro Airport" },
{ code: "IZO", name: "Izumo - Izumo Enmusubi Airport" },
{ code: "YGJ", name: "Yonago - Yonago Kitaro Airport / JASDF Miho Air Base" },
{ code: "IWK", name: "Iwakuni - Iwakuni Kintaikyo Airport / Marine Corps Air Station Iwakuni" },
{ code: "KCZ", name: "Nankoku - Kochi Ryoma Airport" },
{ code: "MYJ", name: "Matsuyama - Matsuyama Airport" },
{ code: "ITM", name: "Osaka - Osaka International Airport" },
{ code: "TTJ", name: "Tottori - Tottori Sand Dunes Conan Airport" },
{ code: "TKS", name: "Tokushima - Tokushima Awaodori Airport / JMSDF Tokushima Air Base" },
{ code: "TAK", name: "Takamatsu - Takamatsu Airport" },
{ code: "IWJ", name: "Masuda - Iwami Airport" },
{ code: "AOJ", name: "Aomori - Aomori Airport" },
{ code: "GAJ", name: "Higashine - Yamagata Airport" },
{ code: "SDS", name: "Sado - Sado Airport" },
{ code: "FKS", name: "Sukagawa - Fukushima Airport" },
{ code: "HHE", name: "Hachinohe - JMSDF Hachinohe Air Base / Hachinohe Airport" },
{ code: "HNA", name: "Hanamaki - Iwate Hanamaki Airport" },
{ code: "AXT", name: "Akita - Akita Airport" },
{ code: "MSJ", name: "Misawa - Misawa Airport / Misawa Air Base" },
{ code: "KIJ", name: "Niigata - Niigata Airport" },
{ code: "ONJ", name: "Kitaakita - Odate Noshiro Airport" },
{ code: "SDJ", name: "Natori - Sendai Airport" },
{ code: "SYO", name: "Shonai - Shonai Airport" },
{ code: "NJA", name: "Ayase / Yamato - JMSDF Atsugi Air Base / Naval Air Facility Atsugi" },
{ code: "HAC", name: "Hachijojima - Hachijojima Airport" },
{ code: "OIM", name: "Izu Oshima - Oshima Airport" },
{ code: "MYE", name: "Miyakejima - Miyakejima Airport" },
{ code: "HND", name: "Tokyo - Tokyo Haneda International Airport" },
{ code: "OKO", name: "Fussa - Yokota Air Base" },
{ code: "MWX", name: "Muan (Piseo-ri) - Muan International Airport" },
{ code: "KWJ", name: "Gwangju - Gwangju Airport" },
{ code: "KUV", name: "Gunsan - Gunsan Airport / Gunsan Air Base" },
{ code: "RSU", name: "Yeosu - Yeosu Airport" },
{ code: "KAG", name: "Gangneung - Gangneung Airport (K-18)" },
{ code: "WJU", name: "Wonju - Wonju Airport / Hoengseong Air Base (K-38/K-46)" },
{ code: "YNY", name: "Gonghang-ro - Yangyang International Airport" },
{ code: "CJU", name: "Jeju City - Jeju International Airport" },
{ code: "JDG", name: "Jeju Island - Jeongseok Airport" },
{ code: "PUS", name: "Busan - Gimhae International Airport" },
{ code: "HIN", name: "Sacheon - Sacheon Airport / Sacheon Air Base" },
{ code: "USN", name: "Ulsan - Ulsan Airport" },
{ code: "ICN", name: "Seoul - Incheon International Airport" },
{ code: "SSN", name: "Seongnam - Seoul Air Base (K-16)" },
{ code: "OSN", name: "Pyeongtaek - Osan Air Base" },
{ code: "GMP", name: "Seoul - Gimpo International Airport" },
{ code: "SWU", name: "Suwon - Suwon Airport" },
{ code: "KPO", name: "Pohang - Pohang Airport (G-815/K-3)" },
{ code: "JWO", name: "Gimseang-ro - Jungwon Air Base/Chungju Airport" },
{ code: "TAE", name: "Daegu - Daegu Airport" },
{ code: "CJJ", name: "Cheongju - Cheongju International Airport/Cheongju Air Base (K-59/G-513)" },
{ code: "YEC", name: "Yecheon-ri - Yecheon Airbase" },
{ code: "OKA", name: "Naha - Naha Airport / JASDF Naha Air Base" },
{ code: "DNA", name: "Okinawa - Kadena Air Base" },
{ code: "ISG", name: "Ishigaki - New Ishigaki Airport" },
{ code: "UEO", name: "Kumejima - Kumejima Airport" },
{ code: "MMD", name: "Minamidaito - Minamidaito Airport" },
{ code: "MMY", name: "Miyakojima - Miyako Airport" },
{ code: "IEJ", name: "Ie - Iejima Airport" },
{ code: "KTD", name: "KitadaitÅjima - Kitadaito Airport" },
{ code: "SHI", name: "Miyakojima - Shimojishima Airport" },
{ code: "TRA", name: "Tarama - Tarama Airport" },
{ code: "RNJ", name: "Yoron - Yoron Airport" },
{ code: "OGN", name: "Yonaguni - Yonaguni Airport" },
{ code: "SFS", name: "Olongapo - Subic Bay International Airport / Naval Air Station Cubi Point" },
{ code: "CRK", name: "Mabalacat - Clark International Airport / Clark Air Base" },
{ code: "LLC", name: "Lal-lo - Cagayan North International Airport" },
{ code: "LAO", name: "Laoag City - Laoag International Airport" },
{ code: "DRP", name: "Legazpi - Bicol International Airport" },
{ code: "MNL", name: "Manila (Pasay) - Ninoy Aquino International Airport" },
{ code: "SGL", name: "Cavite - Danilo Atienza Air Base" },
{ code: "LBX", name: "Lubang - Lubang Airport" },
{ code: "AAV", name: "Surallah - Allah Valley Airport" },
{ code: "CBO", name: "Datu Odin Sinsuat - Cotabato (Awang) Airport" },
{ code: "DVO", name: "Davao - Francisco Bangoy International Airport" },
{ code: "BXU", name: "Butuan - Bancasi Airport" },
{ code: "BPH", name: "Bislig - Bislig Airport" },
{ code: "DPL", name: "Dipolog - Dipolog Airport" },
{ code: "CGM", name: "Mambajao - Camiguin Airport" },
{ code: "JOL", name: "Jolo - Jolo Airport" },
{ code: "TWT", name: "Bongao - Sanga Sanga Airport" },
{ code: "OZC", name: "Ozamiz - Labo Airport" },
{ code: "PAG", name: "Pagadian - Pagadian Airport" },
{ code: "MXI", name: "Mati - Mati National Airport" },
{ code: "GES", name: "General Santos - General Santos International Airport" },
{ code: "SUG", name: "Surigao City - Surigao Airport" },
{ code: "TDG", name: "Tandag - Tandag Airport" },
{ code: "CGY", name: "Laguindingan - Laguindingan International Airport" },
{ code: "ZAM", name: "Zamboanga - Zamboanga International Airport" },
{ code: "TAG", name: "Panglao - Bohol-Panglao International Airport" },
{ code: "BAG", name: "Baguio - Loakan Airport" },
{ code: "DTE", name: "Daet - Daet Airport" },
{ code: "SJI", name: "San Jose - San Jose Airport" },
{ code: "MBO", name: "Mamburao - Mamburao Airport" },
{ code: "WNP", name: "Naga - Naga Airport" },
{ code: "BSO", name: "Basco - Basco Airport" },
{ code: "BQA", name: "Baler - Dr Juan C Angara Airport" },
{ code: "SFE", name: "San Fernando - San Fernando Airport" },
{ code: "TUG", name: "Tuguegarao City - Tuguegarao Airport" },
{ code: "VRC", name: "Virac - Virac Airport" },
{ code: "MRQ", name: "Gasan - Marinduque Airport" },
{ code: "CYZ", name: "Cauayan City - Cauayan Airport" },
{ code: "TAC", name: "Tacloban City - Daniel Z. Romualdez Airport" },
{ code: "BCD", name: "Bacolod City - Bacolod-Silay Airport" },
{ code: "CYP", name: "Calbayog City - Calbayog Airport" },
{ code: "DGT", name: "Dumaguete City - Sibulan Airport" },
{ code: "MPH", name: "Caticlan - Godofredo P. Ramos Airport" },
{ code: "CRM", name: "Catarman - Catarman National Airport" },
{ code: "ILO", name: "Cabatuan - Iloilo International Airport" },
{ code: "MBT", name: "Masbate - Moises R. Espinosa Airport" },
{ code: "KLO", name: "Kalibo - Kalibo International Airport" },
{ code: "CEB", name: "Lapu-Lapu City - Mactan Cebu International Airport" },
{ code: "OMC", name: "Ormoc City - Ormoc Airport" },
{ code: "PPS", name: "Puerto Princesa - Puerto Princesa International Airport / PAF Antonio Bautista Air Base" },
{ code: "RXS", name: "Roxas City - Roxas Airport" },
{ code: "EUQ", name: "San Jose - Evelio Javier Airport" },
{ code: "TBH", name: "Tablas Island - Tugdan Airport" },
{ code: "USU", name: "Coron - Francisco B. Reyes (Busuanga) Airport" },
{ code: "RSI", name: "Hanak - Red Sea International Airport" },
{ code: "NOI", name: "Krymsk - Krymsk Air Base" },
{ code: "LNX", name: "Smolensk - Smolensk North Airport" },
{ code: "EIK", name: "Yeysk - Yeysk Airport" },
{ code: "COC", name: "Concordia - Comodoro Pierrestegui Airport" },
{ code: "GHU", name: "Gualeguaychu - Gualeguaychu Airport" },
{ code: "PRA", name: "Parana - General Urquiza Airport" },
{ code: "ROS", name: "Rosario - Rosario Islas Malvinas International Airport" },
{ code: "SFN", name: "Santa Fe - Sauce Viejo Airport" },
{ code: "AEP", name: "Buenos Aires - Jorge Newbery Airpark" },
{ code: "COR", name: "Cordoba - Ingeniero Ambrosio Taravella Airport" },
{ code: "LPG", name: "La Plata - La Plata Airport" },
{ code: "EPA", name: "El Palomar - El Palomar Airport" },
{ code: "EZE", name: "Buenos Aires (Ezeiza) - Minister Pistarini International Airport" },
{ code: "RDS", name: "Rincon de los Sauces - Rincon De Los Sauces Airport" },
{ code: "APZ", name: "Zapala - Zapala Airport" },
{ code: "MDZ", name: "Mendoza - El Plumerillo Airport" },
{ code: "LGS", name: "Malargue - Comodoro D.R. SalomÃ³n Airport" },
{ code: "AFA", name: "San Rafael - Suboficial Ay Santiago Germano Airport" },
{ code: "CTC", name: "Catamarca - Coronel Felipe Varela International Airport" },
{ code: "SDE", name: "Santiago del Estero - Vicecomodoro Angel D. La Paz AragonÃ©s Airport" },
{ code: "IRJ", name: "La Rioja - Capitan V A Almonacid Airport" },
{ code: "RHD", name: "Termas de RÃ­o Hondo - Termas de RÃ­o Hondo international Airport" },
{ code: "TUC", name: "San Miguel de TucumÃ¡n - Teniente Benjamin Matienzo Airport" },
{ code: "UAQ", name: "San Juan - Domingo Faustino Sarmiento Airport" },
{ code: "RCU", name: "Rio Cuarto - Area De Material Airport" },
{ code: "VDR", name: "Villa Dolores - Villa Dolores Airport" },
{ code: "VME", name: "Villa Mercedes - Villa Reynolds Airport" },
{ code: "LUQ", name: "San Luis - Brigadier Mayor D Cesar Raul Ojeda Airport" },
{ code: "CNQ", name: "Corrientes - Corrientes Airport" },
{ code: "RES", name: "Resistencia - Resistencia International Airport" },
{ code: "FMA", name: "Formosa - Formosa National Airport" },
{ code: "IGR", name: "Puerto Iguazu - Cataratas Del IguazÃº International Airport" },
{ code: "AOL", name: "Paso de los Libres - Paso De Los Libres Airport" },
{ code: "MCS", name: "Monte Caseros - Monte Caseros Airport" },
{ code: "PSS", name: "Posadas - Libertador Gral D Jose De San Martin Airport" },
{ code: "SLA", name: "Salta - Martin Miguel De Guemes International Airport" },
{ code: "JUJ", name: "San Salvador de Jujuy - Gobernador Horacio Guzman International Airport" },
{ code: "ORA", name: "OrÃ¡n - OrÃ¡n Airport" },
{ code: "TTG", name: "Tartagal - General Enrique Mosconi Airport" },
{ code: "OYA", name: "Goya - Goya Airport" },
{ code: "RCQ", name: "Reconquista - Reconquista Airport" },
{ code: "UZU", name: "Curuzu Cuatia - Curuzu Cuatia Airport" },
{ code: "EHL", name: "El BolsÃ³n - El BolsÃ³n Airfield" },
{ code: "CRD", name: "Comodoro Rivadavia - General E. Mosconi Airport" },
{ code: "EQS", name: "Esquel - Esquel Brigadier Antonio Parodi International Airport" },
{ code: "LHS", name: "Las Heras - Las Heras Airport" },
{ code: "REL", name: "Rawson - Almirante Marco Andres Zar Airport" },
{ code: "VDM", name: "Viedma / Carmen de Patagones - Gobernador Castello Airport" },
{ code: "PMY", name: "Puerto Madryn - El Tehuelche Airport" },
{ code: "FTE", name: "El Calafate - El Calafate - Commander Armando Tola International Airport" },
{ code: "PUD", name: "Puerto Deseado - Puerto Deseado Airport" },
{ code: "RGA", name: "Rio Grande - Gobernador RamÃ³n Trejo Noel International Airport" },
{ code: "RGL", name: "Rio Gallegos - Piloto Civil N. FernÃ¡ndez Airport" },
{ code: "USH", name: "Ushuaia - Ushuaia - Malvinas Argentinas International Airport" },
{ code: "ULA", name: "San Julian - Capitan D Daniel Vazquez Airport" },
{ code: "PMQ", name: "Perito Moreno - Perito Moreno Jalil Hamer Airport" },
{ code: "RZA", name: "Puerto Santa Cruz - Santa Cruz Airport" },
{ code: "BHI", name: "BahÃ­a Blanca - Comandante Espora Airport" },
{ code: "GPO", name: "General Pico - General Pico Airport" },
{ code: "OYO", name: "Tres Arroyos - Tres Arroyos Airport" },
{ code: "SST", name: "Santa Teresita - Santa Teresita Airport" },
{ code: "MDQ", name: "Mar del Plata - Ãstor Piazzola International Airport" },
{ code: "NQN", name: "Neuquen - Presidente Peron Airport" },
{ code: "NEC", name: "Necochea - Necochea Airport" },
{ code: "PEH", name: "PehuajÃ³ - Comodoro Pedro Zanni Airport" },
{ code: "RSA", name: "Santa Rosa - Santa Rosa Airport" },
{ code: "BRC", name: "San Carlos de Bariloche - San Carlos de Bariloche Airport" },
{ code: "TDL", name: "Tandil - HÃ©roes de Malvinas Airport" },
{ code: "VLG", name: "Villa Gesell - Villa Gesell Airport" },
{ code: "CUT", name: "Cutral-Co - Cutral-Co Airport" },
{ code: "CPC", name: "Chapelco/San Martin de los Andes - Aviador C. Campos Airport" },
{ code: "CDJ", name: "ConceiÃ§Ã£o do Araguaia - ConceiÃ§Ã£o do Araguaia Airport" },
{ code: "ARX", name: "Aracati - Aracati DragÃ£o do Mar Regional Airport" },
{ code: "JTC", name: "Bauru - Bauru/Arealvaâ€“Moussa Nakhal Tobias State Airport" },
{ code: "AQA", name: "Araraquara - Araraquara Airport" },
{ code: "AJU", name: "Aracaju - Aracaju - Santa Maria International Airport" },
{ code: "AFL", name: "Alta Floresta - Piloto Osvaldo Marques Dias Airport" },
{ code: "ARU", name: "AraÃ§atuba - AraÃ§atuba Airport" },
{ code: "AAX", name: "AraxÃ¡ - Romeu Zema Airport" },
{ code: "BEL", name: "BelÃ©m - Val de Cans/JÃºlio Cezar Ribeiro International Airport" },
{ code: "BGX", name: "BagÃ© - Comandante Gustavo Kraemer Airport" },
{ code: "PLU", name: "Belo Horizonte - Pampulha - Carlos Drummond de Andrade Airport" },
{ code: "BFH", name: "Curitiba - Bacacheri Airport" },
{ code: "BSB", name: "BrasÃ­lia - Presidente Juscelino Kubitschek International Airport" },
{ code: "BAT", name: "Barretos - Chafei Amsei Airport" },
{ code: "BVB", name: "Boa Vista - Atlas Brasil Cantanhede Airport" },
{ code: "BPG", name: "Barra do GarÃ§as - Barra do GarÃ§as Airport" },
{ code: "BZC", name: "Cabo Frio - Umberto Modiano Airport" },
{ code: "CAC", name: "Cascavel - Coronel Adalberto Mendes da Silva Airport" },
{ code: "CNF", name: "Belo Horizonte - Tancredo Neves International Airport" },
{ code: "CGR", name: "Campo Grande - Campo Grande Airport" },
{ code: "XAP", name: "ChapecÃ³ - Serafin Enoss Bertaso Airport" },
{ code: "CLN", name: "Carolina - Brig. Lysias Augusto Rodrigues Airport" },
{ code: "CKS", name: "Parauapebas - CarajÃ¡s Airport" },
{ code: "CCM", name: "CriciÃºma - Forquilhinha - CriciÃºma  Airport" },
{ code: "QNS", name: "Porto Alegre - Canoas Air Force Base" },
{ code: "CAW", name: "Campos dos Goytacazes - Bartolomeu Lisandro Airport" },
{ code: "CMG", name: "CorumbÃ¡ - CorumbÃ¡ International Airport" },
{ code: "CWB", name: "Curitiba - Afonso Pena Airport" },
{ code: "CRQ", name: "Caravelas - Caravelas Airport" },
{ code: "CXJ", name: "Caxias Do Sul - Hugo Cantergiani Regional Airport" },
{ code: "CGB", name: "CuiabÃ¡ - Marechal Rondon Airport" },
{ code: "CZS", name: "Cruzeiro Do Sul - Cruzeiro do Sul Airport" },
{ code: "PPB", name: "Presidente Prudente - Presidente Prudente Airport" },
{ code: "MAO", name: "Manaus - Eduardo Gomes International Airport" },
{ code: "JCR", name: "Jacareacanga - Jacareacanga Airport" },
{ code: "IGU", name: "Foz do IguaÃ§u - Cataratas International Airport" },
{ code: "FLN", name: "FlorianÃ³polis - HercÃ­lio Luz International Airport" },
{ code: "FEN", name: "Fernando de Noronha - Fernando de Noronha Airport" },
{ code: "FOR", name: "Fortaleza - Pinto Martins International Airport" },
{ code: "GIG", name: "Rio De Janeiro - Rio GaleÃ£o â€“ Tom Jobim International Airport" },
{ code: "GJM", name: "GuajarÃ¡-Mirim - GuajarÃ¡-Mirim Airport" },
{ code: "GYN", name: "GoiÃ¢nia - Santa Genoveva Airport" },
{ code: "GRU", name: "SÃ£o Paulo - Guarulhos - Governador AndrÃ© Franco Montoro International Airport" },
{ code: "GVR", name: "Governador Valadares - Coronel Altino Machado Airport" },
{ code: "GUJ", name: "GuaratinguetÃ¡ - Edu Chaves Field" },
{ code: "ATM", name: "Altamira - Altamira Interstate Airport" },
{ code: "ITA", name: "Itacoatiara - Itacoatiara Airport" },
{ code: "ITB", name: "Itaituba - Itaituba Airport" },
{ code: "IOS", name: "IlhÃ©us - Bahia - Jorge Amado Airport" },
{ code: "IPN", name: "Ipatinga - Usiminas Airport" },
{ code: "IMP", name: "Imperatriz - Prefeito Renato Moreira Airport" },
{ code: "JJD", name: "Cruz - Comandante Ariston Pessoa Airport" },
{ code: "JDF", name: "Juiz de Fora - Francisco de Assis Airport" },
{ code: "JHF", name: "SÃ£o Roque - SÃ£o Paulo Catarina Executive Airport" },
{ code: "JPA", name: "JoÃ£o Pessoa - Presidente Castro Pinto International Airport" },
{ code: "JOI", name: "Joinville - Lauro Carneiro de Loyola Airport" },
{ code: "CPV", name: "Campina Grande - Presidente JoÃ£o Suassuna Airport" },
{ code: "VCP", name: "Campinas - Viracopos International Airport" },
{ code: "LAJ", name: "Lages - Lages Airport" },
{ code: "LIP", name: "Lins - Lins Airport" },
{ code: "LDB", name: "Londrina - Governor JosÃ© Richa Airport" },
{ code: "LAZ", name: "Bom Jesus da Lapa - Bom Jesus da Lapa Airport" },
{ code: "MAB", name: "MarabÃ¡ - JoÃ£o Correa da Rocha Airport" },
{ code: "MQH", name: "MinaÃ§u - MinaÃ§u Airport" },
{ code: "MEU", name: "Almeirim - Monte Dourado - Serra do AreÃ£o Airport" },
{ code: "MEA", name: "MacaÃ© - MacaÃ© Benedito Lacerda Airport" },
{ code: "MGF", name: "MaringÃ¡ - Regional de MaringÃ¡ - SÃ­lvio Name JÃºnior Airport" },
{ code: "MOC", name: "Montes Claros - MÃ¡rio Ribeiro Airport" },
{ code: "MII", name: "MarÃ­lia - Frank Miloye Milenkowichiâ€“MarÃ­lia State Airport" },
{ code: "PLL", name: "Manaus - Ponta Pelada Airport / Manaus Air Base" },
{ code: "MCZ", name: "MaceiÃ³ - Zumbi dos Palmares Airport" },
{ code: "MCP", name: "MacapÃ¡ - MacapÃ¡ - Alberto Alcolumbre International Airport" },
{ code: "MVF", name: "MossorÃ³ - Dix-Sept Rosado Airport" },
{ code: "RTE", name: "SÃ£o Paulo - Campo de Marte Airport" },
{ code: "MNX", name: "ManicorÃ© - ManicorÃ© Airport" },
{ code: "NVT", name: "Navegantes - Ministro Victor Konder International Airport" },
{ code: "GEL", name: "Santo Ã‚ngelo - Santo Ã‚ngelo Airport" },
{ code: "OYK", name: "Oiapoque - Oiapoque Airport" },
{ code: "POA", name: "Porto Alegre - Salgado Filho International Airport" },
{ code: "PHB", name: "ParnaÃ­ba - ParnaÃ­ba - Prefeito Doutor JoÃ£o Silva Filho International Airport" },
{ code: "POO", name: "PoÃ§os De Caldas - PoÃ§os de Caldas - Embaixador Walther Moreira Salles Airport" },
{ code: "PFB", name: "Passo Fundo - Lauro Kurtz Airport" },
{ code: "PGZ", name: "Ponta Grossa - Ponta Grossa Airport - Comandante Antonio Amilton Beraldo" },
{ code: "PMW", name: "Palmas - Brigadeiro Lysias Rodrigues Airport" },
{ code: "PET", name: "Pelotas - JoÃ£o SimÃµes Lopes Neto International Airport" },
{ code: "PNZ", name: "Petrolina - Senador Nilo Coelho Airport" },
{ code: "PNB", name: "Porto Nacional - Porto Nacional Airport" },
{ code: "PMG", name: "Ponta PorÃ£ - Ponta PorÃ£ Airport" },
{ code: "BPS", name: "Porto Seguro - Porto Seguro Airport" },
{ code: "PVH", name: "Porto Velho - Governador Jorge Teixeira de Oliveira Airport" },
{ code: "RBR", name: "Rio Branco - Rio Branco-PlÃ¡cido de Castro International Airport" },
{ code: "ROO", name: "RondonÃ³polis - Maestro Marinho Franco Airport" },
{ code: "REC", name: "Recife - Recife/Guararapes - Gilberto Freyre International Airport" },
{ code: "SDU", name: "Rio de Janeiro - Santos Dumont Airport" },
{ code: "RAO", name: "RibeirÃ£o Preto - Leite Lopes Airport" },
{ code: "SNZ", name: "Rio de Janeiro - Santa Cruz Air Force Base" },
{ code: "NAT", name: "Natal - SÃ£o GonÃ§alo do Amarante - Governador AluÃ­zio Alves International Airport" },
{ code: "SJK", name: "SÃ£o JosÃ© Dos Campos - Professor Urbano Ernesto Stumpf Airport" },
{ code: "SLZ", name: "SÃ£o LuÃ­s - Marechal Cunha Machado International Airport" },
{ code: "RIA", name: "Santa Maria - Santa Maria Airport" },
{ code: "STM", name: "SantarÃ©m - SantarÃ©m - Maestro Wilson Fonseca International Airport" },
{ code: "CGH", name: "SÃ£o Paulo - Congonhas Airport" },
{ code: "SJP", name: "SÃ£o JosÃ© do Rio Preto - Prof. Eribelto Manoel Reino State Airport" },
{ code: "SSZ", name: "GuarujÃ¡ - Santos Nero Moura Air Base / GuarujÃ¡ Airport" },
{ code: "SSA", name: "Salvador - Deputado Luiz Eduardo MagalhÃ£es International Airport" },
{ code: "TMT", name: "OriximinÃ¡ - Trombetas Airport" },
{ code: "THE", name: "Teresina - Senador PetrÃ´nio Portela Airport" },
{ code: "TFF", name: "TefÃ© - TefÃ© Airport" },
{ code: "TRQ", name: "TarauacÃ¡ - TarauacÃ¡ Airport" },
{ code: "TEC", name: "TelÃªmaco Borba - TelÃªmaco Borba Airport" },
{ code: "TBT", name: "Tabatinga - Tabatinga Airport" },
{ code: "TUR", name: "TucuruÃ­ - TucuruÃ­ Airport" },
{ code: "SJL", name: "SÃ£o Gabriel da Cachoeira - SÃ£o Gabriel da Cachoeira Airport" },
{ code: "PAV", name: "Paulo Afonso - Paulo Afonso Airport" },
{ code: "URG", name: "Uruguaiana - Rubem Berta Airport" },
{ code: "UDI", name: "UberlÃ¢ndia - Ten. Cel. Aviador CÃ©sar Bombonato Airport" },
{ code: "UBA", name: "Uberaba - MÃ¡rio de Almeida Franco Airport" },
{ code: "VAG", name: "Varginha - Major Brigadeiro Trompowsky Airport" },
{ code: "BVH", name: "Vilhena - Brigadeiro CamarÃ£o Airport" },
{ code: "VIX", name: "VitÃ³ria - Eurico de Aguiar Salles Airport" },
{ code: "QPS", name: "Pirassununga - Campo Fontenelle" },
{ code: "IZA", name: "Juiz de Fora - Presidente Itamar Franco Airport" },
{ code: "ARI", name: "Arica - Chacalluta Airport" },
{ code: "CPO", name: "Copiapo - Desierto de Atacama Airport" },
{ code: "BBA", name: "Balmaceda - Balmaceda Airport" },
{ code: "TOQ", name: "Tocopilla - Barriles Airport" },
{ code: "CCH", name: "Chile Chico - Chile Chico Airport" },
{ code: "CJC", name: "Calama - El Loa Airport" },
{ code: "YAI", name: "Chillan - Gral. Bernardo OÂ´Higgins Airport" },
{ code: "PUQ", name: "Punta Arenas - President Carlos IbaÃ±ez del Campo International Airport" },
{ code: "GXQ", name: "Coyhaique - Teniente Vidal Airport" },
{ code: "IQQ", name: "Iquique - Diego Aracena Airport" },
{ code: "SCL", name: "Santiago - Comodoro Arturo Merino BenÃ­tez International Airport" },
{ code: "ESR", name: "El Salvador - Ricardo GarcÃ­a Posada Airport" },
{ code: "ANF", name: "Antofagasta - AndrÃ©s Sabella GÃ¡lvez International Airport" },
{ code: "WPR", name: "Porvenir - Captain Fuentes Martinez Airport" },
{ code: "WPU", name: "Puerto Williams - Guardia Marina ZaÃ±artu Airport" },
{ code: "LGR", name: "Cochrane - Cochrane Airport" },
{ code: "CCP", name: "Concepcion - Carriel Sur Airport" },
{ code: "IPC", name: "Isla De Pascua - Mataveri Airport" },
{ code: "ZOS", name: "Osorno - CaÃ±al Bajo Carlos Hott Siebert Airport" },
{ code: "VLR", name: "Vallenar - Vallenar Airport" },
{ code: "PNT", name: "Puerto Natales - Lieutenant Julio Gallardo Airport" },
{ code: "ZCO", name: "Temuco - La AraucanÃ­a Airport" },
{ code: "CNR", name: "ChaÃ±aral - ChaÃ±aral Airport" },
{ code: "LSC", name: "La Serena-Coquimbo - La Florida Airport" },
{ code: "PZS", name: "Temuco - Maquehue Airport" },
{ code: "PMC", name: "Puerto Montt - El Tepual Airport" },
{ code: "TLX", name: "Talca - Panguilemo Airport" },
{ code: "WCH", name: "ChaitÃ©n - Nuevo ChaitÃ©n Airport" },
{ code: "ZIC", name: "Victoria - Victoria Airport" },
{ code: "TTC", name: "Taltal - Las Breas Airport" },
{ code: "ZAL", name: "Valdivia - Pichoy Airport" },
{ code: "KNA", name: "ViÃ±a del Mar - ViÃ±a del Mar Airport" },
{ code: "ATF", name: "Ambato - ChachoÃ¡n Regional Airport" },
{ code: "OCC", name: "Coca - Francisco De Orellana Airport" },
{ code: "CUE", name: "Cuenca - Mariscal Lamar Airport" },
{ code: "GYE", name: "Guayaquil - JosÃ© JoaquÃ­n de Olmedo International Airport" },
{ code: "TNW", name: "Ahuano - Jumandy Airport" },
{ code: "LTX", name: "Latacunga - Cotopaxi International Airport" },
{ code: "MRR", name: "MacarÃ¡ - Jose Maria Velasco Ibarra Airport" },
{ code: "XMS", name: "Macas - Coronel E Carvajal Airport" },
{ code: "MEC", name: "Manta - Eloy Alfaro International Airport" },
{ code: "PVO", name: "Portoviejo - Reales Tamarindos Airport" },
{ code: "UIO", name: "Quito - Mariscal Sucre International Airport" },
{ code: "ETR", name: "Santa Rosa - Santa Rosa - Artillery Colonel Victor Larrea International Airport" },
{ code: "SNC", name: "Salinas - General Ulpiano Paez Airport" },
{ code: "ESM", name: "Tachina - Carlos Concha Torres International Airport" },
{ code: "TPC", name: "Tarapoa - Tarapoa Airport" },
{ code: "TUA", name: "TulcÃ¡n - Lieutenant Colonel Luis A. Mantilla International Airport" },
{ code: "PSY", name: "Stanley - Port Stanley Airport" },
{ code: "ASU", name: "AsunciÃ³n - Aeropuerto Internacional Silvio Pettirossi" },
{ code: "AYO", name: "Ayolas - Aeropuerto Nacional Juan de Ayolas" },
{ code: "CIO", name: "ConcepciÃ³n - Aeropuerto Nacional Tte. Cnel. Carmelo Peralta" },
{ code: "ENO", name: "EncarnaciÃ³n - Aeropuerto Internacional Tte. AmÃ­n Ayub GonzÃ¡lez" },
{ code: "AGT", name: "Ciudad del Este - Aeropuerto Internacional GuaranÃ­" },
{ code: "ESG", name: "Mariscal Estigarribia - Aeropuerto Internacional Dr. Luis Maria ArgaÃ±a" },
{ code: "PIL", name: "Pilar - AerÃ³dromo Don Carlos Miguel Gimenez" },
{ code: "PJC", name: "Pedro Juan Caballero - Aeropuerto Nacional Dr. Augusto Roberto Fuster" },
{ code: "API", name: "Apiay - Gomez Nino Apiay Air Base" },
{ code: "AXM", name: "Armenia - El Eden Airport" },
{ code: "PUU", name: "Puerto AsÃ­s - Tres De Mayo Airport" },
{ code: "ELB", name: "El Banco - Las Flores Airport" },
{ code: "BGA", name: "Bucaramanga - Palonegro Airport" },
{ code: "BOG", name: "Bogota - El Dorado International Airport" },
{ code: "BAQ", name: "Barranquilla - Ernesto Cortissoz International Airport" },
{ code: "BSC", name: "BahÃ­a Solano - JosÃ© Celestino Mutis Airport" },
{ code: "BUN", name: "Buenaventura - Gerardo Tobar LÃ³pez Airport" },
{ code: "CUC", name: "CÃºcuta - Camilo Daza International Airport" },
{ code: "CTG", name: "Cartagena - Rafael NuÃ±ez International Airport" },
{ code: "CLO", name: "Cali - Alfonso Bonilla Aragon International Airport" },
{ code: "TCO", name: "Tumaco - La Florida Airport" },
{ code: "CAQ", name: "Caucasia - Juan H White Airport" },
{ code: "CVE", name: "CoveÃ±as - CoveÃ±as Airport" },
{ code: "CZU", name: "Corozal - Las Brujas Airport" },
{ code: "EBG", name: "El Bagre - El Bagre Airport" },
{ code: "EJA", name: "Barrancabermeja - YariguÃ­es Airport" },
{ code: "FLA", name: "Florencia - Gustavo Artunduaga Paredes Airport" },
{ code: "GIR", name: "Girardot - Santiago Vila Airport" },
{ code: "CRC", name: "Cartago - Santa Ana Airport" },
{ code: "GPI", name: "Guapi - Juan Casiano Airport" },
{ code: "IBE", name: "IbaguÃ© - Perales Airport" },
{ code: "IPI", name: "Ipiales - San Luis Airport" },
{ code: "APO", name: "Carepa - Antonio RoldÃ¡n Betancur Airport" },
{ code: "MCJ", name: "La Mina-Maicao - Jorge Isaac Airport" },
{ code: "LET", name: "Leticia - Alfredo VÃ¡squez Cobo International Airport" },
{ code: "EOH", name: "MedellÃ­n - Enrique Olaya Herrera Airport" },
{ code: "MGN", name: "MaganguÃ© - Baracoa Airport" },
{ code: "MTR", name: "MonterÃ­a - Los Garzones Airport" },
{ code: "MVP", name: "MitÃº - Fabio Alberto Leon Bentley Airport" },
{ code: "MZL", name: "Manizales - La Nubia Airport" },
{ code: "NVA", name: "Neiva - Benito Salas Airport" },
{ code: "OCV", name: "OcaÃ±a - Aguas Claras Airport" },
{ code: "PCR", name: "Puerto CarreÃ±o - German Olano Airport" },
{ code: "PDA", name: "Puerto InÃ­rida - Obando Cesar Gaviria Trujillo Airport" },
{ code: "PEI", name: "Pereira - MatecaÃ±a International Airport" },
{ code: "PTX", name: "Pitalito - Pitalito Airport" },
{ code: "PPN", name: "PopayÃ¡n - Guillermo LeÃ³n Valencia Airport" },
{ code: "PAL", name: "La Dorada - German Olano Air Base" },
{ code: "PSO", name: "ChachagÃ¼Ã­ - Antonio NariÃ±o Airport" },
{ code: "PVA", name: "Providencia - El Embrujo Airport" },
{ code: "PZA", name: "Paz De Ariporo - Paz De Ariporo Airport" },
{ code: "MQU", name: "Mariquita - Mariquita Airport" },
{ code: "MDE", name: "MedellÃ­n - Jose Maria CÃ³rdova International Airport" },
{ code: "RCH", name: "Riohacha - Almirante Padilla Airport" },
{ code: "SJE", name: "San JosÃ© Del Guaviare - Jorge E. Gonzalez Torres Airport" },
{ code: "SMR", name: "Santa Marta - SimÃ³n BolÃ­var International Airport" },
{ code: "ADZ", name: "San AndrÃ©s - Gustavo Rojas Pinilla International Airport" },
{ code: "SVI", name: "San Vicente Del CaguÃ¡n - Eduardo Falla Solano Airport" },
{ code: "TME", name: "Tame - Gustavo Vargas Airport" },
{ code: "TQS", name: "Tres Esquinas - Captain Ernesto Esguerra Cubides Air Base" },
{ code: "AUC", name: "Arauca - Santiago Perez Airport" },
{ code: "UIB", name: "QuibdÃ³ - El CaraÃ±o Airport" },
{ code: "ULQ", name: "TuluÃ¡ - Heriberto GÃ­l MartÃ­nez Airport" },
{ code: "VUP", name: "Valledupar - Alfonso LÃ³pez Pumarejo Airport" },
{ code: "VVC", name: "Villavicencio - Vanguardia Airport" },
{ code: "EYP", name: "Yopal - El Alcaravan - Yopal Airport" },
{ code: "SRE", name: "Yamparaez - AlcantarÃ­ Airport" },
{ code: "BJO", name: "Bermejo - Bermejo Airport" },
{ code: "CBB", name: "Cochabamba - Jorge Wilsterman International Airport" },
{ code: "CIJ", name: "Cobija - CapitÃ¡n AnÃ­bal Arab Airport" },
{ code: "SRZ", name: "Santa Cruz - El Trompillo Airport" },
{ code: "GYA", name: "GuayaramerÃ­n - GuayaramerÃ­n Airport" },
{ code: "LPB", name: "La Paz / El Alto - El Alto International Airport" },
{ code: "ORU", name: "Oruro - Juan Mendoza Airport" },
{ code: "POI", name: "PotosÃ­ - Capitan Nicolas Rojas Airport" },
{ code: "PSZ", name: "Puerto SuÃ¡rez - CapitÃ¡n Av. Salvador Ogaya G. airport" },
{ code: "RIB", name: "Riberalta - CapitÃ¡n Av. Selin Zeitun Lopez Airport" },
{ code: "SBL", name: "Santa Ana del Yacuma - Santa Ana Del Yacuma Airport" },
{ code: "TJA", name: "Tarija - Capitan Oriel Lea Plaza Airport" },
{ code: "TDD", name: "Trinidad - Teniente Av. Jorge Henrich Arauz Airport" },
{ code: "VLM", name: "Villamontes - Teniente Coronel Rafael PabÃ³n Airport" },
{ code: "VVI", name: "Santa Cruz - Viru Viru International Airport" },
{ code: "BYC", name: "YacuÃ­ba - Yacuiba Airport" },
{ code: "PBM", name: "Zandery - Johan Adolf Pengel International Airport" },
{ code: "JSO", name: "Sobral - Dr. Luciano de Arruda Coelho Regional Airport" },
{ code: "EEA", name: "Correia Pinto - Planalto Serrano Regional Airport" },
{ code: "LHN", name: "Linhares - Linhares Municipal Airport" },
{ code: "CAY", name: "Matoury - Cayenne â€“ FÃ©lix EbouÃ© Airport" },
{ code: "OYP", name: "Saint-Georges-de-l'Oyapock - Saint-Georges-de-l'Oyapock Airport" },
{ code: "AYX", name: "Atalaya - Teniente General Gerardo PÃ©rez Pinedo Airport" },
{ code: "IBP", name: "Iberia - Iberia Airport" },
{ code: "PCL", name: "Pucallpa - Cap FAP David Abenzur Rengifo International Airport" },
{ code: "CHM", name: "Chimbote - FAP Lieutenant Jaime Andres de Montreuil Morales Airport" },
{ code: "CIX", name: "Chiclayo - Air Force Captain Jose A Quinones Gonzales International Airport" },
{ code: "AYP", name: "Ayacucho - Air Force Colonel Alfredo Mendivil Duarte Airport" },
{ code: "ATA", name: "Anta - Comandante FAP German Arias Graziani Airport" },
{ code: "LIM", name: "Lima - Jorge ChÃ¡vez International Airport" },
{ code: "RIJ", name: "Rioja - Juan Simons Vela Airport" },
{ code: "JAE", name: "JaÃ©n - Shumba Airport" },
{ code: "JJI", name: "JuanjuÃ­ - Juanjui Airport" },
{ code: "JAU", name: "Jauja - Francisco Carle Airport" },
{ code: "JUL", name: "Juliaca - Inca Manco Capac International Airport" },
{ code: "CJA", name: "Cajamarca - Mayor General FAP Armando Revoredo Iglesias Airport" },
{ code: "ILQ", name: "Ilo - General Jorge Fernandez Maldon Airport" },
{ code: "TBP", name: "Tumbes - Captain Pedro Canga RodrÃ­guez International Airport" },
{ code: "YMS", name: "Yurimaguas - Moises Benzaquen Rengifo Airport" },
{ code: "HUU", name: "HuÃ¡nuco - Alferez Fap David Figueroa Fernandini Airport" },
{ code: "CHH", name: "Chachapoyas - Chachapoyas Airport" },
{ code: "IQT", name: "Iquitos - Coronel FAP Francisco Secada Vignetta International Airport" },
{ code: "AQP", name: "Arequipa - RodrÃ­guez BallÃ³n International Airport" },
{ code: "TRU", name: "Trujillo - Capitan FAP Carlos Martinez De Pinillos International Airport" },
{ code: "PIO", name: "Pisco - Captain RenÃ¡n ElÃ­as Olivera International Airport" },
{ code: "TPP", name: "Tarapoto - Cadete FAP Guillermo Del Castillo Paredes Airport" },
{ code: "TCQ", name: "Tacna - Coronel FAP Carlos Ciriani Santa Rosa International Airport" },
{ code: "PEM", name: "Puerto Maldonado - Padre Aldamiz International Airport" },
{ code: "PIU", name: "Piura - CapitÃ¡n FAP Guillermo Concha Iberico International Airport" },
{ code: "TYL", name: "Talara - Captain Victor Montes Arias International Airport" },
{ code: "NZC", name: "Nazca - Maria Reiche Neuman Airport" },
{ code: "CUZ", name: "Cusco - Alejandro Velasco Astete International Airport" },
{ code: "DZO", name: "Durazno - Santa Bernardina International Airport" },
{ code: "PDP", name: "Punta del Este - Capitan Corbeta CA Curbelo International Airport" },
{ code: "MVD", name: "Ciudad de la Costa - Carrasco General CesÃ¡reo L. Berisso International Airport" },
{ code: "PDU", name: "PaysandÃº - Tydeo Larre Borges Airport" },
{ code: "STY", name: "Salto - Nueva Hesperides International Airport" },
{ code: "AGV", name: "Acarigua - Oswaldo Guevara Mujica Airport" },
{ code: "AAO", name: "Anaco - Anaco Airport" },
{ code: "BLA", name: "Barcelona - General JosÃ© Antonio Anzoategui International Airport" },
{ code: "BNS", name: "Barinas - Barinas Airport" },
{ code: "BRM", name: "Barquisimeto - Barquisimeto International Airport" },
{ code: "MYC", name: "Maracay - Escuela Mariscal Sucre Airport" },
{ code: "CBL", name: "Ciudad Bolivar - General Tomas de Heres Airport" },
{ code: "CXA", name: " - Caicara del Orinoco Airport" },
{ code: "CLZ", name: "Guarico - Calabozo Airport" },
{ code: "CAJ", name: "Canaima - Canaima Airport" },
{ code: "CUP", name: "CarÃºpano - General Francisco BermÃºdez Airport" },
{ code: "CZE", name: "Coro - JosÃ© Leonardo Chirinos Airport" },
{ code: "CUM", name: " - CumanÃ¡ (Antonio JosÃ© de Sucre) Airport" },
{ code: "EOR", name: "Bolivar - El Dorado Airport" },
{ code: "EOZ", name: " - Elorza Airport" },
{ code: "GDO", name: "Guasdualito - Guasdualito Airport" },
{ code: "GUI", name: " - Guiria Airport" },
{ code: "GUQ", name: "Guanare - Guanare Airport" },
{ code: "LSP", name: "ParaguanÃ¡ - Josefa Camejo International Airport" },
{ code: "LFR", name: " - La Fria Airport" },
{ code: "MAR", name: "Maracaibo - La Chinita International Airport" },
{ code: "MRD", name: "MÃ©rida - Alberto Carnevalli Airport" },
{ code: "PMV", name: "Isla Margarita - Del Caribe Santiago MariÃ±o International Airport" },
{ code: "CCS", name: "MaiquetÃ­a - MaiquetÃ­a SimÃ³n BolÃ­var International Airport" },
{ code: "MUN", name: "MaturÃ­n - JosÃ© Tadeo Monagas International Airport" },
{ code: "PYH", name: "Puerto Ayacucho - Cacique Aramare Airport" },
{ code: "PBL", name: "Puerto Cabello - General Bartolome Salom International Airport" },
{ code: "SCI", name: "San CristÃ³bal - Paramillo Airport" },
{ code: "PZO", name: "Puerto Ordaz-Ciudad Guayana - General Manuel Carlos Piar International Airport" },
{ code: "PTM", name: "Palmarito - Palmarito Airport" },
{ code: "SVZ", name: " - San Antonio Del Tachira Airport" },
{ code: "SNV", name: "Santa Elena de UairÃ©n - Santa Elena de Uairen Airport" },
{ code: "STD", name: "Santo Domingo - Mayor Buenaventura Vivas International Airport" },
{ code: "SNF", name: "San Felipe - Sub Teniente Nestor Arias Airport" },
{ code: "SFD", name: "San Fernando de Apure - San Fernando de Apure Las Flecheras National Airport" },
{ code: "SOM", name: "El Tigre - San TomÃ© Airport" },
{ code: "STB", name: "San Carlos del Zulia - Miguel Urdaneta FernÃ¡ndez Airport" },
{ code: "TUV", name: "Tucupita - Tucupita Airport" },
{ code: "TMO", name: " - Tumeremo Airport" },
{ code: "VLN", name: "Valencia - Arturo Michelena International Airport" },
{ code: "VIG", name: "El VigÃ­a - Juan Pablo PÃ©rez Alfonso Airport" },
{ code: "VLV", name: "Valera - Dr. Antonio NicolÃ¡s BriceÃ±o Airport" },
{ code: "VDP", name: " - Valle de La Pascua Airport" },
{ code: "AUX", name: "AraguaÃ­na - AraguaÃ­na Airport" },
{ code: "GEO", name: "Georgetown - Cheddi Jagan International Airport" },
{ code: "OGL", name: "Ogle - Eugene F. Correira International Airport" },
{ code: "KAI", name: "Kaieteur Falls - Kaieteur International Airport" },
{ code: "LTM", name: "Lethem - Lethem Airport" },
{ code: "ANU", name: "Osbourn - V C Bird International Airport" },
{ code: "BBQ", name: "Codrington - Codrington Airport" },
{ code: "BGI", name: "Bridgetown - Grantley Adams International Airport" },
{ code: "DCF", name: "Canefield - Canefield Airport" },
{ code: "DOM", name: "Marigot - Douglas-Charles Airport" },
{ code: "FDF", name: "Fort-de-France - Martinique AimÃ© CÃ©saire International Airport" },
{ code: "SFG", name: "Grand Case - Grand Case-l'EspÃ©rance Airport" },
{ code: "SBH", name: "Gustavia - Saint BarthÃ©lemy - Gustaf III Airport" },
{ code: "GBJ", name: "Grand-Bourg - Marie-Galante Airport" },
{ code: "PTP", name: "Pointe-Ã -Pitre - Guadeloupe - Maryse CondÃ© International Airport" },
{ code: "GND", name: "Saint George's - Maurice Bishop International Airport" },
{ code: "STT", name: "Charlotte Amalie - Cyril E. King Airport" },
{ code: "STX", name: "Christiansted - Henry E Rohlsen Airport" },
{ code: "ARE", name: "Arecibo - Antonio Nery Juarbe Pol Airport" },
{ code: "BQN", name: "Aguadilla - Rafael HernÃ¡ndez International Airport" },
{ code: "CPX", name: "Culebra - Benjamin Rivera Noriega Airport" },
{ code: "SIG", name: "San Juan - Fernando Luis Ribas Dominicci Airport" },
{ code: "MAZ", name: "Mayaguez - Eugenio Maria De Hostos Airport" },
{ code: "PSE", name: "Ponce - Mercedita Airport" },
{ code: "NRR", name: "Ceiba - JosÃ© Aponte de la Torre Airport" },
{ code: "SJU", name: "San Juan - Luis Munoz Marin International Airport" },
{ code: "VQS", name: "Vieques - Antonio Rivera Rodriguez Airport" },
{ code: "SKB", name: "Basseterre - Robert L. Bradshaw International Airport" },
{ code: "NEV", name: "Charlestown - Vance W. Amory International Airport" },
{ code: "SLU", name: "Castries - George F. L. Charles Airport" },
{ code: "UVF", name: "Vieux Fort - Hewanorra International Airport" },
{ code: "AUA", name: "Oranjestad - Queen Beatrix International Airport" },
{ code: "BON", name: "Kralendijk - Flamingo International Airport" },
{ code: "CUR", name: "Willemstad - Hato International Airport" },
{ code: "EUX", name: "Oranjestad - F. D. Roosevelt Airport" },
{ code: "SXM", name: "Sint Maarten - Princess Juliana International Airport" },
{ code: "SAB", name: "Zion's Hill - Juancho E. Yrausquin Airport" },
{ code: "AXA", name: "The Valley - Clayton J Lloyd International Airport" },
{ code: "MNI", name: "Gerald's Park - John A. Osborne Airport" },
{ code: "TAB", name: "Scarborough - A.N.R. Robinson International Airport" },
{ code: "POS", name: "Port of Spain - Piarco International Airport" },
{ code: "EIS", name: "Beef Island - Terrance B. Lettsome International Airport" },
{ code: "SVD", name: "Kingstown - Argyle International Airport" },
{ code: "BQU", name: "Bequia - J F Mitchell Airport" },
{ code: "CIW", name: "Canouan - Canouan Airport" },
{ code: "MQS", name: "Lovell - Mustique Airport" },
{ code: "UNI", name: "Union Island - Union Island International Airport" },
{ code: "BDA", name: "Hamilton - L.F. Wade International Airport" },
{ code: "ALA", name: "Almaty - Almaty International Airport" },
{ code: "BXH", name: "Balkhash - Balkhash Airport" },
{ code: "TDK", name: "Taldykorgan - Taldykorgan Airport" },
{ code: "NQZ", name: "Astana - Nursultan Nazarbayev International Airport" },
{ code: "KOV", name: "Kokshetau - Kokshetau Airport" },
{ code: "PPK", name: "Petropavl - Petropavl Airport" },
{ code: "DMB", name: "Taraz - Taraz Airport" },
{ code: "FRU", name: "Bishkek - Manas International Airport" },
{ code: "OSS", name: "Osh - Osh Airport" },
{ code: "CIT", name: "Shymkent - Shymkent Airport" },
{ code: "HSA", name: "TurkÄ±stan - Hazrat Sultan International Airport" },
{ code: "DZN", name: "Zhezkazgan - Zhezkazgan National Airport" },
{ code: "KGF", name: "Karaganda - Sary-Arka Airport" },
{ code: "BXY", name: "Baikonur - Baikonur Krayniy Airport" },
{ code: "URA", name: "Uralsk - Uralsk Airport" },
{ code: "EKB", name: "Ekibastuz - Ekibastuz Airport" },
{ code: "UKK", name: "Ust-Kamenogorsk (Oskemen) - Ust-Kamenogorsk Airport" },
{ code: "PWQ", name: "Pavlodar - Pavlodar Airport" },
{ code: "PLX", name: "Semey - Semey Airport" },
{ code: "SCO", name: "Aktau - Aktau Airport" },
{ code: "GUW", name: "Atyrau - Atyrau International Airport" },
{ code: "AKX", name: "Aktobe - Aktobe Airport" },
{ code: "KSN", name: "Kostanay - Kostanay West Airport" },
{ code: "GYD", name: "Baku - Heydar Aliyev International Airport" },
{ code: "GNJ", name: "Ganja - Ganja International Airport" },
{ code: "NAJ", name: "Nakhchivan - Nakhchivan Airport" },
{ code: "GBB", name: "Gabala - Gabala International Airport" },
{ code: "ZTU", name: "Zaqatala - Zaqatala International Airport" },
{ code: "IKU", name: "Tamchy - Issyk-Kul International Airport" },
{ code: "LWN", name: "Gyumri - Shirak International Airport" },
{ code: "EVN", name: "Yerevan - Zvartnots International Airport" },
{ code: "YKS", name: "Yakutsk - Yakutsk Airport" },
{ code: "NER", name: "Neryungri - Chulman Airport" },
{ code: "MQJ", name: "Khonuu - Moma Airport" },
{ code: "GYG", name: "Magan - Magan Airport" },
{ code: "OLZ", name: "Olyokminsk - Olyokminsk Airport" },
{ code: "USR", name: "Ust-Nera - Ust-Nera Airport" },
{ code: "VYI", name: "Vilyuisk - Vilyuisk Airport" },
{ code: "ULK", name: "Lensk - Lensk Airport" },
{ code: "PYJ", name: "Yakutia - Polyarny Airport" },
{ code: "MJZ", name: "Mirny - Mirny Airport" },
{ code: "SYS", name: "Saskylakh - Saskylakh Airport" },
{ code: "BGN", name: "Belaya Gora - Belaya Gora Airport" },
{ code: "SEK", name: "Srednekolymsk - Srednekolymsk Airport" },
{ code: "CKH", name: "Chokurdah - Chokurdakh Airport" },
{ code: "CYX", name: "Cherskiy - Cherskiy Airport" },
{ code: "IKS", name: "Tiksi - Tiksi Airport" },
{ code: "ZKP", name: "Zyryanka - Zyryanka Airport" },
{ code: "ZIX", name: "Zhigansk - Zhigansk Airport" },
{ code: "KUT", name: "Kopitnari - David the Builder Kutaisi International Airport" },
{ code: "BUS", name: "Batumi - Batumi International Airport" },
{ code: "SUI", name: "Sukhumi - Sukhumi Babushara /  Vladislav Ardzinba International Airport" },
{ code: "TBS", name: "Tbilisi - Tbilisi International Airport" },
{ code: "BQS", name: "Blagoveschensk - Ignatyevo Airport" },
{ code: "KHV", name: "Khabarovsk - Khabarovsk Novy Airport" },
{ code: "KXK", name: "Komsomolsk-on-Amur - Komsomolsk-on-Amur Airport" },
{ code: "GVN", name: "Sovetskaya Gavan - Sovetskaya Gavan (Maygatka) Airport" },
{ code: "DYR", name: "Anadyr - Ugolny Yuri Ryktheu Airport" },
{ code: "PVS", name: "Chukotka - Provideniya Bay Airport" },
{ code: "KPW", name: "Keperveem - Keperveem Airport" },
{ code: "GDX", name: "Magadan - Sokol Airport" },
{ code: "PWE", name: "Apapelgino - Pevek Airport" },
{ code: "SWV", name: "Evensk - Severo-Evensk Airport" },
{ code: "NLI", name: "Nikolayevsk-na-Amure Airport - Nikolayevsk-na-Amure Airport" },
{ code: "OHO", name: "Okhotsk - Okhotsk Airport" },
{ code: "PKC", name: "Petropavlovsk-Kamchatsky - Yelizovo Airport" },
{ code: "UUS", name: "Yuzhno-Sakhalinsk - Yuzhno-Sakhalinsk Airport" },
{ code: "VVO", name: "Artyom - Vladivostok International Airport" },
{ code: "HTA", name: "Chita - Chita-Kadala International Airport" },
{ code: "BTK", name: "Bratsk - Bratsk Airport" },
{ code: "IKT", name: "Irkutsk - Irkutsk International Airport" },
{ code: "UKX", name: "Ust-Kut - Ust-Kut Airport" },
{ code: "UUD", name: "Ulan Ude - Baikal International Airport" },
{ code: "KBP", name: "Boryspil - Boryspil International Airport" },
{ code: "MPW", name: "Mariupol - Mariupol International Airport" },
{ code: "ERD", name: "Berdyansk - Berdyansk Airport" },
{ code: "DNK", name: "Dnipro - Dnipro International Airport" },
{ code: "OZH", name: "Zaporizhia - Zaporizhzhia International Airport" },
{ code: "KWG", name: "Kryvyi Rih - Kryvyi Rih International Airport" },
{ code: "UKS", name: "Sevastopol - Sevastopol International Airport / Belbek Air Base" },
{ code: "SIP", name: "Simferopol - Simferopol International Airport" },
{ code: "HRK", name: "Kharkiv - Kharkiv International Airport" },
{ code: "CKC", name: "Cherkasy - Cherkasy International Airport" },
{ code: "IEV", name: "Kyiv - Ihor Sikorsky Kyiv International Airport (Zhuliany)" },
{ code: "HMJ", name: "Khmelnytskyi - Khmelnytskyi Airport" },
{ code: "IFO", name: "Ivano-Frankivsk - Ivano-Frankivsk International Airport" },
{ code: "LWO", name: "Lviv - Lviv International Airport" },
{ code: "CWC", name: "Chernivtsi - Chernivtsi International Airport" },
{ code: "RWN", name: "Rivne - Rivne International Airport" },
{ code: "UDJ", name: "Uzhhorod - Uzhhorod International Airport" },
{ code: "KHE", name: "Kherson - Kherson International Airport" },
{ code: "NLV", name: "Nikolayev - Mykolaiv International Airport" },
{ code: "ODS", name: "Odessa - Odessa International Airport" },
{ code: "VIN", name: "Vinnitsa - Vinnytsia/Gavyryshivka International Airport" },
{ code: "ARH", name: "Archangelsk - Talagi Airport" },
{ code: "VKV", name: "Arkhangelsk - Vaskovo Airport" },
{ code: "NNM", name: "Naryan Mar - Naryan Mar Airport" },
{ code: "AMV", name: "Amderma - Amderma Airport" },
{ code: "KSZ", name: "Kotlas - Kotlas Airport" },
{ code: "LED", name: "St. Petersburg - Pulkovo Airport" },
{ code: "MMK", name: "Murmansk - Murmansk Airport" },
{ code: "PKV", name: "Pskov - Pskov Airport" },
{ code: "PES", name: "Petrozavodsk - Petrozavodsk Airport" },
{ code: "CEE", name: "Cherepovets - Cherepovets Airport" },
{ code: "VUS", name: "Velikiy Ustyug - Velikiy Ustyug Airport" },
{ code: "VGD", name: "Vologda - Vologda Airport" },
{ code: "BQT", name: "Brest - Brest Airport" },
{ code: "GME", name: "Gomel - Gomel Airport" },
{ code: "VTB", name: "Vitebsk - Vitebsk Vostochny Airport" },
{ code: "KGD", name: "Kaliningrad - Khrabrovo Airport" },
{ code: "GNA", name: "Hrodna - Hrodna Airport" },
{ code: "MSQ", name: "Minsk - Minsk National Airport" },
{ code: "MVQ", name: "Mogilev - Mogilev Airport" },
{ code: "ABA", name: "Abakan - Abakan International Airport" },
{ code: "BAX", name: "Barnaul - Barnaul Airport" },
{ code: "RGK", name: "Gorno-Altaysk - Gorno-Altaysk Airport" },
{ code: "KEJ", name: "Kemerovo - Kemerovo Airport" },
{ code: "BKA", name: "Baykit - Baykit Airport" },
{ code: "EIE", name: "Yeniseysk - Yeniseysk Airport" },
{ code: "TGP", name: "Bor - Podkamennaya Tunguska Airport" },
{ code: "VEO", name: "Severo-Yeniseysk - Severo-Yeniseysk Airport" },
{ code: "VAQ", name: "Vanavara - Vanavara Airport" },
{ code: "KJA", name: "Krasnoyarsk - Krasnoyarsk International Airport" },
{ code: "KCY", name: "Krasnoyarsk - Krasnoyarsk Cheremshanka Airport" },
{ code: "ACS", name: "Achinsk - Achinsk Airport" },
{ code: "KYZ", name: "Kyzyl - Kyzyl Airport" },
{ code: "OVB", name: "Novosibirsk - Novosibirsk Tolmachevo Airport" },
{ code: "OMS", name: "Omsk - Omsk Central Airport" },
{ code: "SWT", name: "Strezhevoy - Strezhevoy Airport" },
{ code: "TOF", name: "Tomsk - Bogashevo Airport" },
{ code: "NOZ", name: "Novokuznetsk - Spichenkovo Airport" },
{ code: "DKS", name: "Dikson - Dikson Airport" },
{ code: "HTG", name: "Khatanga - Khatanga Airport" },
{ code: "SES", name: "Svetlogorsk - Svetlogorsk Airport" },
{ code: "IAA", name: "Igarka - Igarka Airport" },
{ code: "NSK", name: "Norilsk - Norilsk-Alykel Airport" },
{ code: "AAQ", name: "Krasnyi Kurgan - Anapa Vityazevo Airport" },
{ code: "GDZ", name: "Gelendzhik - Gelendzhik Airport" },
{ code: "KRR", name: "Krasnodar - Krasnodar Pashkovsky International Airport" },
{ code: "GRV", name: "Grozny - Grozny Airport" },
{ code: "MCX", name: "Makhachkala - Makhachkala Uytash International Airport" },
{ code: "MRV", name: "Mineralnyye Vody - Mineralnyye Vody Airport" },
{ code: "NAL", name: "Nalchik - Nalchik Airport" },
{ code: "OGZ", name: "Beslan - Vladikavkaz Beslan International Airport" },
{ code: "IGT", name: "Sunzha - Magas Airport" },
{ code: "STW", name: "Stavropol - Stavropol Shpakovskoye Airport" },
{ code: "ROV", name: "Rostov-on-Don - Platov International Airport" },
{ code: "TGK", name: "Taganrog - Taganrog Yuzhny Airport" },
{ code: "AER", name: "Sochi - Sochi International Airport" },
{ code: "ASF", name: "Astrakhan - Astrakhan Narimanovo Boris M. Kustodiev International Airport" },
{ code: "ESL", name: "Elista - Elista Airport" },
{ code: "VOG", name: "Volgograd - Volgograd International Airport" },
{ code: "CEK", name: "Chelyabinsk - Chelyabinsk Balandino Airport" },
{ code: "MQF", name: "Magnitogorsk - Magnitogorsk International Airport" },
{ code: "SBT", name: "Sabetta - Sabetta International Airport" },
{ code: "BVJ", name: "Bovanenkovo - Bovanenkovo Airport" },
{ code: "SLY", name: "Salekhard - Salekhard Airport" },
{ code: "EZV", name: " - Berezovo Airport" },
{ code: "HMA", name: "Khanty-Mansiysk - Khanty Mansiysk Airport" },
{ code: "NYA", name: "Nyagan - Nyagan Airport" },
{ code: "EYK", name: " - Beloyarskiy Airport" },
{ code: "OVS", name: "Sovetskiy - Sovetskiy Airport" },
{ code: "URJ", name: "Uray - Uray Airport" },
{ code: "IJK", name: "Izhevsk - Izhevsk Airport" },
{ code: "KVX", name: "Kirov - Pobedilovo Airport" },
{ code: "NYM", name: "Nadym - Nadym Airport" },
{ code: "NUX", name: "Novy Urengoy - Novy Urengoy Airport" },
{ code: "NJC", name: "Nizhnevartovsk - Nizhnevartovsk Airport" },
{ code: "PEE", name: "Perm - Perm International Airport" },
{ code: "KGP", name: "Kogalym - Kogalym International Airport" },
{ code: "NFG", name: "Nefteyugansk - Nefteyugansk Airport" },
{ code: "NOJ", name: "Noyabrsk - Noyabrsk Airport" },
{ code: "SGC", name: "Surgut - Surgut Airport" },
{ code: "SVX", name: "Yekaterinburg - Koltsovo Airport" },
{ code: "RMZ", name: "Tobolsk - Remezov Airport" },
{ code: "TJM", name: "Tyumen - Roshchino International Airport" },
{ code: "KRO", name: "Kurgan - Kurgan Airport" },
{ code: "ASB", name: "Ashgabat - Ashgabat International Airport" },
{ code: "KRW", name: "Turkmenbashi - Turkmenbashi International Airport" },
{ code: "MYP", name: "Mary - Mary International Airport" },
{ code: "TAZ", name: "DaÅŸoguz - DaÅŸoguz Airport" },
{ code: "CRZ", name: "TÃ¼rkmenabat - TÃ¼rkmenabat International Airport" },
{ code: "DYU", name: "Dushanbe - Dushanbe International Airport" },
{ code: "TJU", name: "Kulyab - Kulob Airport" },
{ code: "LBD", name: "Khujand - Khujand Airport" },
{ code: "KQT", name: "Kurgan-Tyube - Qurghonteppa International Airport" },
{ code: "AZN", name: "Andizhan - Andizhan Airport" },
{ code: "FEG", name: "Fergana - Fergana International Airport" },
{ code: "NCU", name: "Nukus - Nukus Airport" },
{ code: "UGC", name: "Urgench - Urgench Airport" },
{ code: "NVI", name: "Navoi - Navoi Airport" },
{ code: "BHK", name: "Bukhara - Bukhara International Airport" },
{ code: "SKD", name: "Samarkand - Samarkand Airport" },
{ code: "TMJ", name: "Termez - Termez Airport" },
{ code: "TAS", name: "Tashkent - Tashkent International Airport" },
{ code: "OMN", name: "Zaamin - Zomin Airport" },
{ code: "KMW", name: "Kostroma - Kostroma Sokerkino Airport" },
{ code: "KLF", name: "Kaluga - Grabtsevo Airport" },
{ code: "IWA", name: "Ivanovo - Ivanovo South Airport" },
{ code: "RYB", name: "Rybinsk - Staroselye Airport" },
{ code: "BZK", name: "Bryansk - Bryansk Airport" },
{ code: "ZIA", name: "Moscow - Zhukovsky International Airport" },
{ code: "DME", name: "Moscow - Domodedovo International Airport" },
{ code: "SVO", name: "Moscow - Sheremetyevo International Airport" },
{ code: "KLD", name: "Tver - Migalovo Air Base" },
{ code: "OSF", name: "Moscow - Ostafyevo International Airport" },
{ code: "CKL", name: "Moscow - Chkalovskiy Air Base" },
{ code: "EGO", name: "Belgorod - Belgorod International Airport" },
{ code: "URS", name: "Kursk - Kursk East Airport" },
{ code: "LPK", name: "Lipetsk - Lipetsk Airport" },
{ code: "VOZ", name: "Voronezh - Voronezh International Airport" },
{ code: "TBW", name: "Tambov - Donskoye Airport" },
{ code: "VKO", name: "Moscow - Vnukovo International Airport" },
{ code: "UCT", name: "Ukhta - Ukhta Airport" },
{ code: "INA", name: "Inta - Inta Airport" },
{ code: "PEX", name: "Pechora - Pechora Airport" },
{ code: "USK", name: "Usinsk - Usinsk Airport" },
{ code: "VKT", name: "Vorkuta - Vorkuta Airport" },
{ code: "UTS", name: "Ust-Tsylma - Ust-Tsylma Airport" },
{ code: "SCW", name: "Syktyvkar - Syktyvkar Airport" },
{ code: "GOJ", name: "Nizhny Novgorod - Nizhny Novgorod / Strigino International Airport" },
{ code: "UUA", name: "Bugulma - Bugulma Airport" },
{ code: "KZN", name: "Kazan - Kazan International Airport" },
{ code: "NBC", name: "Nizhnekamsk - Begishevo Airport" },
{ code: "JOK", name: "Yoshkar-Ola - Yoshkar-Ola Airport" },
{ code: "CSY", name: "Cheboksary - Cheboksary Airport" },
{ code: "ULV", name: "Ulyanovsk - Ulyanovsk Baratayevka Airport" },
{ code: "ULY", name: "Cherdakly - Ulyanovsk East Airport" },
{ code: "REN", name: "Orenburg - Orenburg Central Airport" },
{ code: "OSW", name: "Orsk - Orsk Airport" },
{ code: "PEZ", name: "Penza - Penza Airport" },
{ code: "SKX", name: "Saransk - Saransk Airport" },
{ code: "BWO", name: "Balakovo - Balakovo Airport" },
{ code: "GSV", name: "Saratov - Gagarin International Airport" },
{ code: "UFA", name: "Ufa - Ufa International Airport" },
{ code: "KUF", name: "Samara - Kurumoch International Airport" },
{ code: "REW", name: "Rewa - Rewa Airport, Chorhata, REWA" },
{ code: "GDB", name: "Gondia - Gondia Airport" },
{ code: "AMD", name: "Ahmedabad - Sardar Vallabh Bhai Patel International Airport" },
{ code: "AKD", name: "Akola - Akola Airport" },
{ code: "IXU", name: "Aurangabad - Aurangabad Airport" },
{ code: "BOM", name: "Mumbai - Chhatrapati Shivaji International Airport" },
{ code: "BHJ", name: "Bhuj - Bhuj Airport" },
{ code: "IXG", name: "Belgaum - Belagavi Airport" },
{ code: "BDQ", name: "Vadodara - Vadodara Airport" },
{ code: "BHO", name: "Bhopal - Raja Bhoj International Airport" },
{ code: "BHU", name: "Bhavnagar - Bhavnagar Airport" },
{ code: "NMB", name: "Daman - Daman Airport" },
{ code: "HBX", name: "Hubli - Hubli Airport" },
{ code: "HSR", name: "Rajkot - Rajkot International Airport" },
{ code: "IDR", name: "Indore - Devi Ahilyabai Holkar Airport" },
{ code: "JLR", name: "Jabalpur - Jabalpur Airport" },
{ code: "JGA", name: "Jamnagar - Jamnagar Airport" },
{ code: "IXY", name: "Kandla - Kandla Airport" },
{ code: "HJR", name: "Khajuraho - Khajuraho Airport" },
{ code: "KLH", name: "Kolhapur - Kolhapur Airport" },
{ code: "IXK", name: "Keshod - Keshod Airport" },
{ code: "LTU", name: "Latur - Murod Kond Airport" },
{ code: "NDC", name: "Nanded - Nanded Airport" },
{ code: "NAG", name: "Nagpur - Dr. Babasaheb Ambedkar International Airport" },
{ code: "ISK", name: "Nasik - Nashik Airport" },
{ code: "PNQ", name: "Pune - Pune Airport / Lohagaon Air Force Station" },
{ code: "PBD", name: "Porbandar - Porbandar Airport" },
{ code: "RTC", name: " - Ratnagiri Airport" },
{ code: "RAJ", name: "Rajkot - Rajkot Airport" },
{ code: "RPR", name: "Raipur - Swami Vivekananda Airport" },
{ code: "SAG", name: "Kakadi - Shirdi Airport" },
{ code: "SSE", name: "Solapur - Solapur Airport" },
{ code: "STV", name: "Surat - Surat Airport" },
{ code: "UDR", name: "Udaipur - Maharana Pratap Airport" },
{ code: "CMB", name: "Colombo - Bandaranaike International Colombo Airport" },
{ code: "ACJ", name: "Anuradhapura - Anuradhapura Airport" },
{ code: "BTC", name: "Batticaloa - Batticaloa Airport" },
{ code: "RML", name: "Colombo - Colombo Ratmalana Airport" },
{ code: "ADP", name: "Ampara - Ampara Airport" },
{ code: "HIM", name: "Polonnaruwa Town - Hingurakgoda Air Force Base" },
{ code: "JAF", name: "Jaffna - Jaffna International Airport" },
{ code: "KCT", name: "Galle - Koggala Airport" },
{ code: "TRR", name: "Trincomalee - China Bay Airport" },
{ code: "HRI", name: "Mattala - Mattala Rajapaksa International Airport" },
{ code: "BBM", name: "Battambang - Battambang Airport" },
{ code: "KZC", name: "Kampong Chhnang - Kampong Chhnang Airport" },
{ code: "PNH", name: "Phnom Penh (Pou Senchey) - Phnom Penh International Airport" },
{ code: "RBE", name: "Ratanakiri - Ratanakiri Airport" },
{ code: "SAI", name: "Siem Reap - Siem Reap-Angkor International Airport" },
{ code: "IXV", name: " - Along Airport" },
{ code: "IXA", name: "Agartala - Agartala - Maharaja Bir Bikram Airport" },
{ code: "IXB", name: "Siliguri - Bagdogra Airport" },
{ code: "SHL", name: "Shillong - Shillong Airport" },
{ code: "VNS", name: "Varanasi - Lal Bahadur Shastri Airport" },
{ code: "BBI", name: "Bhubaneswar - Biju Patnaik Airport" },
{ code: "PAB", name: "Bilaspur - Bilaspur Airport" },
{ code: "CCU", name: "Kolkata - Netaji Subhash Chandra Bose International Airport" },
{ code: "DBD", name: " - Dhanbad Airport" },
{ code: "RDP", name: "Durgapur - Kazi Nazrul Islam Airport" },
{ code: "DBR", name: "Darbhanga - Darbhanga Airport" },
{ code: "GOP", name: "Gorakhpur - Gorakhpur Airport" },
{ code: "GAU", name: "Guwahati - Lokpriya Gopinath Bordoloi International Airport" },
{ code: "GAY", name: "Gaya - Gaya Airport" },
{ code: "IMF", name: "Imphal - Imphal Airport" },
{ code: "IXW", name: "Jamshedpur - Sonari Airport" },
{ code: "JRH", name: "Jorhat - Jorhat Airport" },
{ code: "KBK", name: "Kushinagar - Kushinagar International Airport" },
{ code: "IXH", name: "Kailashahar - Kailashahar Airport" },
{ code: "IXS", name: "Silchar - Silchar Airport" },
{ code: "AJL", name: "Aizawl (Lengpui) - Lengpui Airport" },
{ code: "IXI", name: "Lilabari - Lilabari North Lakhimpur Airport" },
{ code: "DIB", name: "Dibrugarh - Dibrugarh Airport" },
{ code: "DMU", name: "Dimapur - Dimapur Airport" },
{ code: "MZU", name: "Muzaffarpur - Muzaffarpur Airport" },
{ code: "PAT", name: "Patna - Jay Prakash Narayan Airport" },
{ code: "IXR", name: "Ranchi - Birsa Munda Airport" },
{ code: "RRK", name: "Rourkela - Rourkela Airport" },
{ code: "TEZ", name: " - Tezpur Airport" },
{ code: "VTZ", name: "Visakhapatnam - Visakhapatnam Airport" },
{ code: "ZER", name: "Ziro - Ziro Airport" },
{ code: "BZL", name: "Barisal - Barisal Airport" },
{ code: "CXB", name: "Cox's Bazar - Cox's Bazar Airport" },
{ code: "CGP", name: "Chattogram (Chittagong) - Shah Amanat International Airport" },
{ code: "DAC", name: "Dhaka - Hazrat Shahjalal International Airport" },
{ code: "IRD", name: "Ishurdi - Ishurdi Airport" },
{ code: "JSR", name: "Jashore (Jessore) - Jessore Airport" },
{ code: "RJH", name: "Rajshahi - Shah Mokhdum Airport" },
{ code: "SPD", name: "Saidpur - Saidpur Airport" },
{ code: "ZYL", name: "Sylhet - Osmany International Airport" },
{ code: "HKG", name: "Hong Kong - Hong Kong International Airport" },
{ code: "AGR", name: "Agra - Agra Airport / Agra Air Force Station" },
{ code: "IXD", name: "Allahabad - Prayagraj Airport" },
{ code: "ATQ", name: "Amritsar - Sri Guru Ram Dass Jee International Airport" },
{ code: "BKB", name: "Bikaner - Nal Airport" },
{ code: "KUU", name: "Bhuntar - Kullu Manali Airport" },
{ code: "BUP", name: " - Bhatinda Air Force Station" },
{ code: "BEK", name: "Bareilly - Bareilly Air Force Station" },
{ code: "IXC", name: "Chandigarh - Chandigarh International Airport" },
{ code: "KNU", name: "Kanpur - Kanpur Airport" },
{ code: "DED", name: "Dehradun (Jauligrant) - Dehradun Jolly Grant Airport" },
{ code: "DEL", name: "New Delhi - Indira Gandhi International Airport" },
{ code: "DHM", name: "Kangra - Kangra Airport" },
{ code: "GWL", name: "Gwalior - Gwalior Airport" },
{ code: "HSS", name: "Hisar - Hisar Airport" },
{ code: "JDH", name: "Jodhpur - Jodhpur Airport" },
{ code: "JAI", name: "Jaipur - Jaipur International Airport" },
{ code: "JSA", name: " - Jaisalmer Airport" },
{ code: "IXJ", name: "Jammu - Jammu Airport" },
{ code: "KQH", name: "Ajmer (Kishangarh) - Kishangarh Airport Ajmer" },
{ code: "KTU", name: "Kota - Kota Airport" },
{ code: "LUH", name: " - Ludhiana Airport" },
{ code: "IXL", name: "Leh - Leh Kushok Bakula Rimpochee Airport" },
{ code: "LKO", name: "Lucknow - Chaudhary Charan Singh International Airport" },
{ code: "MZS", name: "Moradabad - Moradabad Airport" },
{ code: "IXP", name: "Pathankot - Pathankot Airport" },
{ code: "PGH", name: "Pantnagar - Pantnagar Airport" },
{ code: "SXR", name: "Srinagar - Sheikh ul Alam International Airport" },
{ code: "LPQ", name: "Luang Phabang - Luang Phabang International Airport" },
{ code: "PKZ", name: "Pakse - Pakse International Airport" },
{ code: "ZVK", name: " - Savannakhet Airport" },
{ code: "NEU", name: " - Sam Neua Airport" },
{ code: "VTE", name: "Vientiane - Wattay International Airport" },
{ code: "VMI", name: "Puerto Vallemi - Aeropuerto Nacional Doctor Juan Plate" },
{ code: "MFM", name: "Nossa Senhora do Carmo - Macau International Airport" },
{ code: "BWA", name: "Siddharthanagar (Bhairahawa) - Gautam Buddha International Airport" },
{ code: "JKR", name: "Janakpur - Janakpur Airport" },
{ code: "KTM", name: "Kathmandu - Tribhuvan International Airport" },
{ code: "KEP", name: "Nepalgunj - Nepalgunj Airport" },
{ code: "PKR", name: "Pokhara - Pokhara Airport" },
{ code: "TPJ", name: "Taplejung - Taplejung Airport" },
{ code: "BIR", name: "Biratnagar - Biratnagar Airport" },
{ code: "AGX", name: "Agatti - Agatti Airport" },
{ code: "BEP", name: "Bellary - Bellary Airport" },
{ code: "BLR", name: "Bangalore - Kempegowda International Airport" },
{ code: "IXX", name: "Bidar - Bidar Airport / Bidar Air Force Station" },
{ code: "VGA", name: "Gannavaram - Vijayawada Airport" },
{ code: "CJB", name: "Coimbatore - Coimbatore International Airport" },
{ code: "COK", name: "Kochi - Cochin International Airport" },
{ code: "CCJ", name: "Calicut - Calicut International Airport" },
{ code: "CDP", name: "Kadapa - Kadapa Airport" },
{ code: "CBD", name: "IAF Camp - Car Nicobar Air Force Base" },
{ code: "GOX", name: "Mopa - Manohar International Airport" },
{ code: "GOI", name: "Vasco da Gama - Dabolim Airport" },
{ code: "HYD", name: "Hyderabad - Rajiv Gandhi International Airport" },
{ code: "BPM", name: "Hyderabad - Begumpet Airport" },
{ code: "CNN", name: "Kannur - Kannur International Airport" },
{ code: "KJB", name: "Orvakal - Kurnool Airport" },
{ code: "IXM", name: "Madurai - Madurai Airport" },
{ code: "IXE", name: "Mangalore - Mangalore International Airport" },
{ code: "MAA", name: "Chennai - Chennai International Airport" },
{ code: "IXZ", name: "Port Blair - Veer Savarkar International Airport / INS Utkrosh" },
{ code: "PNY", name: "Puducherry (Pondicherry) - Pondicherry Airport" },
{ code: "PUT", name: "Puttaparthi - Sri Sathya Sai Airport" },
{ code: "RJA", name: "Madhurapudi - Rajahmundry Airport" },
{ code: "SXV", name: "Salem - Salem Airport" },
{ code: "TRZ", name: "Tiruchirappalli - Tiruchirappalli International Airport" },
{ code: "TRV", name: "Thiruvananthapuram - Thiruvananthapuram International Airport" },
{ code: "GLU", name: "Gelephu - Gelephu Airport" },
{ code: "PBH", name: "Paro - Paro International Airport" },
{ code: "NMF", name: "Noonu Atoll - Maafaru International Airport" },
{ code: "GAN", name: "Gan - Gan International Airport" },
{ code: "HAQ", name: "Haa Dhaalu Atoll - Hanimaadhoo Airport" },
{ code: "KDO", name: "Kadhdhoo - Kadhdhoo Airport" },
{ code: "MLE", name: "MalÃ© - MalÃ© International Airport" },
{ code: "KDM", name: "Huvadhu Atoll - Kaadedhdhoo Airport" },
{ code: "VAM", name: "Maamigili - Villa International Airport Maamigili" },
{ code: "DMK", name: "Bangkok - Don Mueang International Airport" },
{ code: "KDT", name: "Nakhon Pathom - Kamphaeng Saen Airport" },
{ code: "KKM", name: "Lop Buri - Khok Kathiam Airport" },
{ code: "TDX", name: "Laem Ngop - Trat Airport" },
{ code: "BKK", name: "Bangkok - Suvarnabhumi Airport" },
{ code: "UTP", name: "Rayong - U-Tapao International Airport" },
{ code: "CNX", name: "Chiang Mai - Chiang Mai International Airport" },
{ code: "HGN", name: "Mae Hong Son - Mae Hong Son Airport" },
{ code: "LPT", name: " - Lampang Airport" },
{ code: "NNT", name: " - Nan Airport" },
{ code: "PRH", name: " - Phrae Airport" },
{ code: "CEI", name: "Chiang Rai - Mae Fah Luang - Chiang Rai International Airport" },
{ code: "PHY", name: " - Phetchabun Airport" },
{ code: "HHQ", name: "Hua Hin - Hua Hin Airport" },
{ code: "TKH", name: " - Takhli Airport" },
{ code: "MAQ", name: " - Mae Sot Airport" },
{ code: "THS", name: " - Sukhothai Airport" },
{ code: "PHS", name: "Phitsanulok - Phitsanulok Airport" },
{ code: "TKT", name: " - Tak Airport" },
{ code: "URT", name: "Surat Thani - Surat Thani Airport" },
{ code: "NAW", name: " - Narathiwat Airport" },
{ code: "CJM", name: "Chumphon - Chumphon Airport" },
{ code: "NST", name: "Nakhon Si Thammarat - Nakhon Si Thammarat Airport" },
{ code: "KBV", name: "Krabi - Krabi Airport" },
{ code: "SGZ", name: " - Songkhla Airport" },
{ code: "PAN", name: " - Pattani Airport" },
{ code: "USM", name: "Na Thon (Ko Samui Island) - Samui Airport" },
{ code: "HKT", name: "Phuket - Phuket International Airport" },
{ code: "UNN", name: "Ranong - Ranong Airport" },
{ code: "HDY", name: "Hat Yai - Hat Yai International Airport" },
{ code: "TST", name: "Trang - Trang Airport" },
{ code: "UTH", name: "Udon Thani - Udon Thani Airport" },
{ code: "SNO", name: " - Sakon Nakhon Airport" },
{ code: "PXR", name: "Surin - Surin Airport" },
{ code: "KKC", name: "Khon Kaen - Khon Kaen Airport" },
{ code: "LOE", name: " - Loei Airport" },
{ code: "BFV", name: "Buriram - Buri Ram Airport" },
{ code: "NAK", name: "Chaloem Phra Kiat - Nakhon Ratchasima Airport" },
{ code: "UBP", name: "Ubon Ratchathani - Ubon Ratchathani Airport" },
{ code: "ROI", name: "Roi Et - Roi Et Airport" },
{ code: "KOP", name: "Nakhon Phanom - Nakhon Phanom Airport" },
{ code: "BMV", name: "Buon Ma Thuot - Buon Ma Thuot Airport" },
{ code: "HPH", name: "Haiphong (Hai An) - Cat Bi International Airport" },
{ code: "CAH", name: "Ca Mau City - CÃ  Mau Airport" },
{ code: "CXR", name: "Cam Ranh - Cam Ranh International Airport / Cam Ranh Air Base" },
{ code: "VCS", name: "Con Dao - Con Dao Airport" },
{ code: "VCA", name: "Can Tho - Can Tho International Airport" },
{ code: "DIN", name: "Dien Bien Phu - Dien Bien Phu Airport" },
{ code: "VDH", name: "Dong Hoi - Dong Hoi Airport" },
{ code: "DLI", name: "Da Lat - Lien Khuong Airport" },
{ code: "DAD", name: "Da Nang - Da Nang International Airport" },
{ code: "HAN", name: "Hanoi (Soc Son) - Noi Bai International Airport" },
{ code: "HUI", name: "Huáº¿ - Phu Bai International Airport" },
{ code: "UIH", name: "Quy Nohn - Phu Cat Airport" },
{ code: "PXU", name: "Pleiku - Pleiku Airport" },
{ code: "PQC", name: "Phu Quoc Island - Phu Quoc International Airport" },
{ code: "VKG", name: "Rach Gia - Rach Gia Airport" },
{ code: "TBB", name: "Tuy Hoa - Dong Tac Airport" },
{ code: "SGN", name: "Ho Chi Minh City - Tan Son Nhat International Airport" },
{ code: "VDO", name: "Van Don - Van Don International Airport" },
{ code: "VII", name: "Vinh - Vinh Airport" },
{ code: "TVY", name: "Dawei - Dawei Airport" },
{ code: "KET", name: "Kengtung - Kengtung Airport" },
{ code: "KYP", name: "Kyaukpyu - Kyaukpyu Airport" },
{ code: "KAW", name: "Kawthoung - Kawthoung Airport" },
{ code: "LIW", name: "Loikaw - Loikaw Airport" },
{ code: "LSH", name: "Lashio - Lashio Airport" },
{ code: "MDL", name: "Mandalay - Mandalay International Airport" },
{ code: "MGZ", name: "Mkeik - Myeik Airport" },
{ code: "MYT", name: "Myitkyina - Myitkyina Airport" },
{ code: "MOE", name: " - Momeik Airport" },
{ code: "MOG", name: "Mong Hsat - Mong Hsat Airport" },
{ code: "NMS", name: "Namsang - Namsang Airport" },
{ code: "NYT", name: "Pyinmana - Nay Pyi Taw International Airport" },
{ code: "PBU", name: "Putao - Putao Airport" },
{ code: "AKY", name: "Sittwe - Sittwe Airport" },
{ code: "SNW", name: "Thandwe - Thandwe Airport" },
{ code: "THL", name: "Tachileik - Tachileik Airport" },
{ code: "RGN", name: "Yangon - Yangon International Airport" },
{ code: "UPG", name: "Ujung Pandang - Hasanuddin International Airport" },
{ code: "BIK", name: "Biak - Frans Kaisiepo Airport" },
{ code: "NBX", name: "Nabire - Douw Aturure Airport" },
{ code: "ZRI", name: "Serui - Stevanus Rumbewas Airport" },
{ code: "TIM", name: "Timika - Mozes Kilangin Airport" },
{ code: "DPS", name: "Kuta, Badung - Denpasar I Gusti Ngurah Rai International Airport" },
{ code: "LOP", name: "Mataram (Pujut, Lombok Tengah) - Lombok International Airport" },
{ code: "TTE", name: "Sango - Sultan Babullah Airport" },
{ code: "OTI", name: "Gotalalamo-Morotai Island - Pitu Airport" },
{ code: "TRT", name: "Toraja - Toraja Airport" },
{ code: "PLW", name: "Palu - Mutiara - SIS Al-Jufrie Airport" },
{ code: "PSJ", name: "Poso-Celebes Island - Kasiguncu Airport" },
{ code: "LUW", name: "Luwok - Syukuran Aminuddin Amir Airport" },
{ code: "PKY", name: "Palangkaraya - Tjilik Riwut Airport" },
{ code: "YIA", name: "Yogyakarta - Yogyakarta International Airport" },
{ code: "CXP", name: "Cilacap - Tunggul Wulung Airport" },
{ code: "DJJ", name: "Sentani - Dortheys Hiyo Eluay International Airport" },
{ code: "OKL", name: "Oksibil - Oksibil Airport" },
{ code: "MKQ", name: "Merauke - Mopah International Airport" },
{ code: "TMH", name: "Tanah Merah - Tanah Merah Airport" },
{ code: "BPN", name: "Balikpapan - Sultan Aji Muhammad Sulaiman Sepinggan International Airport" },
{ code: "TRK", name: "Tarakan - Juwata International Airport / Suharnoko Harbani AFB" },
{ code: "AAP", name: "Samarinda - Aji Pangeran Tumenggung Pranoto International Airport" },
{ code: "NAH", name: "Tabukan Utara, Sangihe Islands - Naha Airport" },
{ code: "MDC", name: "Manado - Sam Ratulangi Airport" },
{ code: "TJG", name: "Tanta-Tabalong - Warukin Airport" },
{ code: "BDJ", name: "Landasan Ulin - Syamsudin Noor International Airport" },
{ code: "LUV", name: "Langgur - Karel Sadsuitubun Airport" },
{ code: "NAM", name: "Namniwel - Namniwel Airport" },
{ code: "AMQ", name: "Ambon - Pattimura International Airport" },
{ code: "BEJ", name: "Tanjung Redeb - Borneo Island - Kalimarau Airport" },
{ code: "MLG", name: "Malang - Abdul Rachman Saleh Airport" },
{ code: "JOG", name: "Yogyakarta - Adisutjipto Airport" },
{ code: "SOC", name: "Surakarta - Adisumarmo Airport" },
{ code: "SUB", name: "Surabaya - Juanda International Airport" },
{ code: "SRG", name: "Semarang - Achmad Yani Airport" },
{ code: "FKQ", name: "Fakfak - Fakfak Airport" },
{ code: "KNG", name: "Kaimana - Kaimana Airport" },
{ code: "BXB", name: "Babo - Babo Airport" },
{ code: "MKW", name: "Manokwari - Rendani Airport" },
{ code: "SOQ", name: "Sorong - Domine Eduard Osok Airport" },
{ code: "WMX", name: "Wamena - Wamena Airport" },
{ code: "WNI", name: "Wangi-wangi Island - Matahora Airport" },
{ code: "KXB", name: "Kolaka - Sangia Nibandera Airport" },
{ code: "BTU", name: "Bintulu - Bintulu Airport" },
{ code: "KCH", name: "Kuching - Kuching International Airport" },
{ code: "LMN", name: "Limbang - Limbang Airport" },
{ code: "MKM", name: "Mukah - Mukah Airport" },
{ code: "MUR", name: "Marudi - Marudi Airport" },
{ code: "MYY", name: "Miri - Miri Airport" },
{ code: "SBW", name: "Sibu - Sibu Airport" },
{ code: "BBN", name: "Bario - Bario Airport" },
{ code: "LDU", name: "Lahad Datu - Lahad Datu Airport" },
{ code: "BKI", name: "Kota Kinabalu - Kota Kinabalu International Airport" },
{ code: "LBU", name: "Labuan - Labuan Airport" },
{ code: "SDK", name: "Sandakan - Sandakan Airport" },
{ code: "TWU", name: "Tawau - Tawau Airport" },
{ code: "MZV", name: "Mulu - Mulu Airport" },
{ code: "BWN", name: "Bandar Seri Begawan - Brunei International Airport" },
{ code: "PKU", name: "Pekanbaru - Sultan Syarif Kasim II International Airport / Roesmin Nurjadin AFB" },
{ code: "DUM", name: "Dumai - Pinang Kampai Airport" },
{ code: "RGT", name: "Rengat-Sumatra Island - Japura Airport" },
{ code: "KJT", name: "Kertajati - Kertajati International Airport" },
{ code: "BDO", name: "Bandung - Husein Sastranegara International Airport" },
{ code: "BTH", name: "Batam - Hang Nadim International Airport" },
{ code: "HLP", name: "Jakarta - Halim Perdanakusuma International Airport" },
{ code: "CGK", name: "Jakarta - Soekarno-Hatta International Airport" },
{ code: "TKG", name: "Bandar Lampung - Radin Inten II International Airport" },
{ code: "GNS", name: "Gunungsitoli - Binaka Airport" },
{ code: "AEG", name: "Padang Sidempuan - Aek Godang Airport" },
{ code: "MES", name: "Medan - Soewondo Air Force Base" },
{ code: "KNO", name: "Beringin - Kualanamu International Airport" },
{ code: "FLZ", name: "Sibolga (Pinangsori) - Dr. Ferdinand Lumban Tobing Airport" },
{ code: "LSR", name: "Kutacane - Alas Leuser Airport" },
{ code: "NPO", name: "Nanga Pinoh-Borneo Island - Nanga Pinoh Airport" },
{ code: "KTG", name: "Ketapang - Rahadi Osman Airport" },
{ code: "NTX", name: "Ranai-Natuna Besar Island - Ranai Airport" },
{ code: "PNK", name: "Pontianak - Supadio Airport" },
{ code: "PSU", name: "Putussibau-Borneo Island - Pangsuma Airport" },
{ code: "SQG", name: "Sintang - Tebelian Airport" },
{ code: "PGK", name: "Pangkal Pinang - Depati Amir Airport" },
{ code: "BKS", name: "Bengkulu - Fatmawati Soekarno Airport" },
{ code: "PLM", name: "Palembang - Sultan Mahmud Badaruddin II Airport" },
{ code: "PDO", name: "Talang Gudang-Sumatra Island - Pendopo Airport" },
{ code: "PDG", name: "Padang (Katapiang) - Minangkabau International Airport" },
{ code: "MEQ", name: "Kuala Pesisir - Cut Nyak Dhien Airport" },
{ code: "TXE", name: "Takengon - Rembele Airport" },
{ code: "LSX", name: "Lhok Sukon-Sumatra Island - Lhok Sukon Airport" },
{ code: "BTJ", name: "Banda Aceh - Sultan Iskandar Muda International Airport" },
{ code: "TOD", name: "Tioman Island - Tioman Airport" },
{ code: "AOR", name: "Alor Satar - Sultan Abdul Halim Airport" },
{ code: "BWH", name: "Butterworth - RMAF Butterworth Air Base" },
{ code: "KBR", name: "Kota Baharu - Sultan Ismail Petra Airport" },
{ code: "KUA", name: "Kuantan - Kuantan Airport" },
{ code: "KTE", name: "Kerteh - Kerteh Airport" },
{ code: "IPH", name: "Ipoh - Sultan Azlan Shah Airport" },
{ code: "JHB", name: "Johor Bahru - Senai International Airport" },
{ code: "KUL", name: "Sepang - Kuala Lumpur International Airport" },
{ code: "LGK", name: "Langkawi - Langkawi International Airport" },
{ code: "MKZ", name: "Malacca - Malacca International Airport" },
{ code: "TGG", name: "Kuala Terengganu - Sultan Mahmud Airport" },
{ code: "PEN", name: "Penang - Penang International Airport" },
{ code: "SZB", name: "Subang - Sultan Abdul Aziz Shah International Airport" },
{ code: "UAI", name: "Suai - Suai Airport" },
{ code: "DIL", name: "Dili - Presidente Nicolau Lobato International Airport" },
{ code: "BCH", name: "Baucau - Cakung Airport" },
{ code: "OEC", name: "Oecussi-Ambeno - Rota Do SÃ¢ndalo Oecusse Airport" },
{ code: "QPG", name: "Paya Lebar - Paya Lebar Air Base" },
{ code: "TGA", name: "Western Water Catchment - Tengah Air Base" },
{ code: "XSP", name: "Seletar - Seletar Airport" },
{ code: "SIN", name: "Singapore - Singapore Changi Airport" },
{ code: "ALH", name: "Albany - Albany Airport" },
{ code: "ARY", name: "Ararat - Ararat Airport" },
{ code: "ARM", name: "Armidale - Armidale Airport" },
{ code: "AYQ", name: "Yulara - Ayers Rock Connellan Airport" },
{ code: "BCI", name: "Barcaldine - Barcaldine Airport" },
{ code: "ASP", name: "Alice Springs - Alice Springs Airport" },
{ code: "BNE", name: "Brisbane - Brisbane International Airport" },
{ code: "OOL", name: "Gold Coast - Gold Coast Airport" },
{ code: "BKQ", name: "Blackall - Blackall Airport" },
{ code: "CNS", name: "Cairns - Cairns International Airport" },
{ code: "CTL", name: "Charleville - Charleville Airport" },
{ code: "BVI", name: " - Birdsville Airport" },
{ code: "BHQ", name: "Broken Hill - Broken Hill Airport" },
{ code: "HTI", name: "Hamilton Island - Hamilton Island Airport" },
{ code: "BEU", name: "Bedourie - Bedourie Airport" },
{ code: "BRK", name: " - Bourke Airport" },
{ code: "BLN", name: "Benalla - Benalla Airport" },
{ code: "ISA", name: "Mount Isa - Mount Isa Airport" },
{ code: "MKY", name: "Mackay - Mackay Airport" },
{ code: "BNK", name: "Ballina - Ballina Byron Gateway Airport" },
{ code: "BSJ", name: "Bairnsdale - Bairnsdale Airport" },
{ code: "OKY", name: " - Oakey Army Aviation Centre" },
{ code: "BQL", name: " - Boulia Airport" },
{ code: "PPP", name: "Proserpine - Proserpine Whitsunday Coast Airport" },
{ code: "ROK", name: "Rockhampton - Rockhampton Airport" },
{ code: "BME", name: "Broome - Broome International Airport" },
{ code: "BZD", name: " - Balranald Airport" },
{ code: "BWQ", name: " - Brewarrina Airport" },
{ code: "MCY", name: "Maroochydore - Sunshine Coast Airport" },
{ code: "BHS", name: "Bathurst - Bathurst Airport" },
{ code: "BRT", name: "Wurrumiyanga - Bathurst Island Airport" },
{ code: "TSV", name: "Townsville - Townsville Airport / RAAF Base Townsville" },
{ code: "BLT", name: " - Blackwater Airport" },
{ code: "BDB", name: "Bundaberg - Bundaberg Airport" },
{ code: "WEI", name: "Weipa - Weipa Airport" },
{ code: "WTB", name: "Toowoomba - Toowoomba Wellcamp Airport" },
{ code: "CVQ", name: "Carnarvon - Carnarvon Airport" },
{ code: "CAZ", name: " - Cobar Airport" },
{ code: "COJ", name: " - Coonabarabran Airport" },
{ code: "CPD", name: "Coober Pedy - Coober Pedy Airport" },
{ code: "CCL", name: "Chinchilla - Chinchilla Airport" },
{ code: "CNJ", name: "Cloncurry - Cloncurry Airport" },
{ code: "CED", name: " - Ceduna Airport" },
{ code: "CVC", name: " - Cleve Airport" },
{ code: "CFS", name: "Coffs Harbour - Coffs Harbour Airport" },
{ code: "DCN", name: "Derby - RAAF Base Curtin" },
{ code: "CTN", name: " - Cooktown Airport" },
{ code: "CMQ", name: " - Clermont Airport" },
{ code: "CMA", name: " - Cunnamulla Airport" },
{ code: "CNB", name: " - Coonamble Airport" },
{ code: "CUQ", name: "Coen - Coen Airport" },
{ code: "OOM", name: "Cooma - Cooma Snowy Mountains Airport" },
{ code: "CWW", name: " - Corowa Airport" },
{ code: "CYG", name: " - Corryong Airport" },
{ code: "CMD", name: " - Cootamundra Airport" },
{ code: "CWT", name: " - Cowra Airport" },
{ code: "DRN", name: " - Dirranbandi Airport" },
{ code: "DRB", name: "Derby - Derby Airport" },
{ code: "DNQ", name: "Deniliquin - Deniliquin Airport" },
{ code: "DPO", name: "Devonport - Devonport Airport" },
{ code: "DYA", name: " - Dysart Airport" },
{ code: "ECH", name: " - Echuca Airport" },
{ code: "ELC", name: "Elcho Island - Elcho Island Airport" },
{ code: "EMD", name: "Emerald - Emerald Airport" },
{ code: "EPR", name: "Esperance - Esperance Airport" },
{ code: "WHB", name: " - Eliwana" },
{ code: "FRB", name: "Forbes - Forbes Airport" },
{ code: "FOS", name: " - Forrest Airport" },
{ code: "FIZ", name: " - Fitzroy Crossing Airport" },
{ code: "GUH", name: " - Gunnedah Airport" },
{ code: "GET", name: "Moonyoonooka - Geraldton Airport" },
{ code: "GFN", name: "Grafton - Clarence Valley Regional Airport" },
{ code: "GLT", name: "Gladstone - Gladstone Airport" },
{ code: "GUL", name: " - Goulburn Airport" },
{ code: "GLI", name: "Glen Innes - Glen Innes Airport" },
{ code: "GPN", name: "Pirlangimpi - Garden Point Airport" },
{ code: "GTE", name: "Groote Eylandt - Groote Eylandt Airport" },
{ code: "GFF", name: "Griffith - Griffith Airport" },
{ code: "HXX", name: " - Hay Airport" },
{ code: "HVB", name: "Hervey Bay - Hervey Bay Airport" },
{ code: "HID", name: "Horn - Horn Island Airport" },
{ code: "HCQ", name: " - Halls Creek Airport" },
{ code: "HLT", name: " - Hamilton Airport" },
{ code: "MHU", name: "Mount Hotham - Mount Hotham Airport" },
{ code: "HTU", name: " - Hopetoun Airport" },
{ code: "HSM", name: " - Horsham Airport" },
{ code: "IVR", name: "Inverell - Inverell Airport" },
{ code: "KRA", name: " - Kerang Airport" },
{ code: "KNS", name: " - King Island Airport" },
{ code: "KPS", name: " - Kempsey Airport" },
{ code: "KWM", name: "Kowanyama - Kowanyama Airport" },
{ code: "KGY", name: " - Kingaroy Airport" },
{ code: "KGC", name: " - Kingscote Airport" },
{ code: "LGH", name: " - Leigh Creek Airport" },
{ code: "LNO", name: "Leonora - Leonora Airport" },
{ code: "IRG", name: "Lockhart River - Lockhart River Airport" },
{ code: "LSY", name: "Lismore - Lismore Airport" },
{ code: "LHG", name: " - Lightning Ridge Airport" },
{ code: "LRE", name: "Longreach - Longreach Airport" },
{ code: "LER", name: " - Leinster Airport" },
{ code: "TGN", name: "Morwell - Latrobe Valley Airport" },
{ code: "AVV", name: "Lara - Avalon Airport" },
{ code: "ABX", name: "East Albury - Albury Airport" },
{ code: "MRG", name: "Mareeba - Mareeba Airport" },
{ code: "DGE", name: "Mudgee - Mudgee Airport" },
{ code: "MKR", name: " - Meekatharra Airport" },
{ code: "MEB", name: "Essendon Fields - Melbourne Essendon Airport" },
{ code: "MIM", name: "Merimbula - Merimbula Airport" },
{ code: "MNG", name: "Maningrida - Maningrida Airport" },
{ code: "HBA", name: "Hobart (Cambridge) - Hobart International Airport" },
{ code: "MQL", name: "Mildura - Mildura Airport" },
{ code: "LST", name: "Launceston (Western Junction) - Launceston Airport" },
{ code: "MBW", name: "Melbourne - Melbourne Moorabbin Airport" },
{ code: "MEL", name: "Melbourne - Melbourne Airport" },
{ code: "WME", name: " - Mount Keith Airport" },
{ code: "MMG", name: " - Mount Magnet Airport" },
{ code: "MRZ", name: "Moree - Moree Airport" },
{ code: "MOV", name: "Moranbah - Moranbah Airport" },
{ code: "MYA", name: "Moruya - Moruya Airport" },
{ code: "MGB", name: "Mount Gambier - Mount Gambier Airport" },
{ code: "NRA", name: "Narrandera - Narrandera Airport" },
{ code: "NAA", name: "Narrabri - Narrabri Airport" },
{ code: "RPM", name: " - Ngukurr Airport" },
{ code: "QRM", name: " - Narromine Airport" },
{ code: "NTN", name: "Normanton - Normanton Airport" },
{ code: "ZNE", name: "Newman - Newman Airport" },
{ code: "OAG", name: "Orange - Orange Airport" },
{ code: "ADL", name: "Adelaide - Adelaide International Airport" },
{ code: "PUG", name: " - Port Augusta Airport" },
{ code: "PBO", name: "Paraburdoo - Paraburdoo Airport" },
{ code: "CCK", name: "West Island - Cocos (Keeling) Islands Airport" },
{ code: "DRW", name: "Darwin - Darwin International Airport / RAAF Darwin" },
{ code: "GOV", name: "Nhulunbuy - Gove Airport" },
{ code: "PPI", name: " - Port Pirie Airport" },
{ code: "JAD", name: "Perth - Perth Jandakot Airport" },
{ code: "KTA", name: "Karratha - Karratha Airport" },
{ code: "KGI", name: "Broadwood - Kalgoorlie Boulder Airport" },
{ code: "PKE", name: "Parkes - Parkes Airport" },
{ code: "PKT", name: "Wadeye - Port Keats Airport" },
{ code: "KNX", name: "Kununurra - East Kimberley Regional (Kununurra) Airport" },
{ code: "PLO", name: "Port Lincoln - Port Lincoln Airport" },
{ code: "LEA", name: "Exmouth - Learmonth Airport" },
{ code: "PQQ", name: "Port Macquarie - Port Macquarie Airport" },
{ code: "PTJ", name: " - Portland Airport" },
{ code: "PHE", name: "Port Hedland - Port Hedland International Airport" },
{ code: "PER", name: "Perth - Perth International Airport" },
{ code: "KTR", name: " - Tindal Airport" },
{ code: "XCH", name: "Flying Fish Cove - Christmas Island Airport" },
{ code: "ULP", name: " - Quilpie Airport" },
{ code: "RMK", name: " - Renmark Airport" },
{ code: "RMA", name: "Roma - Roma Airport" },
{ code: "BWU", name: "Sydney - Sydney Bankstown Airport" },
{ code: "CBR", name: "Canberra - Canberra Airport" },
{ code: "CDU", name: "Cobbitty - Camden Airport" },
{ code: "DBO", name: "Dubbo - Dubbo City Regional Airport" },
{ code: "MJK", name: "Denham - Shark Bay Airport" },
{ code: "WOL", name: "Albion Park Rail - Shellharbour Airport" },
{ code: "SHT", name: " - Shepparton Airport" },
{ code: "SIO", name: " - Smithton Airport" },
{ code: "SNB", name: "Milikapiti - Snake Bay Airport" },
{ code: "NLK", name: "Burnt Pine - Norfolk Island International Airport" },
{ code: "NOA", name: "Nowra Hill - Naval Air Station Nowra - HMAS Albatross" },
{ code: "XRH", name: "Richmond - RAAF Base Richmond" },
{ code: "SYD", name: "Sydney (Mascot) - Sydney Kingsford Smith International Airport" },
{ code: "TMW", name: "Tamworth - Tamworth Airport" },
{ code: "WGA", name: "Forest Hill - Wagga Wagga Airport" },
{ code: "SWH", name: " - Swan Hill Airport" },
{ code: "SWC", name: " - Stawell Airport" },
{ code: "TEF", name: " - Telfer Airport" },
{ code: "TEM", name: "Temora - Temora Airport" },
{ code: "XTG", name: "Thargomindah - Thargomindah Airport" },
{ code: "TYB", name: " - Tibooburra Airport" },
{ code: "TUM", name: "Tumut - Tumut Aerodrome" },
{ code: "THG", name: "Biloela - Thangool Airport" },
{ code: "TCA", name: "Tennant Creek - Tennant Creek Airport" },
{ code: "TRO", name: "Taree - Taree Airport" },
{ code: "WNR", name: "Windorah - Windorah Airport" },
{ code: "WGT", name: "Laceby - Wangaratta Airport" },
{ code: "WYA", name: "Whyalla - Whyalla Airport" },
{ code: "WKB", name: " - Warracknabeal Airport" },
{ code: "WGE", name: " - Walgett Airport" },
{ code: "NTL", name: "Williamtown - Newcastle Airport" },
{ code: "WUN", name: " - Wiluna Airport" },
{ code: "SXE", name: "Sale - West Sale Airport" },
{ code: "WIN", name: " - Winton Airport" },
{ code: "WWY", name: "West Wyalong - West Wyalong Airport" },
{ code: "BWT", name: "Burnie - Wynyard Airport" },
{ code: "NGA", name: " - Young Airport" },
{ code: "PEK", name: "Beijing - Beijing Capital International Airport" },
{ code: "PKX", name: "Beijing - Beijing Daxing International Airport" },
{ code: "CDE", name: "Chengde - Chengde Puning Airport" },
{ code: "CIF", name: "Chifeng - Chifeng Yulong Airport" },
{ code: "BPE", name: "Qinhuangdao (Changli) - Qinhuangdao Beidaihe Airport" },
{ code: "DSN", name: "Ordos - Ordos Ejin Horo Airport" },
{ code: "ERL", name: "Erenhot - Erenhot Saiwusu International Airport" },
{ code: "YIE", name: "Arxan - Arxan Yi'ershi Airport" },
{ code: "HDG", name: "Handan - Handan Airport" },
{ code: "HET", name: "Hohhot - Hohhot Baita International Airport" },
{ code: "HUO", name: "Holingol - Holingol Huolinhe Airport" },
{ code: "HLD", name: "Hailar - Hulunbuir Hailar Airport" },
{ code: "LFQ", name: "Linfen (Yaodu) - Linfen Yaodu Airport" },
{ code: "LLV", name: "LÃ¼liang - LÃ¼liang Dawu Airport" },
{ code: "NZH", name: "Manzhouli - Manzhouli Xijiao Airport" },
{ code: "BAV", name: "Baotou - Baotou Donghe Airport" },
{ code: "SJW", name: "Shijiazhuang - Shijiazhuang Zhengding International Airport" },
{ code: "TSN", name: "Tianjin - Tianjin Binhai International Airport" },
{ code: "TGO", name: "Tongliao - Tongliao Airport" },
{ code: "UCB", name: "Ulanqab - Ulanqab Jining Airport" },
{ code: "XIL", name: "Xilinhot - Xilinhot Airport" },
{ code: "YCU", name: "Yuncheng (Yanhu) - Yuncheng Zhangxiao Airport" },
{ code: "TYN", name: "Taiyuan - Taiyuan Wusu International Airport" },
{ code: "RLK", name: "Bavannur - Bayannur Tianjitai Airport" },
{ code: "ZQZ", name: "Zhangjiakou - Zhangjiakou Ningyuan Airport" },
{ code: "NZL", name: "Zhalantun - Zhalantun Genghis Khan Airport" },
{ code: "BHY", name: "Beihai (Yinhai) - Beihai Fucheng Airport" },
{ code: "AEB", name: "Baise (Tianyang) - Baise (Bose) Bama Airport" },
{ code: "CGD", name: "Changde (Dingcheng) - Changde Taohuayuan Airport" },
{ code: "HJJ", name: "Huaihua - Huaihua Zhijiang Airport" },
{ code: "HCZ", name: "Chenzhou - Chenzhou Beihu Airport" },
{ code: "FUO", name: "Foshan (Nanhai) - Foshan Shadi Airport" },
{ code: "CAN", name: "Guangzhou (Huadu) - Guangzhou Baiyun International Airport" },
{ code: "CSX", name: "Changsha (Changsha) - Changsha Huanghua International Airport" },
{ code: "HCJ", name: "Hechi (Jinchengjiang) - Hechi Jinchengjiang Airport" },
{ code: "HUZ", name: "Huizhou (Pingtan) - Huizhou Pingtan Airport" },
{ code: "KWL", name: "Guilin (Lingui) - Guilin Liangjiang International Airport" },
{ code: "LLF", name: "Yongzhou - Yongzhou Lingling Airport" },
{ code: "NNG", name: "Nanning (Jiangnan) - Nanning Wuxu Airport" },
{ code: "SWA", name: "Jieyang (Rongcheng) - Jieyang Chaoshan International Airport" },
{ code: "ZUH", name: "Zhuhai (Jinwan) - Zhuhai Jinwan Airport" },
{ code: "WGN", name: "Shaoyang (Wugang) - Shaoyang Wugang Airport" },
{ code: "SZX", name: "Shenzhen (Bao'an) - Shenzhen Bao'an International Airport" },
{ code: "WUZ", name: "Tangbu - Wuzhou Xijiang Airport" },
{ code: "YLX", name: "YÃ¹lÃ­n - Yulin Fumian Airport" },
{ code: "YYA", name: "Yueyang (Yueyanglou) - Yueyang Sanhe Airport" },
{ code: "LZH", name: "Liuzhou (Liujiang) - Liuzhou Bailian Airport / Bailian Air Base" },
{ code: "ZHA", name: "Zhanjiang - Zhanjiang Wuchuan Airport" },
{ code: "CGO", name: "Zhengzhou - Zhengzhou Xinzheng International Airport" },
{ code: "EHU", name: "Ezhou - Ezhou Huahu Airport" },
{ code: "ENH", name: "Enshi (Enshi) - Enshi Xujiaping Airport" },
{ code: "LHK", name: "Xiangyang (Laohekou) - Guangzhou MR Air Base / Guanghua Airport" },
{ code: "WUH", name: "Wuhan (Huangpi) - Wuhan Tianhe International Airport" },
{ code: "SHS", name: "Jingzhou (Shashi) - Jingzhou Shashi Airport" },
{ code: "LYA", name: "Luoyang (Laocheng) - Luoyang Beijiao Airport" },
{ code: "HPG", name: "Shennongjia (Hongping) - Shennongjia Hongping Airport" },
{ code: "WDS", name: "Shiyan (Maojian) - Shiyan Wudangshan Airport" },
{ code: "XFN", name: "Xiangyang (Xiangzhou) - Xiangyang Liuji Airport" },
{ code: "XAI", name: "Xinyang - Xinyang Minggang Airport" },
{ code: "YIH", name: "Yichang (Xiaoting) - Yichang Sanxia Airport" },
{ code: "HAK", name: "Haikou (Meilan) - Haikou Meilan International Airport" },
{ code: "BAR", name: "Qionghai (Basuo) - Qionghai Bo'ao Airport" },
{ code: "SYX", name: "Sanya (Tianya) - Sanya Phoenix International Airport" },
{ code: "RGO", name: "Hoemun-ri - Orang (Chongjin) Airport" },
{ code: "FNJ", name: "Pyongyang - Pyongyang Sunan International Airport" },
{ code: "DSO", name: "SÅndÅng-ni - Sondok Airport" },
{ code: "WOS", name: "Wonsan - Wonsan Kalma International Airport" },
{ code: "DNH", name: "Dunhuang - Dunhuang Mogao International Airport" },
{ code: "GMQ", name: "Golog (MaqÃªn) - Golog MaqÃªn Airport" },
{ code: "GOQ", name: "Golmud - Golmud Airport" },
{ code: "GYU", name: "Guyuan (Yuanzhou) - Guyuan Liupanshan Airport" },
{ code: "HTT", name: "Mengnai - Huatugou Airport" },
{ code: "INC", name: "Yinchuan - Yinchuan Hedong International Airport" },
{ code: "LHW", name: "Lanzhou (Yongdeng) - Lanzhou Zhongchuan International Airport" },
{ code: "LNL", name: "Longnan (Cheng) - Longnan Chengzhou Airport" },
{ code: "IQN", name: "Qingyang (Xifeng) - Qingyang Xifeng Airport" },
{ code: "SIA", name: "Xi'an (Baqiao) - Xi'an Xiguan Airport" },
{ code: "THQ", name: "Tianshui (Maiji) - Tianshui Maijishan Airport" },
{ code: "GXH", name: "Gannan (Xiahe) - Gannan Xiahe Airport" },
{ code: "XNN", name: "Haidong (Huzhu Tu Autonomous County) - Xining Caojiabao International Airport" },
{ code: "XIY", name: "Xianyang (Weicheng) - Xi'an Xianyang International Airport" },
{ code: "ENY", name: "Yan'an (Baota) - Yan'an Nanniwan Airport" },
{ code: "YUS", name: "Yushu (Batang) - Yushu Batang Airport" },
{ code: "ZHY", name: "Zhongwei (Shapotou) - Zhongwei Shapotou Airport" },
{ code: "UMB", name: "Kalumbila - Kalumbila Airport" },
{ code: "AVK", name: "Arvaikheer - Arvaikheer Airport" },
{ code: "LTI", name: "Altai - Altai Airport" },
{ code: "BYN", name: "Bayankhongor - Bayankhongor Airport" },
{ code: "UGA", name: "Bulgan - Bulgan Airport" },
{ code: "UUN", name: " - Baruun Urt Airport" },
{ code: "COQ", name: " - Choibalsan Airport" },
{ code: "UBN", name: "Ulaanbaatar (Sergelen) - Ulaanbaatar Chinggis Khaan International Airport" },
{ code: "DLZ", name: "Dalanzadgad - Dalanzadgad Airport" },
{ code: "HVD", name: "Khovd - Khovd Airport" },
{ code: "MXV", name: "MÃ¶rÃ¶n - MÃ¶rÃ¶n Airport" },
{ code: "ULN", name: "Ulaanbaatar - Buyant-Ukhaa International Airport" },
{ code: "BSD", name: "Baoshan (Longyang) - Baoshan Yunrui Airport" },
{ code: "CWJ", name: "Lincang (Cangyuan) - Cangyuan Washan Airport" },
{ code: "DLU", name: "Dali (Xiaguan) - Dali Fengyi Airport" },
{ code: "DIG", name: "Diqing (Shangri-La) - Diqing Shangri-La Airport" },
{ code: "JHG", name: "Jinghong (Gasa) - Xishuangbanna Gasa International Airport" },
{ code: "JMJ", name: "Pu'er (Lancang) - Lancang Jingmai Airport" },
{ code: "LNJ", name: "Lincang - Lincang Boshang Airport" },
{ code: "LJG", name: "Lijiang (Gucheng) - Lijiang Sanyi International Airport" },
{ code: "LUM", name: "Dehong (Mangshi) - Dehong Mangshi Airport" },
{ code: "KMG", name: "Kunming - Kunming Changshui International Airport" },
{ code: "YUA", name: "Chuxiong (Yuanmou) - Yuanmou Air Base" },
{ code: "XMN", name: "Xiamen - Xiamen Gaoqi International Airport" },
{ code: "AQG", name: "Anqing - Anqing Tianzhushan Airport / Anqing North Air Base" },
{ code: "BFU", name: "Bengbu - Bengbu Tenghu Airport" },
{ code: "CZX", name: "Changzhou - Changzhou Benniu International Airport" },
{ code: "KHN", name: "Nanchang - Nanchang Changbei International Airport" },
{ code: "DOY", name: "Dongying (Kenli) - Dongying Shengli Airport" },
{ code: "FUG", name: "Yingzhou, Fuyang - Fuyang Xiguan Airport" },
{ code: "FOC", name: "Fuzhou (Changle) - Fuzhou Changle International Airport" },
{ code: "HGH", name: "Hangzhou - Hangzhou Xiaoshan International Airport" },
{ code: "HZA", name: "Heze (Dingtao) - Heze Mudan Airport" },
{ code: "JDZ", name: "Jingdezhen - Jingdezhen Luojia Airport" },
{ code: "JNG", name: "Jining - Jining Da'an Airport" },
{ code: "TNA", name: "Jinan (Licheng) - Jinan Yaoqiang International Airport" },
{ code: "JUZ", name: "Quzhou (Kezheng) - Quzhou Airport" },
{ code: "LYG", name: "Lianyungang - Lianyungang Huaguoshan International Airport" },
{ code: "LCX", name: "Longyan (Liancheng) - Liancheng Guanzhishan Airport" },
{ code: "HYN", name: "Taizhou (Luqiao) - Taizhou Luqiao Airport" },
{ code: "LYI", name: "Linyi (Hedong) - Linyi Qiyang Airport" },
{ code: "NGB", name: "Ningbo - Ningbo Lishe International Airport" },
{ code: "NKG", name: "Nanjing - Nanjing Lukou International Airport" },
{ code: "NTG", name: "Nantong (Tongzhou) - Nantong Xingdong International Airport" },
{ code: "HFE", name: "Hefei - Hefei Xinqiao International Airport" },
{ code: "PVG", name: "Shanghai (Pudong) - Shanghai Pudong International Airport" },
{ code: "TAO", name: "Qingdao (Jiaozhou) - Qingdao Jiaodong International Airport" },
{ code: "JJN", name: "Quanzhou - Quanzhou Jinjiang International Airport" },
{ code: "RUG", name: "Rugao (Nantong) - Rugao Air Base" },
{ code: "RIZ", name: "Rizhao (Donggang) - Rizhao Shanzihe Airport" },
{ code: "HIA", name: "Huai'an - Huai'an Lianshui International Airport" },
{ code: "SQJ", name: "Sanming (Sha) - Sanming Shaxian Airport" },
{ code: "SQD", name: "Shangrao (Hengfeng) - Shangrao Sanqingshan Airport" },
{ code: "SHA", name: "Shanghai (Minhang) - Shanghai Hongqiao International Airport" },
{ code: "SZV", name: "Suzhou - Suzhou Guangfu Airport" },
{ code: "TXN", name: "Huangshan - Tunxi International Airport" },
{ code: "WHA", name: "Wuhu - Wuhu Xuanzhou Airport" },
{ code: "WEF", name: "Weifang (Kuiwen) - Weifang Nanyuan Airport" },
{ code: "WEH", name: "Weihai - Weihai Dashuibo Airport" },
{ code: "WUX", name: "Wuxi - Sunan Shuofang International Airport" },
{ code: "WUS", name: "Wuyishan - Nanping Wuyishan Airport" },
{ code: "WNZ", name: "Wenzhou (Longwan) - Wenzhou Longwan International Airport" },
{ code: "XUZ", name: "Xuzhou - Xuzhou Guanyin International Airport" },
{ code: "YTY", name: "Yangzhou - Yangzhou Taizhou Airport" },
{ code: "YIC", name: "Yichun - Yichun Mingyueshan Airport" },
{ code: "YNZ", name: "Yancheng (Tinghu) - Yancheng Nanyang International Airport" },
{ code: "YNT", name: "Yantai - Yantai Penglai International Airport" },
{ code: "YIW", name: "Jinhua (Yiwu) - Yiwu Airport" },
{ code: "HSN", name: "Zhoushan - Zhoushan Putuoshan Airport" },
{ code: "NGQ", name: "Shiquanhe - Ngari Gunsa Airport" },
{ code: "AVA", name: "Anshun (Xixiu) - Anshun Huangguoshu Airport" },
{ code: "BPX", name: "Bangda - Qamdo Bangda Airport" },
{ code: "BFJ", name: "Bijie - Bijie Feixiong Airport" },
{ code: "CKG", name: "Chongqing - Chongqing Jiangbei International Airport" },
{ code: "DZH", name: "Dazhou (Dachuan) - Dazhou Jinya Airport" },
{ code: "DCY", name: "GarzÃª (Daocheng) - Daocheng Yading Airport" },
{ code: "GYS", name: "Guangyuan (Lizhou) - Guangyuan Panlong Airport" },
{ code: "KWE", name: "Guiyang (Nanming) - Guiyang Longdongbao International Airport" },
{ code: "AHJ", name: "Ngawa (Hongyuan) - Hongyuan Airport" },
{ code: "JZH", name: "Ngawa (Songpan) - Jiuzhai Huanglong Airport" },
{ code: "KGT", name: "GarzÃª (Kangding) - Kangding Airport" },
{ code: "KJH", name: "Kaili  (Huangping) - Kaili Huangping Airport" },
{ code: "LXA", name: "Shannan (Gonggar) - Lhasa Gonggar Airport" },
{ code: "LZO", name: "Luzhou (Yunlong) - Luzhou Yunlong Airport" },
{ code: "WMT", name: "Zunyi - Zunyi Maotai Airport" },
{ code: "MIG", name: "Mianyang (Fucheng) - Mianyang Nanjiao Airport" },
{ code: "HZH", name: "Liping - Liping Airport" },
{ code: "LZY", name: "Nyingchi (Mainling) - Nyingchi Mainling Airport" },
{ code: "LPF", name: "Liupanshui (Zhongshan) - Liupanshui Yuezhao Airport" },
{ code: "JIQ", name: "Qianjiang - Qianjiang Wulingshan Airport" },
{ code: "RKZ", name: "XigazÃª (SamzhubzÃª) - Xigaze Peace Airport / Shigatse Air Base" },
{ code: "TCZ", name: "Baoshan (Tengchong) - Tengchong Tuofeng Airport" },
{ code: "TFU", name: "Chengdu (Jianyang) - Chengdu Tianfu International Airport" },
{ code: "TEN", name: "Tongren (Daxing) - Tongren Fenghuang Airport" },
{ code: "CTU", name: "Chengdu (Shuangliu) - Chengdu Shuangliu International Airport" },
{ code: "CQW", name: "Wulong - Chongqing XiannÃ¼shan Airport" },
{ code: "XIC", name: "Liangshan (Xichang) - Xichang Qingshan Airport" },
{ code: "YBP", name: "Yibin (Cuiping) - Yibin Wuliangye Airport" },
{ code: "ACX", name: "Xingyi - Xingyi Wanfenglin Airport" },
{ code: "PZI", name: "Panzhihua (Renhe) - Panzhihua Bao'anying Airport" },
{ code: "ZYI", name: "Zunyi - Zunyi Xinzhou Airport" },
{ code: "AKU", name: "Aksu (Onsu) - Aksu Hongqipo Airport" },
{ code: "AAT", name: "Altay - Altay Xuedu Airport" },
{ code: "BPL", name: "Bole - Bole Alashankou Airport" },
{ code: "IQM", name: "Qiemo - Qiemo Yudu Airport" },
{ code: "FYN", name: "Fuyun - Fuyun Koktokay Airport" },
{ code: "HMI", name: "Hami - Hami Airport" },
{ code: "KRL", name: "Korla - Korla Licheng Airport" },
{ code: "KJI", name: "Burqin - Burqin Kanas Airport" },
{ code: "NLT", name: "Xinyuan - Xinyuan Nalati Airport" },
{ code: "RQA", name: "Ruoqiang Town - Ruoqiang Loulan Airport" },
{ code: "QSZ", name: "Shache - Shache Airport" },
{ code: "KHG", name: "Kashgar - Kashgar Laining International Airport" },
{ code: "SXJ", name: "Shanshan - Shanshan Airport" },
{ code: "TLQ", name: "Turpan - Turpan Jiaohe Airport" },
{ code: "HTN", name: "Hotan - Hotan Airport" },
{ code: "URC", name: "ÃœrÃ¼mqi - ÃœrÃ¼mqi Tianshan International Airport" },
{ code: "AOG", name: "Anshan - Anshan Teng'ao Airport / Anshan Air Base" },
{ code: "DBC", name: "Baicheng - Baicheng Chang'an Airport" },
{ code: "NBS", name: "Baishan - Changbaishan Airport" },
{ code: "CGQ", name: "Changchun - Changchun Longjia International Airport" },
{ code: "CNI", name: "Dalian (Changhai) - Changhai Airport" },
{ code: "CHG", name: "Shuangta, Chaoyang - Chaoyang Airport" },
{ code: "DDG", name: "Dandong (Zhenxing) - Dandong Langtou Airport" },
{ code: "DTU", name: "Heihe - Wudalianchi Dedu Airport" },
{ code: "FYJ", name: "Fuyuan - Fuyuan Dongji Airport" },
{ code: "HRB", name: "Harbin - Harbin Taiping International Airport" },
{ code: "HEK", name: "Heihe - Heihe Aihui Airport" },
{ code: "JGD", name: "Jiagedaqi - Daxing'anling Elunchun Airport" },
{ code: "JMU", name: "Jiamusi - Jiamusi Dongjiao Airport" },
{ code: "JSJ", name: "Jiansanjiang - Jiansanjiang Shidi Airport" },
{ code: "JXA", name: "Jixi - Jixi Xingkaihu Airport" },
{ code: "JNZ", name: "Jinzhou (Linghai) - Jinzhou Bay Airport" },
{ code: "LDS", name: "Yichun - Yichun Lindu Airport" },
{ code: "MDG", name: "Mudanjiang - Mudanjiang Hailang International Airport" },
{ code: "OHE", name: "Mohe - Mohe Gulian Airport" },
{ code: "NDG", name: "Qiqihar - Qiqihar Sanjiazi Airport" },
{ code: "YSQ", name: "Qian Gorlos Mongol Autonomous County - Songyuan Chaganhu Airport" },
{ code: "DLC", name: "Dalian (Ganjingzi) - Dalian Zhoushuizi International Airport" },
{ code: "TNH", name: "Tonghua - Tonghua Sanyuanpu Airport" },
{ code: "SHE", name: "Hunnan, Shenyang - Shenyang Taoxian International Airport" },
{ code: "XEN", name: "Huludao (Xingcheng) - Xingcheng Air Base" },
{ code: "YNJ", name: "Yanji - Yanji Chaoyangchuan Airport" },
{ code: "YKH", name: "Yingkou (Laobian) - Yingkou Lanqi Airport" }
];

export default airports;


